export default {
  login: {
    signInWithMicrosoft: 'Mit Microsoft anmelden',
    singleSignOn: 'Single Sign-On',
    entraSigningIn: 'Mit Microsoft anmelden…',
    entraFailed: 'Microsoft-Anmeldung fehlgeschlagen',
    entraTimedOut: 'Microsoft-Anmeldung dauert zu lange — bitte erneut versuchen.',
    entraSlowHint: 'Es dauert länger als gewöhnlich…',
    pendingTitle: 'Zugang noch nicht freigeschaltet',
    pendingSimple: 'Ihrem Konto wurde noch keine EventHub-Rolle zugewiesen. Bitte wenden Sie sich an Ihren Administrator.',
    pendingDismiss: 'Zurück zur Anmeldung',
    resumeAs: 'Angemeldete Sitzung fortsetzen',
    continueWithMicrosoft: 'Mit Microsoft fortfahren',
    useDifferentAccount: 'Anderes Konto verwenden',
    signInDifferent: 'Mit anderem Konto anmelden',
    forgetThisDevice: 'Konto auf diesem Gerät vergessen',
    resetSession: 'Festgefahren? Sitzung zurücksetzen',
    resettingSession: 'Wird zurückgesetzt…',
    sessionExpired: 'Ihre Sitzung ist abgelaufen — bitte melden Sie sich erneut an.',
    sessionEnded: 'Ihre Sitzung wurde beendet — bitte melden Sie sich erneut an.',
    serverUnreachableTitle: 'Server nicht erreichbar',
    serverUnreachableBody: 'Ihre Anmeldung bleibt erhalten. Bitte Verbindung prüfen und erneut versuchen.',
    orEmailPassword: 'oder mit E-Mail anmelden',
    emailLoginToggleOpen: 'Mit E-Mail anmelden',
    emailLoginToggleClose: 'E-Mail-Anmeldung ausblenden',
    welcomeBack: 'Willkommen zurück',
    signInTitle: 'Bei EventHub anmelden',
    signInSubtitle: 'Melde dich mit deinem ADG-Konto an.',
    emailLabel: 'E-Mail',
    emailPlaceholder: "name{'@'}beispiel.de",
    passwordLabel: 'Passwort',
    signInButton: 'Anmelden',
    signingIn: 'Anmeldung läuft…',
    showPassword: 'Passwort anzeigen',
    hidePassword: 'Passwort verbergen',
  },
  reception: {
    runsOn: 'Läuft auf',
    pmsTitle: 'Property-Management-System',
    pmsIntro: 'Die Rezeption läuft auf Ihrem PMS. Sichtbar sind nur die Funktionen, die dieses PMS unterstützt.',
    pmsMore: 'Weitere PMS-Anbindungen folgen. Sobald ein Adapter verfügbar ist, erscheinen seine Funktionen hier automatisch.',
    pmsMewsNote: 'Verbunden · voller Rezeptionsumfang',
    pmsNative: 'Eigenes PMS',
    pmsNativeNote: 'Muss aktiviert werden — bitte Admin kontaktieren',
    pmsOther: 'Anderes PMS (Drittanbieter)',
    pmsOtherNote: 'Auf Anfrage — bitte Admin kontaktieren',
    pmsActive: 'Aktiv',
    pmsAdmin: 'Admin',
    pmsOnRequest: 'Auf Anfrage',
    live: 'Live',
    snapshot: 'Rückblick',
    prevDayTitle: 'Vorheriger Tag (←)',
    prevDay: 'Vorheriger Tag',
    nextDayTitle: 'Nächster Tag (→)',
    nextDay: 'Nächster Tag',
    businessDate: 'Geschäftstag',
    backToToday: 'Zurück zu heute',
    today: 'Heute',
    title: 'Rezeption',
    subtitle: 'Anreisen, Hausgäste und Abreisen für',
    pmsSettings: 'PMS-Einstellungen',
    openAvailability: 'Zimmerverfügbarkeit öffnen',
    availability: 'Verfügbarkeit',
    openHotelRooms: 'Zimmer-Reservierungsraster öffnen',
    hotelRooms: 'Hotelzimmer',
    loading: 'Lädt…',
    refresh: 'Aktualisieren',
    findGuestTitle: 'Gast oder Firma suchen',
    findGuest: 'Gast suchen',
    findReservationTitle: 'Reservierung nach Name, Zimmer oder Bestätigungsnummer suchen',
    findReservation: 'Reservierung suchen',
    newReservationTitle: 'Neue Reservierung anlegen',
    newReservation: 'Neue Reservierung',
    noAccess: 'Du hast keine Berechtigung für die Rezeption.',
    searchPlaceholder: 'Gast, Zimmer oder Veranstaltung suchen…',
    guestScope: 'Gästeauswahl',
    scopeHotel: 'Hotel',
    scopeAll: 'Alle',
    scopeHotelTitle: 'Nur Übernachtungsgäste',
    scopeAllTitle: 'Inkl. Tagesgäste (wie die Summe im Dashboard)',
    shown: '{n} angezeigt',
    inspectAndCheckIn: 'Als geprüft markieren & einchecken',
    assignInspected: 'Geprüftes Zimmer zuweisen',
    colGuest: 'Gast',
    colRoom: 'Zimmer',
    colStay: 'Aufenthalt',
    colBilling: 'Abrechnung',
    colStatus: 'Status',
    colAction: 'Aktion',
    nothingFor: 'Keine Einträge für {date}',
    openGuestProfile: 'Gastprofil öffnen',
    changeRoom: 'Zimmer ändern',
    assignRoom: 'Zimmer zuweisen',
    noMewsReservation: 'Keine MEWS-Reservierung zum Zuweisen',
    editStay: 'Aufenthaltsdaten ändern',
    nights: '{n} Nacht | {n} Nächte',
    openBalanceTitle: 'Offener Saldo — am MEWS-Terminal begleichen',
    due: '{amount} offen',
    companyBilled: 'Firma zahlt',
    guestPays: 'Gast zahlt',
    checkIn: 'Einchecken',
    checkingIn: 'Checke ein…',
    readOnly: 'Nur Leserechte',
    noShowTitle: 'Als No-Show markieren (storniert in MEWS)',
    noShow: 'No-Show',
    checkOutTitle: 'Auschecken — begleichen, Rechnung, Druck',
    checkOut: 'Auschecken',
    noteTitle: 'Notiz: {note}\n\nZum Bearbeiten klicken',
    addNote: 'Notiz hinzufügen',
    noNote: 'Keine Notiz',
    guestNote: 'Gastnotiz',
    folio: 'Folio',
    cancelTitle: 'Reservierung in MEWS stornieren',
    cancelAria: 'Reservierung stornieren',
    terminalNote: 'Zahlung und Check-out laufen am MEWS-Terminal. Diese Übersicht zeigt MEWS an und kassiert kein Geld.',
    tabArrivals: 'Anreisen',
    tabInhouse: 'Hausgäste',
    tabDepartures: 'Abreisen',
    arrivalsSub: '{checkedIn} eingecheckt · {pending} ausstehend',
    noArrivals: 'heute keine Anreisen',
    inhouseSub: 'übernachten heute',
    noInhouse: 'niemand im Haus',
    departuresSub: 'am Terminal begleichen',
    noDepartures: 'heute keine Abreisen',
    statusCheckedIn: 'eingecheckt',
    statusConfirmed: 'bestätigt',
    statusUnknown: 'unbekannt',
    rooms: 'Zimmer',
    unavailable: 'Nicht verfügbar',
    ready: 'bereit',
    dirty: 'schmutzig',
    blocked: 'gesperrt',
    occupancy: 'Belegung',
    freeOf: '{free} von {sellable} frei',
    mewsUnreachableTitle: 'Zimmerdaten kommen aus MEWS und konnten nicht geladen werden',
    mewsUnreachable: 'MEWS nicht erreichbar',
    attention: 'Achtung',
    note: 'Hinweis',
    openBalances: '{n} Abreise(n) mit offenem Saldo',
    outstanding: '{amount} offen',
    hide: 'ausblenden',
    show: 'anzeigen',
    partial: 'Unvollständig — nicht jede Abreise wurde geprüft. Für den verbindlichen Saldo das Folio des Gastes öffnen.',
  },
  status: {
    inquiry: 'Anfrage',
    qualify: 'Qualifizieren',
    proposal: 'Angebot',
    tentative: 'Vorläufig',
    definite: 'Definitiv',
    closedLost: 'Verloren',
    cancelled: 'Storniert'
  },
  notifications: {
    title: 'Benachrichtigungen',
    markAllRead: 'Alle als gelesen markieren',
    byAuthor: 'von',
    none: 'Keine Benachrichtigungen',
    tasks: 'Aufgaben',
    openTaskManager: 'Zur Aufgabenverwaltung',
    settings: 'Benachrichtigungseinstellungen',
    reportsTab: 'Tickets',
    awaitingRetest: 'Warten auf deinen Re-Test',
    assignedToYou: 'Dir zugewiesen',
    ticketActivity: 'Aktivität',
    noReportActivity: 'Aktuell brauchen dich keine Tickets',
    reportDigest: '{count} Ticket-Updates in deiner Abwesenheit',
    enableDesktopAlerts: 'Desktop-Hinweise aktivieren',
    desktopAlertsOn: 'Desktop-Hinweise aktiv — deaktivieren',
    event: {
      new_report: 'neues Ticket',
      comment: 'neuer Kommentar',
      backlogged: 'in den Backlog verschoben',
      blocked: 'blockiert',
      picked_up: 'in Bearbeitung',
      needs_retest: 'bereit für deinen Re-Test',
      retest_failed: 'Re-Test fehlgeschlagen',
      reopened: 'wieder geöffnet',
      retest_passed: 'als gelöst bestätigt',
      closed: 'geschlossen',
      declined: 'abgelehnt',
      assigned: 'zugewiesen',
      escalated: 'auf kritisch hochgestuft',
      digest: 'Updates',
    },
  },
  inside: {
    deleteBody: '„{title}" wird dauerhaft entfernt.',
    title: 'Inside EventHub',
    subtitle: 'Kurze How-to-Videos — lerne EventHub Schritt für Schritt.',
    search: 'Videos suchen…',
    allCategories: 'Alle',
    upload: 'Video hochladen',
    uploadFirst: 'Erstes Video hochladen',
    noMatches: 'Keine Videos gefunden.',
    empty: 'Noch keine Videos vorhanden.',
    draft: 'Entwurf',
    uploadVideo: 'Video hochladen',
    editVideo: 'Video bearbeiten',
    fieldTitle: 'Titel',
    titlePlaceholder: 'z.B. Event anlegen in 2 Minuten',
    fieldCategory: 'Kategorie',
    categoryPlaceholder: 'z.B. Events, Hotel, Reporting',
    fieldDescription: 'Beschreibung',
    descriptionPlaceholder: 'Worum geht es in diesem Video?',
    fieldVideo: 'Videodatei',
    keepVideo: 'leer lassen = unverändert',
    fieldThumbnail: 'Vorschaubild',
    optional: 'optional',
    published: 'Veröffentlicht (für alle sichtbar)',
    saving: 'Speichern…',
    uploadingVideo: 'Video wird hochgeladen…',
    uploadingThumb: 'Vorschaubild wird hochgeladen…',
    saveFailed: 'Speichern fehlgeschlagen.',
    noFile: 'Kein Video hinterlegt.',
    playFailed: 'Video konnte nicht geladen werden.',
    deleteTitle: 'Video löschen?',
    watched: 'Gesehen',
    markWatched: 'Als gesehen markieren',
    uploadedBy: 'Hochgeladen von {who}',
    tooLarge: 'Video zu groß (max. {max} MB). Bitte komprimieren.',
    maxSizeHint: 'MP4 empfohlen · max. {max} MB',
    recLinkShort: 'mit Cap aufnehmen',
    viewLibrary: 'Bibliothek',
    viewInsights: 'Insights',
    insightsByPerson: 'Nach Person',
    insightsByVideo: 'Nach Video',
    insightsSearchPeople: 'Name oder E-Mail suchen…',
    insightsSearchVideos: 'Video suchen…',
    insightsPeopleLabel: 'Personen',
    insightsVideosLabel: 'Videos',
    insightsPerson: 'Person',
    insightsSortHint: 'Spalte sortieren',
    insightsWatched: 'Gesehen',
    insightsProgress: 'Fortschritt',
    insightsStarted: 'Angefangen',
    insightsLastSeen: 'Zuletzt',
    insightsNever: 'nie geöffnet',
    insightsVideo: 'Video',
    insightsOpened: 'Geöffnet',
    insightsFinished: 'Gesehen',
    insightsReach: 'Reichweite',
    insightsNoPeople: 'Keine Personen gefunden.',
    insightsNoVideos: 'Keine Videos gefunden.',
    insightsFailed: 'Insights konnten nicht geladen werden. Das heißt NICHT, dass niemand etwas gesehen hat.',
    insightsKpiStaff: 'Aktive Nutzer',
    insightsKpiAvg: 'Ø Fortschritt',
    insightsKpiAvgHint: 'von {n} veröffentlichten Videos',
    insightsKpiComplete: 'Alles gesehen',
    insightsKpiNever: 'Nie geöffnet',
    insightsPrivacyNote: 'Grundlage sind die veröffentlichten Videos — Entwürfe zählen für niemanden. Angezeigt wird nur, ob ein Video geöffnet bzw. zu Ende gesehen wurde, nicht wann oder wie lange jemand zugesehen hat.',
    recTitle: 'Wie aufnehmen? Kurzanleitung für Autoren',
    recSubtitle: 'Werkzeug, Einstellungen und die eine Regel, die keine Geschmacksfrage ist.',
    recToolHeading: 'Werkzeug',
    recTool: 'Wir nehmen mit Cap auf — Open Source, für macOS, Windows und Linux (Debian/Ubuntu). Der Studio-Modus zeichnet lokal auf, ohne Zeitlimit, und exportiert bis 4K/60fps.',
    recLicence: 'Für den persönlichen Gebrauch kostenlos. Für die Arbeit hier wird eine Desktop-Lizenz benötigt (29 $/Jahr) — bitte vor der ersten Aufnahme anfragen.',
    recSettingsHeading: 'Einstellungen für diese Bibliothek',
    recStudioMode: 'Studio-Modus statt Instant-Modus: wir laden die Datei hier hoch, und Cap-Links sind auf 5 Minuten begrenzt.',
    recExport: 'Export als MP4, 1080p/30fps genügt — hier sind max. {max} MB pro Video möglich.',
    recLength: '2–4 Minuten, ein Thema pro Video. Lieber zwei kurze als ein langes.',
    recWindow: 'Browserfenster auf 1920×1080, Zoom 100 %, Lesezeichenleiste und private Tabs ausblenden.',
    recAudio: 'Mikrofon als eigene Spur aufnehmen — so lässt sich der Ton später ersetzen, ohne neu aufzunehmen.',
    recThumbnail: 'Für das Vorschaubild den Screenshot-Modus nutzen: ein Bild der Seite, über die das Video spricht.',
    recNoGuestData: 'Keine echten Gastdaten aufnehmen. Namen, Adressen, Telefonnummern und Rechnungen aus der Produktion gehören nicht in ein Video, das jede Rolle sehen kann — mit Testdaten arbeiten oder vor der Aufnahme anonymisieren.',
    seenOfTotal: 'gesehen',
    videosCount: 'Videos',
    inProgressCount: '{n} angefangen',
    fieldSource: 'Quelle',
    sourceUpload: 'Hochladen',
    sourceLoom: 'Loom-Link',
    fieldLoomUrl: 'Loom-Link',
    loomHint: 'Füge den Loom-Freigabelink ein — er wird direkt eingebettet (kein Upload nötig).',
    viewsCount: '{n} Aufrufe',
    viewsCountOne: '{n} Aufruf',
    viewsHint: 'Eindeutige Aufrufe (ein Benutzer zählt einmal)',
    mostViewed: 'Meistgesehen',
    filterForYou: 'Für dich',
    filterNew: 'Neu',
    filterSeen: 'Bereits gesehen',
    copyLink: 'Link kopieren',
    linkCopied: 'Kopiert',
    backToLibrary: 'Inside EventHub',
    watchedOfTotal: '{seen}/{total} gesehen',
    allWatched: 'Alles gesehen!',
    openCount: '{n} offen',
  },
  review: {
    changedSinceReview: 'Geändert seit Durchsicht',
    reviewed: 'Geprüft',
    markReviewed: 'Als geprüft markieren',
    markFailed: 'Konnte nicht als geprüft markiert werden',
    unmark: 'Zurücksetzen',
    unmarked: 'Als ungesehen zurückgesetzt',
    checked: 'Als geprüft markiert',
    unchecked: 'Prüfung zurückgesetzt',
    seen: 'Gesehen',
    markSeen: 'Als gesehen markieren',
    seenDone: 'Als gesehen markiert',
    seenOn: 'Gesehen am',
    seenFailed: 'Konnte nicht als gesehen markiert werden',
    changedSinceSeen: 'Geändert seit Ansicht',
    changedShort: 'Geändert',
    seenNew: 'Neu – noch nicht gesehen',
    confirmSeenTitle: 'Als gesehen bestätigen',
    confirmSeenBody: 'Diese Veranstaltung als gesehen markieren?',
    confirmChangedTitle: 'Änderungen bestätigen',
    confirmChangedBody: 'Diese Veranstaltung wurde seit deiner letzten Ansicht geändert. Änderungen ansehen und als gesehen bestätigen?',
    confirmSeenAction: 'Gesehen bestätigen',
    confirmUnseenTitle: 'Als ungesehen markieren',
    confirmUnseenBody: 'Diese Veranstaltung wieder als ungesehen markieren? Sie erscheint dann wieder als offen in deiner Liste.',
    confirmUnseenAction: 'Als ungesehen markieren',
    history: 'Verlauf',
    historyTitle: 'Verlauf: Gesehen & Änderungen',
    historyEmpty: 'Noch kein Verlauf.',
    histSeen: 'Gesehen',
    histUnseen: 'Als ungesehen zurückgesetzt',
    histChanged: 'Geändert',
    lockedStamp: 'Gesperrt',
    checkedByAt: 'Geprüft von {who} am {when}',
  },
  preflight: {
    title: 'Block Pre-Flight',
    subtitle: 'Passen die Business-Central-Veranstaltungen der Woche in unsere Zimmer?',
    prevWeek: 'Vorherige Woche',
    nextWeek: 'N\u00e4chste Woche',
    load: 'Neu laden',
    manualPlaceholder: 'Veranstaltungsnr., z.\u202fB. ST26-00027',
    loadByNo: 'Per Nr.',
    rangeUnsupported: 'Business Central hat die Wochenabfrage abgelehnt. Oben eine oder mehrere Veranstaltungsnummern eingeben, um sie einzeln zu laden.',
    events: 'Veranstaltungen',
    overnightGuests: '\u00dcbernachtung',
    roomsFreePeak: 'Frei max. / min.',
    roomsFreeHint: 'Freie Zimmer über ALLE Kategorien — beste Nacht der Woche / schwächste Nacht. Die Tier-Tabelle unten teilt dieselben Zimmer nach Kategorie auf.',
    resetSimulation: 'Zur\u00fccksetzen',
    demandTitle: 'Bedarf',
    demandSource: 'Business Central',
    supplyTitle: 'Kapazit\u00e4t',
    supplySource: 'EventHub-Verf\u00fcgbarkeit',
    loadingShort: 'l\u00e4dt\u2026',
    enriching: 'Teilnehmer und Zimmerw\u00fcnsche werden geladen\u2026',
    loadingBc: 'Veranstaltungen werden aus Business Central geladen\u2026',
    loadingAvailability: 'Verf\u00fcgbarkeit wird geladen\u2026',
    availabilityUnknown: 'Verf\u00fcgbarkeit nicht lesbar \u2014 Kapazit\u00e4t wird als 0 angezeigt.',
    bcUnavailable: 'Business Central ist nicht erreichbar.',
    diagnose: 'Warum?',
    probe: 'BC fragen, was akzeptiert wird',
    asking: 'Backend fragt',
    weekQueryUnsupported: 'Die Woche konnte nicht abgefragt werden \u2014 das hei\u00dft NICHT \u201ekeine Veranstaltungen\u201c.',
    bcOnly: 'nicht in EventHub',
    bcOnlyHint: 'Business Central kennt diese Veranstaltung, EventHub f\u00fchrt sie nicht \u2014 hier ist daf\u00fcr nichts geblockt.',
    noBc: 'keine BC-Daten',
    noBcHint: 'Business Central lieferte zu dieser Nummer nichts \u2014 Bewertung und Zimmerw\u00fcnsche sind unbekannt.',
    noNumber: 'keine BC-Nr.',
    noNumberHint: 'Diese EventHub-Veranstaltung hat keine externe ID und kann Business Central nicht zugeordnet werden.',
    lookbackNote: 'Gesucht wird nach Startdatum \u00fcber die letzten {days} Tage; {hidden} Veranstaltungen au\u00dferhalb dieser Woche wurden gepr\u00fcft und \u00fcberschneiden sich nicht.',
    weekEmptyBc: 'Business Central meldet f\u00fcr diese Woche keine beginnenden Veranstaltungen.',
    weekEmptyHere: 'EventHub f\u00fchrt f\u00fcr diese Woche keine Veranstaltungen.',
    probing: 'Business Central wird gefragt\u2026',
    rows: 'Zeilen',
    diagnosing: 'Business-Central-Verbindung wird gepr\u00fcft\u2026',
    diagReachable: 'Business Central ist erreichbar \u2014 fehlgeschlagen ist die Veranstaltungsabfrage, nicht die Verbindung.',
    diagUnconfigured: 'F\u00fcr diese Backend-Stage sind keine Business-Central-Zugangsdaten hinterlegt. Fehlt:',
    diagAuth: 'Die Sitzung wurde vom Backend nicht akzeptiert \u2014 bitte neu anmelden.',
    diagUpstream: 'Business Central hat die Anfrage abgelehnt:',
    diagUnknown: 'Business Central hat geantwortet, aber nicht mit einem gesunden Status.',
    noEvents: 'In dieser Woche beginnt keine Business-Central-Veranstaltung.',
    night: 'Nacht',
    nights: 'N\u00e4chte',
    simulate: '\u00dcbernachtungsg\u00e4ste',
    unassigned: 'Ohne Kategorie',
    unassignedHint: '\u00dcbernachtungsg\u00e4ste, deren Zimmerkategorie nicht lesbar war. Sie z\u00e4hlen mit, werden aber keiner Kategorie zugerechnet \u2014 sonst verschw\u00e4nde eine echte Unterdeckung.',
    unmapped: 'nicht gelesen',
    unmappedHint: 'Kein Feld dieses Namens in der Business-Central-Zeile. Wird als \u201enicht gelesen\u201c angezeigt statt als 0, was wie \u201ekeine\u201c aussehen w\u00fcrde.',
    showRaw: 'Rohdaten aus Business Central anzeigen',
    ratingTitle: 'Bewertung, aus BC-Feld \u201e{field}\u201c',
    mustDrop: '\u2212{n} damit es passt',
    applyDrop: '\u00dcbernehmen',
    verdictIdle: 'Noch nichts geladen',
    verdictIdleHint: 'Woche w\u00e4hlen und laden, um zu sehen, ob sie passt.',
    verdictFits: 'Die Woche passt',
    verdictFitsHint: 'Jede Nacht hat genug Zimmer in der gew\u00fcnschten Kategorie.',
    verdictShort: '{n} Zimmer zu wenig',
    verdictShortHint: 'Engste Nacht: {night} {date}, {tier}.',
    assumptions: 'Ein \u00dcbernachtungsgast z\u00e4hlt als ein Zimmer \u2014 Doppelbelegung w\u00fcrde nur Zimmer freimachen, die Rechnung kann also zu streng, aber nie zu optimistisch sein. Die Kapazit\u00e4t ist die Netto-Verf\u00fcgbarkeit der Property in EventHub; die Bewertung einer Veranstaltung gilt nur f\u00fcr G\u00e4ste ohne eigenen Wunsch.',
    tier: { economy: 'Economy', comfort: 'Komfort' },
    field: {
      minParticipants: 'Min',
      maxParticipants: 'Max',
      participants: 'Teilnehmer',
      lecturers: 'Dozenten',
    },
  },
  common: {
    copy: 'Kopieren',
    saved: 'Gespeichert',
    processing: 'Bitte warten…',
    errorLoading: 'Fehler beim Laden',
    previous: 'Zurück',
    next: 'Weiter',
    discardUnsavedChanges: 'Ungespeicherte Änderungen verwerfen?',
    default: 'Standard',
    deprecated: 'Alt',
    activate: 'Aktivieren',
    deactivate: 'Deaktivieren',
    later: 'Sp\u00e4ter',
    loading: 'Laden...',
    failed: 'Fehlgeschlagen',
    collapse: 'Einklappen',
    expandDetails: 'Details anzeigen',
    save: 'Speichern',
    saveAll: 'Alles speichern',
    saving: 'Speichern...',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    deleting: 'Wird gelöscht...',
    edit: 'Bearbeiten',
    noEditPermission: 'Keine Berechtigung zum Bearbeiten',
    eventInPast: 'Event liegt in der Vergangenheit — Bearbeitung nicht möglich',
    lockedAfterChecked: 'Funktionsblatt ist geprüft — Bearbeiten gesperrt',
    notSet: 'Nicht gesetzt',
    back: 'Zurück',
    rename: 'Umbenennen',
    change: 'Ändern',
    create: 'Erstellen',
    search: 'Suchen',
    filter: 'Filtern',
    refresh: 'Aktualisieren',
    notes: 'Notizen',
    justNow: 'gerade eben',
    minutesAgo: 'Min.',
    hoursAgo: 'Std.',
    dayAgo: 'Tag',
    daysAgo: 'Tage',
    export: 'Exportieren',
    import: 'Importieren',
    close: 'Schließen',
    download: 'Herunterladen',
    remove: 'Entfernen',
    count: 'Anzahl',
    deletePermanently: 'Endgültig löschen',
    event: 'Veranstaltung',
    start: 'Start',
    end: 'Ende',
    print: 'Drucken',
    clear: 'Löschen',
    copied: 'Kopiert!',
    reload: 'Neu laden',
    retry: 'Erneut versuchen',
    confirm: 'Bestätigen',
    confirmTitle: 'Bestätigen',
    discard: 'Verwerfen',
    keepEvent: 'Event behalten',
    ok: 'OK',
    add: 'Hinzufügen',
    optional: 'optional',
    selectAll: 'Alle auswählen',
    deselectAll: 'Alle abwählen',
    showMore: 'Mehr anzeigen',
    showLess: 'Weniger anzeigen',
    yes: 'Ja',
    no: 'Nein',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    all: 'Alle',
    name: 'Name',
    description: 'Beschreibung',
    status: 'Status',
    actions: 'Aktionen',
    details: 'Details',
    showAllData: 'Alle Daten anzeigen',
    hideAllData: 'Alle Daten ausblenden',
    day: 'Tag',
    days: {
      label: 'Tage',
      sun: 'So',
      mon: 'Mo',
      tue: 'Di',
      wed: 'Mi',
      thu: 'Do',
      fri: 'Fr',
      sat: 'Sa',
    },
  },
  datePicker: {
    selectRange: 'Zeitraum wählen',
    startTime: 'Startzeit',
    endTime: 'Endzeit',
    clickStart: 'Startdatum wählen',
    apply: 'Übernehmen',
  },
  signageEmulator: {
    title: 'Signage-Emulator',
    subtitle: 'So sehen die Raumschilder zu einem gewählten Zeitpunkt aus — aus dem echten Signage-Feed',
    day: 'Tag',
    time: 'Uhrzeit',
    now: 'Jetzt',
    refresh: 'Neu laden',
    window: 'Der Feed reicht von heute 00:00 bis 72 Stunden ab jetzt. Spätere Zeitpunkte sind noch nicht im Feed.',
    syncedAt: 'Feed-Stand',
    free: 'Frei',
    next: 'Als Nächstes',
    noneNext: 'Heute keine weitere Belegung',
    noRooms: 'Keine Räume mit digitaler Beschilderung.',
    loadFailed: 'Signage-Feed konnte nicht geladen werden',
    onlyBooked: 'Nur belegte',
    rooms: 'Räume',
    unknownRoom: 'Nicht als Signage-Raum markiert',
  },
  menu: {
    businessSchool: 'Business School',
    dashboard: 'Dashboard',
    eventBookings: 'Veranstaltungen',
    eventManagement: 'Event-Management',
    eventSessions: 'Veranstaltungssitzungen',
    attendees: 'Teilnehmer',
    availabilities: 'Verfügbarkeit',
    blockManager: 'Block Manager',
    reservations: 'Raumplanungsliste',
    signageEmulator: 'Signage-Emulator',
    roomOccupancy: 'Freigabeübersicht',
    pmsBoard: 'Rezeption',
    bookingPlan: 'Belegungsplan',
    spaces: 'Räume',
    menus: 'Menüs',
    cateringOrders: 'Catering',
    beo: 'BEO',
    exporter: 'Exporteur',
    reports: 'Meldungen',
    mewsData: 'MEWS Daten',
    mewsServices: 'MEWS Dienstleistungen & Produkte',
    analytics: 'Analytik',
    observability: 'Observability',
    stockManagement: 'Lagerverwaltung',
    miceBoard: 'MICE Board',
    miceAnalytics: 'MICE Analytik',
    contacts: 'Kontakte',
    propertySetup: 'Einstellungen',
    pmsSettings: 'PMS-Einstellungen',
    administration: 'Hub Admin',
    rolesPermissions: 'Berechtigungen',
    archive: 'Archiv',
    events: 'Veranstaltungen',
    equipment: 'Ausrüstung',
    masterdataChain: 'Stammdatenkette',
    dataManagement: 'Data Management',
    auditLog: 'Änderungslog',
    errorLog: 'Fehlerlog',
    azurePbis: 'Azure PBIs',
    devOps: 'Dev Ops',
    roadmap: 'Roadmap',
    insideEventhub: 'Inside EventHub',
    conflictResolution: 'Conflict Board',
    hotelOptimisation: 'Hotel-Optimierung',
    revenueManagement: 'Revenue Management',
    fnbEquipment: 'F&B / Equipment',
    middleware: 'Middleware',
    themes: 'Themes',
    rawTables: 'Rohdaten',
  },
  userMenu: {
    profile: 'Profil',
    account: 'Konto & Sicherheit',
    language: 'Sprache',
    passwordSection: 'Passwort',
    ssoPasswordHint: 'Du meldest dich mit Microsoft (Entra ID) an. Dein Passwort wird dort verwaltet und kann hier nicht geändert werden.',
    changePassword: 'Passwort ändern',
    systemStatus: 'Systemstatus',
    about: 'Über',
    developedBy: 'Made by',
    logout: 'Abmelden',
    report: 'Meldung',
    documentation: 'Dokumentation',
    myTasks: 'Meine Aufgaben',
    notifications: 'Benachrichtigungen',
    tasksNotifications: 'Aufgaben & Benachrichtigungen',
    tabTasks: 'Aufgaben',
    tabNotifications: 'Benachrichtigungen',
    noTasks: 'Keine Aufgaben zugewiesen',
    noNotifications: 'Keine Benachrichtigungen',
    notificationsComingSoon: 'Benachrichtigungen demnächst verfügbar',
    filterAll: 'Alle',
    filterOpen: 'Offen',
    filterDone: 'Erledigt',
  },
  changePasswordModal: {
    title: 'Passwort ändern',
    currentPassword: 'Aktuelles Passwort',
    currentPasswordPlaceholder: 'Aktuelles Passwort eingeben',
    newPassword: 'Neues Passwort',
    newPasswordPlaceholder: 'Neues Passwort eingeben (min. 8 Zeichen)',
    confirmPassword: 'Neues Passwort bestätigen',
    confirmPasswordPlaceholder: 'Neues Passwort wiederholen',
    minChars: 'Mindestens 8 Zeichen erforderlich',
    sameAsOld: 'Das neue Passwort muss sich vom aktuellen Passwort unterscheiden',
    mismatch: 'Passwörter stimmen nicht überein',
    cancel: 'Abbrechen',
    submit: 'Passwort ändern',
    saving: 'Wird gespeichert...',
    success: 'Passwort wurde erfolgreich geändert!',
    close: 'Schließen',
    errorIncorrect: 'Das aktuelle Passwort ist falsch.',
    errorMinLength: 'Das neue Passwort muss mindestens 8 Zeichen lang sein.',
    errorNotAvailable: 'Passwortänderung ist für diesen Account nicht verfügbar.',
    errorGeneric: 'Passwort konnte nicht geändert werden. Bitte versuchen Sie es erneut.',
  },
  adyen: {
    title: 'Adyen — Terminals & POS',
    subtitle: 'Kartenterminals verbinden, testen und Zahlungen am Terminal',
    property: 'Property',
    testConnection: 'Verbindung testen',
    credentials: 'Zugangsdaten',
    credentialsHint: 'Pro Property gespeichert. Secrets werden maskiert.',
    secretSet: 'gesetzt',
    secretUnset: 'nicht gesetzt',
    save: 'Speichern',
    saving: 'Speichern …',
    saveFailed: 'Speichern fehlgeschlagen',
    terminals: 'Terminals',
    refresh: 'Aktualisieren',
    loading: 'Lädt …',
    noTerminals: 'Keine Terminals gefunden. Zugangsdaten prüfen und aktualisieren.',
    colTerminal: 'Terminal',
    colStatus: 'Status',
    colActions: 'Aktionen',
    unassigned: 'nicht zugewiesen',
    connect: 'Verbinden',
    diagnose: 'Diagnose',
    test: 'Testzahlung',
    posPay: 'Zahlung am Terminal (POS)',
    terminal: 'Terminal',
    amount: 'Betrag',
    currency: 'Währung',
    reference: 'Referenz',
    referenceHint: 'z. B. Rechnungs-Nr. (optional)',
    charge: 'Belasten',
    charging: 'Belasten …',
    checking: 'Prüfe …',
    unconfigured: 'Nicht konfiguriert',
    connected: 'Verbunden',
    error: 'Fehler',
    unconfiguredHint: 'Adyen für diese Property noch nicht konfiguriert.',
    loadFailed: 'Terminals konnten nicht geladen werden',
    boarded: 'Terminal einsatzbereit',
    actionFailed: 'Aktion fehlgeschlagen',
    online: 'Online',
    offline: 'Offline / nicht erreichbar',
    testPayment: 'Testzahlung',
    verdict_approved: 'genehmigt',
    verdict_refused: 'abgelehnt',
    verdict_pending: 'ausstehend (am Terminal fortsetzen)',
    verdict_unknown: 'unbekannt',
  },
  stripeTerminal: {
    title: 'Stripe Terminal — Reader & POS',
    subtitle: 'Stripe-Kartenleser koppeln, testen und Zahlungen am Reader',
    property: 'Property',
    testConnection: 'Verbindung testen',
    credentials: 'Zugangsdaten',
    credentialsHint: 'Pro Property gespeichert. Secrets werden maskiert.',
    secretKey: 'Secret Key',
    secretKeyHint: 'sk_test_… = Testmodus, sk_live_… = Live',
    keyFormat: 'Erwartet wird ein Secret Key (sk_test_… / sk_live_…), kein Publishable Key.',
    location: 'Terminal-Standort',
    locationHint: 'tml_… — filtert Reader; zum Koppeln erforderlich',
    secretSet: 'gesetzt',
    secretUnset: 'nicht gesetzt',
    save: 'Speichern',
    saving: 'Speichern …',
    saveFailed: 'Speichern fehlgeschlagen',
    readers: 'Reader',
    refresh: 'Aktualisieren',
    loading: 'Lädt …',
    noReaders: 'Keine Reader gefunden. Zugangsdaten prüfen oder unten einen koppeln.',
    colReader: 'Reader',
    colStatus: 'Status',
    colActions: 'Aktionen',
    unknownStatus: 'unbekannt',
    status: 'Status',
    test: 'Testzahlung',
    simulateCard: 'Testkarte auflegen',
    cancel: 'Abbrechen',
    registrationCode: 'Registrierungscode',
    label: 'Bezeichnung',
    labelHint: 'z. B. Rezeption',
    register: 'Reader koppeln',
    registering: 'Koppeln …',
    registered: 'Reader gekoppelt',
    registerHint: 'Code vom Reader-Display eingeben. Im Testmodus erzeugt simulated-wpe einen simulierten Reader — ohne Hardware.',
    posPay: 'Zahlung am Reader (POS)',
    reader: 'Reader',
    amount: 'Betrag',
    currency: 'Währung',
    reference: 'Referenz',
    referenceHint: 'z. B. Rechnungs-Nr. (wird sonst erzeugt)',
    charge: 'Belasten',
    charging: 'Belasten …',
    checking: 'Prüfe …',
    unconfigured: 'Nicht konfiguriert',
    connected: 'Verbunden',
    error: 'Fehler',
    modeTest: 'Test',
    modeLive: 'Live',
    unconfiguredHint: 'Stripe Terminal für diese Property noch nicht konfiguriert.',
    loadFailed: 'Reader konnten nicht geladen werden',
    actionFailed: 'Aktion fehlgeschlagen',
    online: 'Online',
    offline: 'Offline',
    testPayment: 'Testzahlung',
    pollTimeout: 'Wartet weiter auf den Reader — Reader prüfen oder abbrechen',
    verdict_approved: 'genehmigt',
    verdict_refused: 'abgelehnt',
    verdict_canceled: 'abgebrochen',
    verdict_pending: 'wartet auf Karte am Reader',
  },
  eventManagement: {
    streamAll: 'Alle',
    scopeYear: 'Jahr',
    scopeAll: 'Alle',
    emptyTitleAll: 'Keine Veranstaltungen gefunden.',
    tabOverview: 'Übersicht',
    tabMine: 'Meine Events',
    title: 'Event-Management',
    subtitle: 'Planungs-Cockpit f\u00fcr Veranstaltungsmanager',
    loading: 'Veranstaltungen werden geladen \u2026',
    prevYear: 'Vorheriges Jahr',
    nextYear: 'N\u00e4chstes Jahr',
    untitled: 'Ohne Titel',
    noManager: 'Ohne Manager',
    unknownManager: 'Unbekannt',
    eventsShort: 'Veranst.',
    paxShort: 'Pers.',
    daysShort: 'Tage',
    emptyTitle: 'Keine Veranstaltungen in {year}',
    emptyHint: 'W\u00e4hle einen anderen Stream oder ein anderes Jahr.',
    kpiEvents: 'Veranstaltungen',
    kpiPax: 'Teilnehmer gesamt',
    kpiPaxSub: 'Summe \u00fcber alle Events',
    kpiDays: 'Veranstaltungstage',
    kpiDaysSub: 'Summe der Event-Tage',
    kpiAvgValue: '\u00d8 Wert',
    kpiAvgValueSub: 'Personen \u00d7 Tage pro Event',
    perManagerTitle: 'Veranstaltungen pro Manager',
    perManagerSub: 'Verteilung nach Veranstaltungsmanager',
    showMoreManagers: '{n} weitere anzeigen',
    showFewerManagers: 'Weniger anzeigen',
    valueTableTitle: 'Wert je Veranstaltung',
    valueTableSub: 'Wert = Personen \u00d7 Tage',
    colEvent: 'Veranstaltung',
    colPax: 'Pers.',
    colDays: 'Tage',
    colValue: 'Wert',
    replanTitle: 'F\u00fcr {year} neu planen',
    replanSub: 'Die st\u00e4rksten Events \u2013 wert, wiederholt zu werden',
    replanEmpty: 'Nichts zu planen.',
    replanCalendar: {
      open: 'Planungskalender \u00f6ffnen',
      title: 'Programm {year} planen',
      subtitle: 'Programm des Vorjahres \u2013 Wochentage angepasst',
      year: 'Jahr',
      month: 'Monat',
      events: 'Veranstaltungen',
      plannedPax: 'geplante Teilnehmer',
      holiday: 'Feiertag',
      load: 'Auslastung',
      empty: 'Keine Seminare oder Business-School-Events im gew\u00e4hlten Jahr.',
    },
  },
  setupTypes: {
    theatre: 'Stuhlreihen (Theater)',
    classroom: 'Parlamentarisch (Seminar)',
    u_shape: 'U-Form',
    block: 'Blockform (Konferenz)',
    round: 'Bankett (Rundtische)',
    retreat: 'Klausur',
  },
  dashboard: {
    secReleases: 'Freigaben',
    releasesOpenPage: 'Hotel-Optimierung',
    releasesEventSummary: '{n} Events mit offenen Freigaben · {r} bereit',
    beta: 'Beta — in Entwicklung, Funktionsumfang kann sich noch ändern',
    toAvailabilities: 'Zur Verfügbarkeiten-Seite',
    clear: 'Leeren',
    // Section titles
    secConflicts: 'Konflikte',
    secEvents: 'Veranstaltungen',
    secHotelAvailability: 'Hotel-Verfügbarkeit',
    secHotelReleases: 'Hotel-Freigaben',
    secHotelOptimization: 'Hotel-Optimierung',
    secMyTasks: 'Meine Aufgaben',
    secPmsSyncIssues: 'PMS Sync-Probleme',
    secSpaceConfirmations: 'Raum-Bestätigungen',
    secSpacesAvailability: 'Räume-Verfügbarkeit',
    secOperationsToday: 'Operativ heute',
    secPipeline: 'Pipeline',
    // Hero
    openReception: 'Reception öffnen — Anreisen, im Haus, Abreisen (neuer Tab)',
    reception: 'Reception',
    openMiceBoard: 'MICE Board öffnen',
    miceBoard: 'MICE Board',
    weatherMoodsView: 'Alle Wetter-Stimmungen ansehen',
    weatherMoodsViewAria: 'Wetter-Stimmungen ansehen',
    guestsThisWeek: 'Gäste diese Woche — zu den Teilnehmern (Wochenansicht)',
    eventTrend: 'Event-Trend — zur Analytics-Seite',
    greetingMorning: 'Guten Morgen',
    greetingDay: 'Guten Tag',
    greetingEvening: 'Guten Abend',
    // Widget actions
    changeBlock: 'Block ändern',
    changeBlockTitle: 'Anfrage mit aktueller Verfügbarkeit ändern',
    release: 'Freigeben',
    reject: 'Ablehnen',
    rejectTitle: 'Freigabe ablehnen',
    confirmAllRooms: 'Alle Raumbuchungen dieser Veranstaltung bestätigen',
    openInEvent: 'Im Event öffnen',
    openBookingInEvent: 'Raumbuchung im Event öffnen',
    openInReservations: 'In Reservierungen öffnen',
    openInReservationsWeek: 'In Reservierungen öffnen — diese Woche',
    changeRoom: 'Raum ändern',
    changeRoomTitle: 'Auf einen anderen (besseren) Raum ändern',
    confirm: 'Bestätigen',
    confirmBookingTitle: 'Raumbuchung bestätigen',
    openSessionInEvent: 'Session im Event öffnen',
    assignRoom: 'Raum zuweisen',
    chooseRoom: 'Raum wählen…',
    heroToday: 'Heute',
    heroPrevDay: 'Vorheriger Tag',
    heroNextDay: 'Nächster Tag',
    searchShort: 'Suchen…',
    searchLong: 'Suche Events, Reservierungen, Gäste, Firmen…',
    guestsPerWeek: 'Gäste / Woche',
    wkPrev: 'Vor', wkThis: 'Diese', wkNext: 'Nächste',
    wkPrevFull: 'Vorwoche', wkThisFull: 'Diese Woche', wkNextFull: 'Nächste Woche',
    guestsWord: 'Gäste',
    eventTrendLabel: 'Event-Trend',
    trendToday: 'Heute',
    trendMinus3: '−3T',
    trendPlus3: '+3T',
    statInHouse: 'Im Haus',
    statArrival: 'Anreise {day}',
    statDeparture: 'Abreise {day}',
    statMewsOnly: 'Nur MEWS',
    splitHotel: 'Hotel',
    splitDayguest: 'Tagesg.',
    mewsEhSub: 'MEWS {mews} · EventHub {eh}',
    snapshotNoData: 'Snapshot ohne Belegungsdaten',
    synced: 'synchron',
    dayToday: 'heute',
    dayPast: 'an diesem Tag',
    daySelected: 'am ausgewählten Tag',
    briefingLoading: 'Lade Briefing…',
    briefingQuiet: 'Heute ist ruhig. Nutze die Zeit für die kommende Woche.',
    briefingNoOps: 'Kein operativer Eintrag für diesen Tag.',
    briefingToday: 'Du hast heute {arrivals} Anreisen und {events} laufende Events.',
    briefingSelected: 'Am gewählten Tag {arrivals} Anreisen und {events} laufende Events.',
    releaseLoading: 'Lade Freigabe-Anfragen…',
    releaseNoneOpen: 'Keine offenen Freigabe-Anfragen.',
    releaseNoneWaiting: 'Keine Blöcke warten auf Freigabe.',
    releaseSubtitle: '{count} Blöcke · {rooms} Zimmer zur Freigabe',
    releaseAllLoaded: 'Alle Anfragen geladen',
    blockOfTotal: 'Block {index} von {total}',
    inDaysShort: 'in {days} T.',
    optLoading: 'Lade Zimmer-Optimierung…',
    optNone: 'Keine ungenutzten Zimmer · alles passt',
    sbcLoading: 'Lade offene Raumbuchungen…',
    sbcAllConfirmed: 'Alle Raumbuchungen sind bestätigt.',
    sbcAllLoaded: 'Alle offenen Buchungen geladen',
    sbcNoneWaiting: 'Keine Raumbuchung wartet auf Bestätigung.',
    sbcRoomsWaiting: '{count} Raum wartet auf Bestätigung | {count} Räume warten auf Bestätigung',
    sbcEventsCount: '{count} Veranstaltung | {count} Veranstaltungen',
    sbcSessionsNoRoom: '{count} Session ohne Raum | {count} Sessions ohne Raum',
    sbcAtLeast: 'mind. {value}',
    roomsSuffix: 'Räume',
    daysSuffix: 'Tage',
    paxSuffix: 'Pax',
    roomWord: 'Raum',
    sessionsNoRoomHeading: 'Sessions ohne Raum',
    roomRequestsHeading: 'Raum-Anfragen',
    requestedShort: 'angefragt',
    newRoom: 'Neuer Raum',
    assignHint: 'Die Buchung wird als vorgeschlagen angelegt und erscheint danach oben zur Bestätigung.',
    changeHint: 'Die Buchung bleibt danach offen und muss noch bestätigt werden.',
    bookingsTogetherTitle: '{n} Einzelbuchungen an {d} Tagen werden gemeinsam bestätigt',
    roomCategory: 'Zimmerkategorie',
    availRetry: 'Erneut prüfen',
    approveAvailabilityUnverifiable: 'Nicht freigegeben: MEWS hat für diese Zimmerkategorie keine Verfügbarkeit geliefert. Die Anfrage bleibt bestehen — bitte in einem Moment erneut freigeben.',
    approveWaitAvailability: 'Verfügbarkeit wird noch aus MEWS geladen — Freigabe danach möglich.',
    approveAvailabilityUnknown: 'Verfügbarkeit konnte nicht aus MEWS geladen werden — Freigabe erst nach erfolgreicher Prüfung („Erneut prüfen“).',
    availNotChecked: 'Verfügbarkeit konnte nicht geprüft werden',
    releaseAndCreate: 'Freigeben und den MEWS-Block erstellen',
    releaseFailedMsg: 'Freigabe konnte nicht durchgeführt werden.',
    rejectFailedMsg: 'Ablehnung konnte nicht durchgeführt werden.',
    releaseFailed: 'Freigabe fehlgeschlagen',
    rejectFailed: 'Ablehnung fehlgeschlagen',
    tasksSubtitle: '{n} offen · sortiert nach Fälligkeit',
    naLoading: 'Lade Probleme…',
    naAllSynced: 'Alles synchron mit MEWS.',
    naSubtitle: '{n} offene Punkte · jetzt prüfen',
    csAllGood: 'Alles im grünen Bereich',
    csNoRoom: 'Kein Raum',
    csLoading: 'Lade Konflikte…',
    eclUpcoming: 'Kommende Veranstaltungen',
    eclLoading: 'Lade Veranstaltungen…',
    eclNoneNow: 'Aktuell finden keine Veranstaltungen statt.',
    eclNoneUpcoming: 'Keine kommenden Veranstaltungen.',
    eclNoneNowShort: 'Aktuell keine',
    eclNoneUpcomingShort: 'Keine kommenden',
    umdPipelineValue: 'Pipeline-Wert',
    umdActivePipeline: 'Aktive Pipeline',
    umdNoRevenue: 'Umsatz fehlt',
    umdMissingRevenue: ' · {n} ohne Umsatzschätzung',
    availLoading: 'Lade Verfügbarkeit…',
    hatSubtitle: 'Freie Hotelzimmer · heute & 3 Tage',
    roomsFree: 'Zimmer frei',
    todayNext3: 'Heute & nächste 3 Tage',
    satSubtitle: 'Freie Räume · heute & 3 Tage',
    occOver: 'Über', occFull: 'Voll', occTight: 'Knapp', occFree: 'Frei',
    spaceFreeSingular: 'Raum frei', spaceFreePlural: 'Räume frei',
    gsMyEvents: 'Meine Veranstaltungen',
    gsManagerSub: 'Produkt-/Veranstaltungsmanager',
    gsNoManagerEvents: 'Keine kommenden Events, bei denen du Manager bist.',
    gsCurrentEvents: 'Aktuelle Veranstaltungen',
    kindEvents: 'Veranstaltungen', kindEvent: 'Event',
    kindReservations: 'Reservierungen', kindReservation: 'Reservierung',
    kindGuests: 'Gäste', kindGuest: 'Gast',
    kindCompanies: 'Firmen', kindCompany: 'Firma',
    gsNextEvents: 'Die nächsten Veranstaltungen',
    gsAllEvents: 'Alle Veranstaltungen',
    gsCreateEvent: 'Erstelle neue Veranstaltung',
    bavLoadingHistory: 'Lade Verlauf …',
    bavNoData: 'Keine Daten',
    bavOnline: 'Online',
    bavRequests: '{count} Anfrage | {count} Anfragen',
    bavShort: 'Kurze Unterbrechung (< 1 Min.)',
    bavDown: 'Ausfall',
    bavAvailable: 'verfügbar',
    bavDowntime: '{d} nicht erreichbar',
    bavRestarts: '{count} Neustart | {count} Neustarts',
    bavIncidents: 'Letzte Unterbrechungen',
    bavNoOutage: 'keine Unterbrechung',
    bavCauseRestart: 'Neustart (z. B. Deploy)',
    bavCauseCrash: 'Absturz, neu gestartet',
    bavCauseSilent: 'keine Lebenszeichen',
    bavOngoing: 'andauernd',
    bavMeasuredSince: 'Gemessen seit {date}',
    bavExplain: 'Das Backend meldet sich alle 30 Sekunden. Eine Unterbrechung ist die Zeit, in der kein Server lief – bei Neustarts auf die Sekunde genau. Grau: aus der Zeit vor der Messung und ohne Anfragen. Fehler einzelner Funktionen siehst du unter Observability.',
    csEventNoRoom: 'Event oder Session ohne Raum',
    csRoomTooSmall: 'Raum zu klein',
    csGroupLargerThanRoom: 'Gruppe größer als der Raum',
    toDayguest: 'Tagesgast',
    csHotelBlockError: 'Hotel Block Fehler',
    csBlockSyncFailed: 'Block-Sync fehlgeschlagen',
    csHotelBlockDiff: 'Hotel Block Differenz',
    csBlockedVsNights: 'Geblockt ≠ Übernachtungen',
    availChecking: 'Verfügbarkeit wird geprüft…',
    hatHeader: 'Heute {n} Zimmer frei',
    satHeader: 'Heute {n} Räume frei',
    viewAll: 'Alle ansehen',
    tOpen: 'Offen', tOpenSub: 'Alle aktiven Aufgaben',
    tOverdue: 'Überfällig', tOverdueSub: 'Vor heute fällig',
    tTodayDue: 'Heute fällig', tTodayDueSub: 'Bis Ende des Tages',
    tWeek: 'Diese Woche', tWeekSub: 'Nächste 7 Tage',
    tNoDue: 'Ohne Fälligkeit', tNoDueSub: 'Termin fehlt',
    optSubtitle: '{rooms} Zimmer freigebbar · {events} Events',
    optReleaseNow: 'Sofort freigeben', optPropose50: '−50 % vorschlagen', optAdjustSmall: 'Kleingruppen anpassen',
    optTier1Sub: '{n} Events · 0–30 Tage', optTier2Sub: '{n} Events · 31–60 Tage', optTier3Sub: '{n} Events · <7 Pickups',
    eclRunningNow: 'Läuft gerade', eclTabCurrent: 'Aktuelle', eclTabNext: 'Nächste',
    eclEntry: '{n} Eintrag', eclEntries: '{n} Einträge',
    eclSinceYesterday: 'seit gestern', eclSinceDays: 'seit {n} T',
    eclSubRunning: '{n} laufen gerade', eclSubNext: 'Die nächsten {n}',
    umdSubBase: 'Nächste 3 Monate · MICE', umdSubtitle: 'Nächste 3 Monate · MICE · {n} Events',
    umdOpenEvents: '{n} offene Events', umdRevenueMissing: 'Umsatzschätzung fehlt bei {n} Events',
    csToCheck: 'zu prüfen', csCritical: 'kritisch',
    fromLocalSnapshot: 'Aus dem lokalen Verfügbarkeits-Snapshot.',
    sinceToday: 'seit heute', sinceYesterday: 'seit gestern', sinceDays: 'seit {n} Tagen',
    gsQuickAccess: 'Schnellzugriff', gsSearching: 'Suche…', gsBackToQuick: 'Zurück zum Schnellzugriff',
    gsNoContact: 'Kein passender Kontakt zu deinem Konto gefunden.', gsNoUser: 'Benutzer konnte nicht ermittelt werden.',
    gsStreamSeminar: 'Seminar', gsStreamInternal: 'Intern', gsStreamBs: 'Business School',
    sbcCurrent: 'Aktuell',
  },
  eventBookings: {
    pickupErroredTooltip: 'Reservierungen mit Pickup-Fehler — kein Zimmer geblockt',
    packagesTab: 'Paket',
    invalidDateRange: 'Anreisedatum muss vor Abreisedatum liegen.',
    contactResolveFailed: 'Kontakt konnte nicht aufgelöst werden.',
    event: 'Event',
    addNoticeOngoingTitle: 'Event läuft gerade',
    addNoticeOngoingBody: 'Dieses Event hat bereits begonnen. Teilnehmer können trotzdem hinzugefügt werden.',
    addNoticeOngoingDayguest: 'Tagesgäste sind problemlos möglich — sie brauchen weder Zimmer noch Block.',
    addNoticeOngoingHotel: 'Hotelgäste nur, solange der Block noch Zimmer hält — sonst ist die Auswahl im Formular ausgegraut.',
    addNoticePastTitle: 'Event ist vorbei',
    addNoticePastBody: 'Dieses Event liegt in der Vergangenheit.',
    addNoticePastHint: 'Nachträglich hinzufügen ist möglich, ändert aber Auswertungen und ggf. Rechnungen. Bitte nur zur Korrektur.',
    addNoticeStreamTitle: 'Für diesen Stream nicht möglich',
    addNoticeStreamBody: 'Für diesen Event-Stream gibt es kein Teilnehmerformular.',
    addNoticeProceed: 'Trotzdem hinzufügen',
    customerBillOpen: 'Rechnung',
    customerBillOpenHint: 'Rechnung in MEWS öffnen',
    customerUnbilled: '{n} Position(en) noch auf keiner Rechnung',
    customerLinesTitle: 'Von EventHub berechnet',
    customerLinesEmpty: 'Keine Produkte auf den Kunden gebucht',
    customerLinesEmptyHint: 'Produkte im Reiter Produkte auf „Kunde“ buchen, damit sie hier erscheinen.',
    customerLineNoPrice: 'Für diese Zeile ist kein Preis hinterlegt.',
    customerLineCharged: 'berechnet',
    customerLineOpen: 'offen',
    customerMewsTitle: 'Auf dem PMS-Konto',
    customerNotInMews: 'Kunde ist nicht mit MEWS verknüpft',
    customerNotInMewsHint: 'Ohne MEWS-Konto kann das PMS für diesen Kunden nichts führen.',
    customerProductsNone: 'Kundenprodukte — noch keine',
    customerProductsCount: 'Kundenprodukte: {ours} von EventHub, {pms} im PMS',
    hideCancelled: 'Storniert ausblenden',
    hideCancelledHint: 'Stornierte Teilnehmer aus der Liste ausblenden. Zeilen, die nur in MEWS storniert sind, bleiben sichtbar.',
    cancelledHiddenCount: '{n} storniert ausgeblendet',
    showCancelledParticipantsHint: 'Stornierte Teilnehmer wieder einblenden.',
    stayCheckedIn: 'Eingecheckt',
    stayCheckedOut: 'Ausgecheckt',
    stayWaiting: 'Wartet',
    stayNoShow: 'No-Show',
    stayHint: {
      checked_in: 'In MEWS eingecheckt (State: Started).',
      checked_out: 'In MEWS ausgecheckt (State: Processed).',
      waiting: 'Anreisetag ({date}) — MEWS meldet noch keinen Check-in.',
      no_show: 'Anreise war am {date}, MEWS hat nie einen Check-in gemeldet. Bitte prüfen.',
    },
    noServices: 'Keine Leistungen',
    noServicesHint: 'Vor Ort, bucht keine Leistungen',
    definiteShort: 'definitiv',
    vsPreviousPeriod: 'ggü. Vorperiode',
    blockRoomsShort: 'Blockzimmern',
    ackUnseenTitle: 'Ungesehen',
    currentShort: 'aktuell',
    pastShort: 'vorbei',
    runningShort: 'laufend',
    upcomingShort: 'kommend',
    hotelGuestsKpi: 'Hotelgäste',
    hotelGuestsKpiHint: 'Gebuchte Hotelgäste gegenüber den im Zimmerblock geplanten Zimmern',
    blockPlannedShort: 'Block',
    blockPlannedHint: 'Im Zimmerblock geplante Zimmer',
    overBlockHint: 'Mehr Hotelgäste als im Block geplant',
    hotelFillTitle: '{booked} von {planned} Blockzimmern gebucht · {open} noch frei',
    confirmedShort: 'bestätigt',
    ofPlanned: 'von',
    participantsFillTitle: '{booked} von {planned} geplanten Teilnehmern gebucht · {open} noch offen',
    ackSeenShort: 'gesehen',
    trendSummary: 'Heute {today} laufende Events · Ø {back}/Tag die letzten 14 Tage · Ø {ahead}/Tag die nächsten 14 Tage',
    checksAllOk: 'Alles in Ordnung',
    deletedPriceList: 'gelöschte Preisliste',
    packagesCountLabel: '{count} Paket | {count} Pakete',
    packageContents: 'Inhalt',
    packagePerPerson: 'Preis',
    billedZeroPriceShort: '0 € lt. Preisliste',
    manualPriceResetHint: 'Eigenen Preis verwerfen – der Preis kommt wieder aus der Preisliste',
    statusFilterNone: 'Kein Status gewählt — oben einen Status anklicken.',
    linesTotal: 'Total',
    rulesAllTitle: 'Produkte durch Regeln ausgelöst',
    manualAllTitle: 'Manuell hinzugefügte Produkte',
    moneyCharged: 'verrechnet',
    moneyOpen: 'offen',
    ruleChipSingular: 'Regel',
    ruleChipPlural: 'Regeln',
    addLine: 'Hinzufügen',
    addLineProduct: 'Produkt',
    addLineProductHint: 'Einzelne Produkte aus dem Katalog',
    addLinePackage: 'Paket',
    addLinePackageHint: 'Vordefiniertes Bündel mehrerer Produkte',
    statusFilterCharged: 'Verrechnet',
    statusFilterPending: 'Ausstehend',
    statusFilterCancelled: 'Storniert',
    statusFilterError: 'Fehler',
    statusCharged: 'Verrechnet',
    statusPending: 'Ausstehend',
    statusCancelled: 'Storniert',
    statusPlanned: 'Geplant',
    statusFailed: 'Fehler',
    statusFilterEmpty: 'Keine Einträge mit diesem Status.',
    statusFilterShowAll: 'Alle anzeigen',
    eventWithoutSessions: 'Event ohne Sessions',
    convertParticipantTypeShort: 'Art ändern – bucht in MEWS um',
    detailTabDetails: 'Details',
    detailTabProducts: 'Produkte',
    detailTabMews: 'MEWS & Rechnungen',
    detailTabSystem: 'System',
    forceAllCategoriesConfirmOn: 'F\u00fcr diese Veranstaltung aktivieren?',
    forceAllCategoriesConfirmOff: 'F\u00fcr diese Veranstaltung wieder deaktivieren?',
    forceAllCategoriesNowOn: 'Kategorien\u00fcbergreifendes F\u00fcllen ist f\u00fcr diese Veranstaltung aktiv.',
    forceAllCategoriesNowOff: 'Kategorien\u00fcbergreifendes F\u00fcllen ist f\u00fcr diese Veranstaltung deaktiviert.',
    costObject: 'Kostenträger',
    roomSetup: 'Bestuhlung',
    today: 'Heute',
    spacesCount: 'Räume',
    sessionsCount: 'Sessions',
    openBookingPlan: 'Belegungsplan öffnen',
    updatedAnyTime: 'Beliebige Zeit',
    updatedFilterTitle: 'Zuletzt geändert',
    updatedFilterShort: 'Geändert',
    updatedFilterNote: 'Änderungsdatum der Veranstaltung — nicht ihr Termin. Den Termin wählt der Zeitfilter oben im Kopf.',
    updatedFilterHint: 'Filtert nach dem Änderungsdatum: zeigt, was zuletzt bearbeitet wurde. Der Termin der Veranstaltung wird über den Zeitfilter oben im Kopf gewählt.',
    updatedLast1d: 'Letzte 24 Stunden',
    updatedLast2d: 'Letzte 2 Tage',
    updatedLast3d: 'Letzte 3 Tage',
    updatedLast7d: 'Letzte 7 Tage',
    updatedCustomRange: 'Eigener Zeitraum',
    // Verwalteter Block-Dialog (PUT/DELETE /api/events/:eventId/blocks)
    editBlock: 'Hotel-Block bearbeiten',
    otherCategory: 'andere Kategorie',
    otherCategoryCount: '{n} andere Kategorie',
    crossCategoryHint: 'Andere Kategorie belegt',
    pickupsByCategory: 'Aufnahmen nach Kategorie',
    manageBlock: 'Block verwalten',
    selectBlockToEdit: 'Block zum Bearbeiten wählen',
    editBlockMewsHint: 'Zuerst wird die Verfügbarkeit geprüft. Kann MEWS die Änderung nicht bestätigen, bleibt der bestehende Block unverändert.',
    editBlockDbOnlyHint: 'Kein MEWS-Block verknüpft — Änderung nur in der Datenbank.',
    editBlockNotInMewsTitle: 'Nicht in MEWS angelegt',
    editBlockNeedsHealHint: 'Dieser Block konnte in MEWS nicht angelegt werden. Das Bearbeiten der Daten hier aktualisiert nur die Datenbank — MEWS wird nicht erneut versucht. Bei Bedarf Daten ändern und speichern, dann „Blöcke prüfen & reparieren“ für diese Veranstaltung ausführen, um den Block in MEWS anzulegen.',
    editBlockSuccess: 'Block aktualisiert',
    editBlockDatesRequired: 'Anreise- und Abreisedatum erforderlich',
    editBlockDateOrder: 'Anreise muss vor oder am Abreisedatum liegen',
    editBlockRoomCount: 'Zimmeranzahl muss null oder positiv sein',
    editBlockMewsError: 'MEWS hat die Änderung abgelehnt',
    editBlockConfigError: 'MEWS-Einstellungen der Property fehlen',
    editBlockPeriodHint: 'Der Zeitraum kann verlängert, verkürzt oder verschoben werden. Bestehende Reservierungen behalten ihre eigenen Aufenthaltsdaten.',
    addPeriodGuidance: 'Zum Hinzufügen weiterer Betten nur für einen Teilzeitraum: diesen Block NICHT verkürzen (das ersetzt ihn vollständig). Stattdessen getrennte Blöcke mit nicht überlappenden Zeiträumen anlegen - z. B. 25 für 01.-04., 30 für 05.-06., 25 für 07.-10.',
    // Beim Anlegen gibt es noch keine Reservierungen — der zweite Satz entfällt.
    createBlockPeriodHint: 'Der Zeitraum kann verlängert, verkürzt oder verschoben werden.',
    capacityConflictTitle: 'Geblockte Zimmer über der Teilnehmerobergrenze',
    capacityConflictMsg: 'Diese Veranstaltung hält {rooms} Zimmer, die maximale Teilnehmerzahl liegt bei {max}. Der Statuswechsel lässt sich erst speichern, wenn beide Werte zusammenpassen.',
    capacityConflictRaiseMax: 'Maximale Teilnehmerzahl auf {rooms} erhöhen',
    capacityConflictAdjustRooms: 'Stattdessen Zimmer anpassen',
    blockRoomsOverCapacity: 'Damit werden {rooms} Zimmer gehalten — über der maximalen Teilnehmerzahl ({max}). Die Veranstaltung kann erst in die nächste Stufe wechseln, wenn beide Werte zusammenpassen.',
    editBlockRoomTypeRequired: 'Bitte eine Zimmerkategorie wählen',
    editBlockReplacementRoomsRequired: 'Beim Wechsel der Kategorie oder Ersetzen des Zeitraums muss mindestens ein Zimmer übrig bleiben.',
    editBlockAvailabilityShortfall: 'Nicht genügend Zimmer verfügbar',
    editBlockAvailabilityCheckFailed: 'Die Verfügbarkeit konnte nicht zuverlässig geprüft werden. Der Block wurde nicht geändert.',
    editBlockCategoryExists: 'Für diese Zimmerkategorie besteht bereits ein aktiver Block der Veranstaltung. Zeiträume getrennt anlegen: Basisblock auf die unveränderten Nächte verkürzen und die stärkeren Nächte separat hinzufügen.',
    editBlockCategoryChangeSummary: '{from} wird geschlossen. {rooms} übrige Zimmer wechseln in einen neuen Block {to}. {booked} bestehende Reservierung(en) bleiben auf {from} mit ihrer bestätigten Kategorie.',
    blockManagedFromHotelTab: 'Im Hotel-Tab der Veranstaltung geändert',
    availableRoomsTarget: 'Zimmer übrig',
    roomsLeft: 'Zimmer übrig',
    roomsLeftShort: 'FREI',
    roomsLeftTotalHint: 'Summe der freien Zimmer in aktiven Blöcken',
    roomsRequestedNoHold: 'Zimmer angefragt, kein aktiver Block',
    roomsAwaitingApprovalHint: 'Zimmer angefragt, wartet auf Freigabe',
    approvalAvailabilityLoading: 'Verfügbarkeit wird geprüft …',
    approvalAvailabilityUnavailable: 'Verfügbarkeit konnte nicht geprüft werden',
    approvalAvailabilityPerNight: 'Frei je Nacht',
    approvalAvailabilityBusiestDay: 'frei am vollsten Tag',
    approvalAvailabilityPossible: 'Möglich',
    approvalAvailabilityOverCapacity: 'Überbucht · {count} fehlen',
    approvalAvailabilityOverCapacityTitle: '{requested} Zimmer angefragt, aber am vollsten Tag nur {available} frei. {missing} Zimmer fehlen.',
    debitedReservations: 'abgebuchte Reservierungen',
    roomsLeftAfterSave: 'Zimmer nach dem Speichern übrig',
    debitedRequestedHint: 'Gebuchte Zimmer / Gesamtzuteilung',
    debitedRequestedShort: 'gebucht',
    blockedPerNight: 'Geblockt',
    releaseBlock: 'Block auflösen',
    releaseBlockMenuHint: 'Gehaltene Zimmer gehen zurück in die Verfügbarkeit; Reservierungen bleiben',
    releaseBlockConfirmDelete: 'Dieser Block hat keine Reservierungen. Er wird in MEWS gelöscht, und seine {free} gehaltenen Zimmer gehen zurück in die Verfügbarkeit.',
    releaseBlockConfirmRelease: '{free} freie Zimmer gehen zurück in die Verfügbarkeit. Der Block bleibt mit {booked} Reservierung(en) bestehen, damit sie ihm zugeordnet bleiben.',
    releaseBlockNothingToRelease: 'Alle Zimmer sind gebucht – nichts freizugeben. Der Block bleibt für die Reservierungen bestehen.',
    blockReleasedFromHotelTab: 'Im Hotel-Tab der Veranstaltung aufgelöst',
    releaseBlockSuccessDeleted: 'Block gelöscht. Seine Zimmer sind wieder verfügbar.',
    releaseBlockSuccessReleased: '{free} Zimmer freigegeben. Der Block bleibt für {booked} Reservierung(en) bestehen.',
    releaseBlockSuccessNothing: 'Nichts freigegeben – alle Zimmer des Blocks sind gebucht.',
    releaseBlockFailed: 'Block konnte nicht aufgelöst werden',
    title: 'Veranstaltungsbuchungen',
    newEvent: 'Neue Veranstaltung',
    newInternalEvent: 'Neue interne Veranstaltung',
    new: 'Neu',
    newInquiry: 'Neue Veranstaltung',
    createInquiry: 'Veranstaltung erstellen',
    descriptionPlaceholder: 'z.B. ADG Führungskräfte Seminar',
    partOnSite: 'Vor Ort',
    partOnline: 'Online',
    partHybrid: 'Hybrid',
    newInternal: 'Interne Buchung',
    newEventOption: 'Event',
    createInternalEvent: 'Interne Buchung erstellen',
    internalEventBannerTitle: 'Sie erstellen eine interne Buchung',
    internalEventBannerHint: 'Für interne Belegungen verwenden. MICE-Anfragen werden im MICE-Board erstellt.',
    customFields: 'Eigene Felder',
    addField: 'Feld hinzufügen',
    noCustomFields: 'Noch keine Felder. Klicke "Feld hinzufügen".',
    fieldName: 'Feldname',
    fieldValue: 'Wert',
    editEvent: 'Veranstaltung bearbeiten',
    chargeProducts: 'Produkte belasten',
    chargeToMews: 'An MEWS senden',
    missingAccountingCategory: 'Buchungskategorie fehlt',
    missingTaxCode: 'Steuerschlüssel fehlt',
    noCustomerLinked: 'Kein Kunde mit Event verknüpft',
    noConfirmedParticipants: 'Keine bestätigten Teilnehmer',
    chargeProductsConfirm: 'Alle Produkte dieses Events an MEWS belasten?',
    chargeProductsSuccess: 'Produkte erfolgreich belastet',
    chargeProductsError: 'Produkte konnten nicht belastet werden',
    chargePartial: 'MEWS-Sync mit Hinweisen abgeschlossen',
    chargeNoChanges: 'Keine Änderungen an MEWS notwendig',
    // EH-0038: a run that skipped every line used to report chargeNoChanges,
    // which told the operator all was well while nothing reached MEWS.
    chargeAllSkipped: 'Nichts an MEWS gesendet — alle Positionen übersprungen',
    chargePartialSkipped: 'Teilweise gesendet — einige Positionen übersprungen',
    chargeScopeBlockedProduct: 'Nicht wählbar: Abrechnungsart „{type}" hat keinen Personenbezug. Bitte auf den Kunden buchen oder im Produkt PerPerson bzw. PerPersonPerTimeUnit hinterlegen.',
    chargeScopeBlockedPackage: 'Nicht wählbar: keine Position dieses Pakets hat einen Personenbezug. Bitte auf den Kunden buchen.',
    skippedRowsHeading: 'Übersprungene Positionen',
    skipReasonNoChargeTarget: 'Kein Belastungsziel gewählt — die Spalte „Belasten" steht auf „—".',
    skipReasonChargingType: 'Abrechnungsart „{type}" hat keinen Personenbezug und kann nicht auf Teilnehmer gebucht werden.',
    selectOnePayer: 'Zahler auswählen',
    singlePayerHint: 'Abrechnungsart „{type}" wird einmalig berechnet, nicht pro Person. Bitte genau eine Person auswählen, die diese Position bezahlt — sonst würde sie mehrfach berechnet. Für die ganze Veranstaltung stattdessen auf den Kunden buchen.',
    noCustomerOnEventHint: 'Auf dieser Veranstaltung ist kein Kunde hinterlegt. Kunde in der Übersicht setzen, um Positionen auf den Kunden zu buchen.',
    skipReasonPackageAll: 'Keine Position dieses Pakets hat einen Personenbezug — nichts davon kann auf Teilnehmer gebucht werden.',
    skipReasonPackagePartial: '{incompatible} von {total} Produkten in diesem Paket haben keinen Personenbezug und werden nicht an MEWS gesendet. Es werden KEINE Teilnehmer übersprungen. Abhilfe: das Paket dem Kunden berechnen, oder die Abrechnungsart dieser Produkte auf PerPerson / PerPersonPerTimeUnit ändern.',
    packageProductsSkippedBadge: '{incompatible}/{total} Produkte übersprungen',
    unnamedProduct: 'Unbenanntes Produkt',
    unnamedPackage: 'Unbenanntes Paket',
    chargeToMewsAllPending: 'Alle offenen Belastungen und Stornos dieses Events an MEWS senden',
    chargeToMewsThisLine: 'Diese Zeile an MEWS senden',
    chargeToMewsAllShort: 'Alle senden',
    chargeResult: 'MEWS-Sync Ergebnis',
    charged: 'Belastet',
    canceledLabel: 'Storniert',
    lockedAfterMewsCharge: 'Bereits an MEWS belastet. Zum Ändern bitte diese Zeile stornieren und neu anlegen.',
    chargeConfirmTitle: 'An MEWS übermitteln',
    chargeConfirmMessage: 'Die ausgewählten Produkte werden auf das Gastkonto in MEWS belastet. Nach der Belastung können diese Bestellungen nicht mehr geändert werden.',
    chargeConfirmWarning: 'Um nach der Belastung Änderungen vorzunehmen, muss der belastete Posten storniert und neu angelegt werden.',
    chargeConfirmButton: 'Jetzt belasten',
    chargingProducts: 'Belaste...',
    accountableProduct: 'In MEWS abrechenbar',
    nonAccountableProduct: 'Nicht abrechenbar - keine MEWS-Produkt-ID',
    customOrderHint: 'Wird als individuelle Bestellung in MEWS belastet (kein verknüpftes MEWS-Produkt)',
    chargeable: 'Abrechenbar',
    notChargeable: 'Nicht abrechenbar',
    bills: 'Rechnungen',
    viewBills: 'Rechnungen anzeigen',
    reservationProducts: 'Reservierung',
    customerProducts: 'Kunde',
    mewsReceipts: 'MEWS-Belege',
    mewsReceiptsHint: 'Rohdaten aus MEWS',
    openMewsReceipt: 'MEWS-Beleg öffnen',
    openOtherBills: 'Rechnungen des Gastes öffnen',
    mewsProductsTitle: 'MEWS Produkte',
    otherCustomer: 'Anderer Kunde',
    otherCustomerWarning: 'Diese Positionen liegen auf einer anderen Kundenkarte — etwa beim bisherigen Gast nach einem Gasttausch, bei einer früheren Firma nach einem Wechsel des Rechnungsempfängers oder auf einer durch einen Typwechsel (Hotel ↔ Tagesgast) ersetzten Reservierung. In MEWS öffnen, um sie zuzuordnen.',
    billsFor: 'Rechnungen für',
    noBillsFound: 'Keine Rechnungen für diesen Teilnehmer',
    billCreated: 'Erstellt',
    billIssued: 'Ausgestellt',
    billDue: 'Fällig',
    billPaid: 'Bezahlt',
    generating: 'Wird erstellt...',
    hidePdf: 'PDF ausblenden',
    previewPdf: 'PDF Vorschau',
    openInTab: 'Im Tab öffnen',
    billNotClosed: 'PDF verfügbar sobald die Rechnung abgeschlossen ist',
    billStayRoom: 'Zimmer',
    billItems: 'Posten',
    billOtherStay: 'Aufenthalt außerhalb dieser Veranstaltung',
    billStayCancelled: 'Aufenthalt storniert — Rechnung bleibt',
    billNoStay: 'Keine Übernachtung auf dieser Rechnung',
    billNoStayTitle: 'Diese Rechnung enthält Produkte, aber keine Übernachtung. Sie ist keinem Aufenthalt zugeordnet.',
    billUnbilledTitle: 'Unbezahlte Posten',
    billUnbilledBadge: 'Auf keiner Rechnung',
    billUnbilledHint: 'In MEWS als „Unbezahlte Posten / Anzahlungen“ geführt. Eine Belastung landet hier, wenn keine Aufenthaltsrechnung ermittelt werden konnte — im Fehlerprotokoll nach chargeProducts:noBillTarget suchen.',
    closeBill: 'Rechnung abschliessen',
    closingBill: 'Wird abgeschlossen...',
    billUnpaidTitle: 'Offener Betrag',
    billUnpaidError: 'Diese Rechnung hat einen offenen Betrag und kann nicht abgeschlossen werden. Bitte zuerst die Zahlung in MEWS ausgleichen.',
    billCloseError: 'Rechnung konnte nicht abgeschlossen werden',
    assignTags: 'Tags zuweisen',
    allTagsAssigned: 'Alle Tags zugewiesen',
    files: 'Dateien',
    uploadFile: 'Datei hochladen',
    uploading: 'Wird hochgeladen...',
    noFiles: 'Keine Dateien angehängt',
    confirmDeleteFile: 'Möchten Sie diese Datei wirklich löschen?',
    noPreview: 'Vorschau für diesen Dateityp nicht verfügbar',
    deleteEvent: 'Veranstaltung löschen',
    deleteEventMenuHint: 'Veranstaltung und alles Verknüpfte endgültig löschen',
    eventName: 'Veranstaltungsname',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    arrivalTime: 'Anreisezeit',
    departureTime: 'Abreisezeit',
    location: 'Standort',
    maxAttendees: 'Max. Teilnehmer',
    currentAttendees: 'Aktuelle Teilnehmer',
    searchEvents: 'Veranstaltungen suchen...',
    noEventsFound: 'Keine Veranstaltungen gefunden',
    createFirstEvent: 'Erste Veranstaltung erstellen',
    confirmedParticipants: 'Teilnehmer bestätigt',
    confirmedParticipantsHint: 'Bestätigte Teilnehmer (Hotel + Tagesgäste) der angezeigten Veranstaltungen. Interne (ADG) Online-Teilnehmer zählen nicht mit.',
    totalEvents: 'Alle Events',
    eventsInPeriod: 'Events im Zeitraum',
    tabDetails: 'Details',
    eventsInPeriodHint: 'Veranstaltungen im gewählten Zeitraum',
    filterUnseen: 'Ungesehen',
    filterUnseenHint: 'Nur von dir ungesehene Veranstaltungen',
    filterChanged: 'Geändert',
    filterChangedHint: 'Seit deiner letzten Ansicht geänderte Veranstaltungen',
    acknowledged: 'Gesehen',
    acknowledgedHint: 'Gesehen-Status dieser Veranstaltungen für dich',
    ackUnseen: 'ungesehen',
    ackUnavailable: 'nicht verfügbar',
    ackSeen: 'Gesehen',
    ackChanged: 'Geändert',
    hotelShort: 'Hotel',
    errorShort: 'Fehler',
    erroredPickups: 'Fehlerhafte Buchungen',
    spaceBookings: 'Raumbuchungen',
    definiteEvents: 'Definitiv',
    inquiryEvents: 'Anfragen',
    allStatus: 'Alle Status',
    allStreams: 'Alle Streams',
    allTypes: 'Alle Typen',
    allBuildings: 'Alle Gebaeude',
    allCostCenters: 'Alle Kostenstellen',
    allSalespersons: 'Alle Verkäufer',
    allCustomers: 'Alle Kunden',
    allProductManagers: 'Alle Produktmanager',
    allEventManagers: 'Alle Eventmanager',
    allTags: 'Alle Tags',
    onlyNew: 'Nur kommende',
    showPast: 'Vergangene',
    showPastHint: 'Auch bereits beendete Events anzeigen',
    showCancelled: 'Stornierte',
    showCancelledHint: 'Auch stornierte / verlorene Events anzeigen',
    onlyNewHint: 'Zeigt nur aktuelle und kommende Veranstaltungen (beendete werden ausgeblendet)',
    overviewTab: 'Übersicht',
    basicInfo: 'Grundinformationen',
    pastEvent: 'Vergangenes Event',
    daysUntilEvent: 'noch {n} Tag | noch {n} Tage',
    pastEventDisabled: 'Nicht verfügbar für vergangene Events',
    ongoingEvent: 'Laufend',
    ongoingEventDisabled: 'Nicht verfügbar für laufende Events',
    onlyMiceInternal: 'Nur für MICE und interne Events verfügbar',
    missingFields: 'Pflichtfelder fehlen',
    pleaseComplete: 'Bitte korrigieren Sie folgende Punkte:',
    validationRequired: 'erforderlich',
    validationDescriptionMin: 'Beschreibung muss mindestens 4 Zeichen lang sein',
    validationMinOne: 'muss mindestens 1 sein',
    validationMaxGteMin: 'muss größer oder gleich Min sein',
    validationOvernightRange: 'muss zwischen {min} und {max} liegen',
    validationDateChangeWithReservations: 'Datum kann nicht geändert werden, solange Reservierungen existieren. Bitte zuerst alle Reservierungen löschen, dann das Datum ändern.',
    validationOvernightSingleDay: 'Eintägige Veranstaltung mit Übernachtungsgästen: Bitte entweder „Voranreise" aktivieren (1 Nacht), Übernachtungsgäste auf 0 setzen oder das Enddatum verlängern.',
    savingHint: 'Dies kann einige Sekunden dauern …',
    noChangesToSave: 'Keine Änderungen zum Speichern',
    savingStageEvent: 'Veranstaltung wird gespeichert …',
    savingStageMews: 'Zimmerblock wird in MEWS angelegt …',
    savingStageSpaces: 'Räume werden gebucht …',
    savingStageAlmostDone: 'Gleich fertig …',
    overnightWarningTitle: 'Keine Übernachtungsgäste',
    overnightWarningMessage: 'Übernachtungsgäste ist auf 0 gesetzt. Für diese Veranstaltung werden keine Zimmerblöcke benötigt.',
    overnightWarningConfirm: 'OK, speichern',
    spaceBookingsDroppedTitle: 'Raumbuchungen entfernt',
    spaceBookingsDroppedMessage: 'Durch die Datumsänderung wurden {count} Raumbuchung(en) entfernt, die nicht auf die neuen Daten verschoben werden konnten. Bitte füge sie im Tab „Räume“ erneut hinzu.',
    spaceMoveRefusedTitle: 'Räume nicht verschoben',
    spaceMoveRefusedMessage: 'Die Veranstaltung wurde gespeichert, die Räume aber nicht verschoben: Mindestens ein Raum ist im neuen Zeitraum bereits belegt. Die Räume stehen noch auf dem alten Zeitraum. Bitte prüfe sie im Tab „Räume“.',
    stream: 'Stream',
    timeline: 'Zeitachse',
    tags: 'Tags',
    addTag: 'Tag hinzufügen',
    noTags: 'Keine Tags zugewiesen',
    eventLogs: 'Ereignisverlauf',
    noLogs: 'Keine Aktivität aufgezeichnet',
    moreFilters: 'Weitere Filter',
    clearFilters: 'Filter löschen',
    resetFilters: 'Filter zurücksetzen',
    fromDate: 'Von Datum',
    toDate: 'Bis Datum',
    type: 'Typ',
    dates: 'Datum',
    pax: 'PAX',
    crowdRelaxed: 'Entspannt',
    crowdMedium: 'Mittel',
    crowdBusy: 'Voll',
    lunch: 'Mittagessen',
    lunchNotSelected: 'nicht gewählt',
    inquiry: 'Anfrage',
    qualify: 'Qualifizieren',
    proposal: 'Angebot',
    tentative: 'Vorläufig',
    definite: 'Definitiv',
    closedLost: 'Verloren',
    cancelled: 'Storniert',
    meeting: 'Besprechung',
    conference: 'Konferenz',
    wedding: 'Hochzeit',
    offsite: 'Offsite',
    kickoff: 'Kickoff',
    firmenevent: 'Firmenevent',
    privateParty: 'Private Feier',
    christmasParty: 'Weihnachtsfeier',
    teamEvent: 'Teamevent',
    sonstiges: 'Sonstiges',
    // Interne Veranstaltungstypen (D132/D136) — nur im Internal-Create-Dropdown
    internalTypeEventMeal: 'Veranstaltung inkl. Mahlzeit',
    internalTypeMeeting: 'Meeting',
    internalTypeWorkshop: 'Workshop',
    internalTypeMeetingWorkshop: 'Meeting / Workshop',
    internalTypeRoomBlock: 'Raumsperrung',
    internalTypeSport: 'Sport',
    forecastedRevenue: 'Erwarteter Umsatz',
    listView: 'Listenansicht',
    calendarView: 'Kalenderansicht',
    setToQualify: 'Qualifizieren',
    advanceToStage: 'Weiter zu {stage}',
    moveToStage: 'Status auf „{stage}“ setzen',
    tentativeViaBoard: 'Tentativ mit Optionsfrist — über das MICE-Board setzen',
    makeProposal: 'Angebot',
    confirmStatusChange: 'Statusänderung bestätigen',
    confirmStatusChangeMsg: 'Status von "{name}" von {from} auf {to} ändern?',
    statusChanged: 'Status erfolgreich geändert',
    proposalWarningsTitle: 'Bitte beachten Sie vor dem Fortfahren:',
    warningNoSpaceBooking: 'Dieses Event hat noch keine Raumbuchungen.',
    warningNoPmsBlock: 'Dieses Event hat Übernachtungsgäste, aber keinen Hotel-Zimmerblock konfiguriert.',
    cancelEvent: 'Event absagen',
    cancelEventMenuHint: 'Veranstaltung als abgesagt markieren; sie bleibt erhalten',
    cancelEventTitle: 'Event absagen',
    cancelEventMsg: 'Wie soll "{name}" abgesagt werden?',
    cancelByAdg: 'ADG hat entschieden, nicht fortzufahren',
    cancelByCustomer: 'Kunde hat das Event abgesagt',
    revertToInquiry: 'Zurück auf Anfrage setzen',
    revert: 'Zurücksetzen',
    cannotRevertToInquiry: 'Diese Veranstaltung hat bereits Zimmerblöcke oder Teilnehmer und kann nicht auf „Anfrage“ zurückgesetzt werden. Bitte vorwärts bewegen oder stornieren.',
    cancelReason: 'Grund der Absage',
    cancelEventLede: 'Verknüpfte Hotelreservierungen und MEWS-Blöcke werden atomar storniert. Dies wird dauerhaft im Audit-Protokoll erfasst.',
    cancelImpactTitle: 'Was passiert',
    cancelImpactEvent: 'Event-Status wird auf „abgesagt" (oder „verloren") gesetzt.',
    cancelImpactReservations: 'verknüpfte Hotelreservierung(en) werden storniert — aktive MEWS-Reservierungen werden auch in MEWS storniert.',
    cancelImpactBlocks: 'MEWS-Hotelblöcke werden freigegeben (in MEWS gelöscht, in unserer DB als storniert markiert).',
    cancelImpactSpacesPackagesProducts: 'Raumbuchungen, Pakete und nicht berechnete Produkte werden als storniert markiert. Bereits abgerechnete Produkte bleiben erhalten.',
    cancelImpactAudit: 'Ein Audit-Log-Eintrag wird mit dem unten angegebenen Grund erstellt.',
    sendConfirmationEmail: 'Bestätigungs-E-Mail an Gast senden',
    sendCancellationEmail: 'Stornierungs-E-Mail an Gast senden',
    chargeCancellationFee: 'Zimmer-Storno berechnen (MEWS)',
    feeChargesTitle: 'Storno- / No-Show-Gebühren',
    feeChargedStatus: 'Verrechnet',
    chargeProductStorno: 'Storno für Produkte berechnen (F&B, Equipment, Räume)',
    productStornoFree: 'Noch vor der ersten Stornostufe — keine Produkt-Stornogebühr.',
    productStornoNothing: 'Keine Produkte, die berechnet werden.',
    productStornoMissingSettings: 'Storno-Produkte fehlen in der Administration — die Stornierung wird abgelehnt.',
    productStornoUnreadable: '{n} Produktzeile(n) ohne Preis — die Stornierung wird abgelehnt.',
    stornoFeeChoice: 'Stornogebühr',
    stornoWithFee: 'Mit Stornogebühr',
    stornoWithFeeHint: 'Zimmer: MEWS storniert mit seiner Stornogebühr · Produkte: Storno nach der Stornoregel der Rate',
    stornoWithoutFee: 'Ohne Stornogebühr',
    stornoWithoutFeeHint: 'MEWS storniert ohne Gebühr · alle Produkte werden storniert',
    stornoRate: 'Rate',
    stornoRule: 'Stornoregel',
    stornoSince: 'gilt seit {at}',
    stornoRoom: 'Zimmer',
    stornoRoomByMews: 'nach dieser Stornoregel — Betrag berechnet MEWS',
    stornoProducts: 'Produkte',
    stornoTotal: 'Summe Produkte',
    cancelReasonPlaceholder: 'Bitte geben Sie einen Grund für die Absage an...',
    cancelReasonCategory: 'Absagegrund',
    cancelReasonDetails: 'Details zur Absage',
    cancelActionHint: 'Bitte Grund auswählen und Details angeben, um die Absage auszuführen.',
    selectReason: 'Grund auswählen',
    reasonBudget: 'Budget/Kosten',
    reasonDate: 'Terminkollision',
    reasonVenue: 'Veranstaltungsort',
    reasonCovid: 'COVID-19',
    reasonOther: 'Sonstiges',
    revenue: 'Umsatz',
    hotelGuests: 'Hotelgäste',
    setTentative: 'Tentativ',
    setTentativeTitle: 'Auf Tentativ setzen',
    tentativeMsg: '"{name}" auf Tentativ setzen?',
    tentativeProposalSent: 'Ich bestätige, dass das Angebot an den Kunden gesendet wurde',
    tentativeDeadline: 'Entscheidungsfrist Kunde',
    tentativeDeadlineHint: 'Optional — leer lassen wenn keine Frist vereinbart',
    setDefinitive: 'Definitiv',
    options: 'Optionen',
    optionsTitle: 'Event Optionen — PMS Blöcke',
    noBlocksFound: 'Keine PMS-Blöcke für dieses Event gefunden.',
    blockStatus: 'Status',
    blockRoomCount: 'Zimmeranzahl',
    moreActions: 'Weitere Aktionen',
    reloadData: 'Daten neu laden',
    viewVenueMap: 'Lageplan anzeigen',
    loadingEventData: 'Lade Veranstaltungsdaten...',
    error: 'Fehler',
    eventNameCol: 'Veranstaltungsname',
    category: 'Stream',
    daysCol: 'Tage',
    status: 'Status',
    roomsBooked: 'Räume',
    lastUpdated: 'Aktualisiert',
    // ── Whiteboard (kernboards-Integration auf Raumbuchungen) ──
    whiteboard: 'Whiteboard',
    startWhiteboard: 'Whiteboard starten',
    openWhiteboard: 'Whiteboard öffnen',
    noWhiteboard: 'Kein Whiteboard verknüpft',
    openInNewTab: 'In neuem Tab öffnen',
    updateWhiteboardUrl: 'URL aktualisieren',
    whiteboardPasteHint: 'Speichere das Whiteboard in kernboards, kopiere die URL aus dem Browser-Tab und füge sie hier ein:',
    whiteboardUrlInvalid: 'Bitte eine gültige kernboards-URL einfügen.',
    whiteboardSaveError: 'Speichern fehlgeschlagen',
    modifiedBy: 'Geändert von',
    // ── Regel-erzeugte Produkte in den Event-Tabs ──
    rule: 'Regel',
    rulePackage: 'Regel-Paket',
    ruleBundleHint: 'Per Regel erzeugt — wird als ein MEWS-Auftrag gebündelt',
    ruleIndividualHint: 'Per Regel erzeugt — einzeln berechnet',
    rulesWillFire: 'Regeln werden ausgelöst',
    ruleWillFireSingular: 'Regel wird beim Pickup automatisch ausgelöst',
    rulesWillFirePlural: 'Regeln werden beim Pickup automatisch ausgelöst',
    rulePreviewHint: 'Wird automatisch hinzugefügt, wenn Teilnehmer anreisen oder abreisen',
    rulePreviewClickHint: 'Klicken, um zu sehen, welche Produkte diese Regel hinzufügt',
    reapplyRules: 'Regeln auf bestehende Teilnehmer anwenden',
    reapplyRulesHint: 'Regeln greifen beim Pickup. Eine später angelegte Regel erreicht bereits erfasste Teilnehmer nicht. Hier werden sie einmalig jetzt angewendet.',
    reapplyRulesConfirmTitle: 'Regeln auf bestehende Teilnehmer anwenden?',
    reapplyRulesConfirmBody: 'Die Regeln laufen für {count} von {total} Teilnehmern (bestätigt und mit Zimmer). Bereits verrechnete Positionen werden übersprungen. Neue Positionen werden in MEWS gebucht und lassen sich dort nicht automatisch zurücknehmen.',
    reapplyRulesNoneEligible: 'Kein Teilnehmer dieser Veranstaltung ist bestätigt und hat ein Zimmer — es gibt nichts anzuwenden.',
    reapplyRulesDone: 'Regeln auf {count} Teilnehmer angewendet.',
    reapplyRulesFailed: 'Regeln konnten nicht angewendet werden: {error}',
    ruleChargedAsPackage: 'wird als Paket gebucht',
    ruleRateScopeHint: 'Nur für diese Rate — die Regel feuert ausschließlich bei Pickups auf dieser Rate',
    firesOn: 'Auslöser',
    // Used when a rule_product has no arrival/departure trigger — the
    // backend still fires the rule for every night of stay (daily charge),
    // so the chip needs to say so rather than imply "won't fire".
    ruleDaily: 'Täglich',
    ruleDailyHint: 'Wird für jede Übernachtung berechnet (kein Anreise-/Abreise-Auslöser)',
    noRulesActivated: 'Keine Regel aktiviert',
    noRulesActivatedHint: 'Keine aktive Regel passt zum Event-Stream und Datum',
    triggerArrivalMorning: 'Anreise vormittags',
    triggerArrivalAfternoon: 'Anreise nachmittags',
    triggerDepartureMorning: 'Abreise vormittags',
    triggerDepartureAfternoon: 'Abreise nachmittags',
    entriesPerPage: 'Einträge pro Seite',
    pageOf: 'Seite {current} von {total}',
    eventsCount: '{count} Veranstaltungen',
    previous: 'Zurück',
    next: 'Weiter',
    attendees: 'Teilnehmer',
    teilnehmerTab: 'Teilnehmer',
    teilnehmerAll: 'Alle',
    teilnehmerDayguest: 'Tagesgäste',
    teilnehmerExternal: 'Extern',
    teilnehmerLecturer: 'Dozenten',
    teilnehmerSearch: 'Teilnehmer suchen...',
    teilnehmerOf: '{filtered} von {total} Teilnehmer',
    teilnehmerName: 'Name',
    teilnehmerEmail: 'E-Mail',
    teilnehmerType: 'Typ',
    teilnehmerArrival: 'Anreise',
    teilnehmerDeparture: 'Abreise',
    teilnehmerRoom: 'Zimmer',
    teilnehmerStatus: 'Status',
    teilnehmerAdded: 'Hinzugefügt',
    teilnehmerAddedHint: 'Wann dieser Teilnehmer hinzugefügt wurde',
    retrySync: 'Erneut versuchen',
    retrySyncSuccess: 'Synchronisation erfolgreich',
    retrySyncFailed: 'Synchronisation fehlgeschlagen',
    retrySyncSuccessDetail: 'Die Reservierung für {name} wurde erfolgreich mit dem PMS synchronisiert. Der Status wurde aktualisiert.',
    retrySyncFailedDetail: 'Die Reservierung für {name} konnte nicht mit dem PMS synchronisiert werden.',
    retrySyncHint: 'Dies kann passieren, wenn das PMS vorübergehend nicht erreichbar ist, das Gästeprofil fehlt oder der Zimmertyp nicht konfiguriert ist. Prüfen Sie die Fehlerdetails und versuchen Sie es später erneut, oder kontaktieren Sie einen Administrator.',
    retrySyncPastReservation: 'Die Anreise dieser Reservierung liegt in der Vergangenheit. MEWS kann für vergangene Tage kein Zimmer mehr aus dem Block ziehen — bitte Anreisedatum anpassen oder die Reservierung manuell in MEWS anlegen.',
    teilnehmerTypeOnline: 'Online',
    // Hand-pick list: online participants are never charged (blocksPayerPick).
    onlineNotCharged: 'online – wird nicht belastet',
    // … and neither are failed hotel pickups nor settled no-shows (EH-0186).
    noRoomNotCharged: 'ohne Zimmer – wird nicht belastet',
    noShowNotCharged: 'No-Show – wird nicht belastet',
    noBoardNotCharged: 'keine Leistungen – wird nicht belastet',
    // Why a hand-picked person on a line not charged yet is not billed (row label, participants list).
    notBilledNoRoom: 'ohne Zimmer',
    notBilledNoShow: 'No-Show',
    notBilledNoBoard: 'keine Leistungen',
    lifecycleCanceled: 'Storniert',
    lifecycleCapacityExceeded: 'Kapazität überschritten',
    lifecycleFailed: 'Fehlgeschlagen',
    linkedStayBadge: 'Verknüpft ({n})',
    linkedStayTooltipBasic: 'Diese Reservierung ist Teil einer Mehr-Event-Buchung.',
    linkedStayTooltipIntro: 'Dieser Gast bleibt auch für:',
    linkedStayTooltipOutro: 'Eine MEWS-Reservierung, ein Check-in, ein Check-out.',
    linkedStayCancelTitle: 'Teil einer verknüpften Buchung ({n} Events)',
    linkedStayCancelHint: 'Wird storniert, schrumpft die MEWS-Reservierung um die Nächte dieses Events. Buchungen der anderen Events bleiben bestehen.',
    allFields: 'Alle Felder',
    checkInAction: 'Einchecken',
    syncCancelFromMews: 'Übernehmen',
    syncCancelFromMewsTitle: 'In EventHub als storniert markieren (MEWS bereits storniert)',
    syncCancelFromMewsFailed: 'Übernahme fehlgeschlagen',
    roomNoLongerBlocked: 'Zimmer nicht mehr geblockt — Reservierung storniert',
    editPriceTitle: 'Zimmerpreis bearbeiten',
    priceCurrent: 'Aktuell',
    priceNew: 'Neuer Preis pro Nacht',
    priceNewPlaceholder: 'z.B. 145,00',
    pricePerNightHint: 'Wird auf jede Übernachtung angewandt.',
    setPrice: 'Preis setzen',
    priceCol: 'Preis',
    checkInToday: 'Heutige Anreisen einchecken',
    checkInTodayTitle: 'Alle Gäste mit Anreise heute einchecken',
    checkInSuccess: 'Eingecheckt',
    checkInFailed: 'Check-in fehlgeschlagen',
    checkInPartial: 'Check-in teilweise erfolgreich',
    checkInNoop: 'Niemand einzuchecken',
    checkInNoopDetail: 'Aktuell sind keine Teilnehmer für den Check-in berechtigt.',
    alreadyCheckedIn: 'Bereits eingecheckt',
    checkInCheckedIn: 'Eingecheckt',
    checkInFailedList: 'Fehlgeschlagen',
    checkInSkipped: 'Übersprungen',
    teilnehmerTypeDayguest: 'Tagesgast',
    teilnehmerTypeExternal: 'Extern',
    teilnehmerSummaryCancelled: 'storniert',
    teilnehmerTypeHotel: 'Hotel',
    // D164/PBI 2922: internal events call the online (never-sent-to-MEWS)
    // participant "Intern (ADG)". Only used when event_stream === 'internal'.
    internalAdgGuest: 'Intern (ADG)',
    teilnehmerTypeLecturer: 'Dozent',
    teilnehmerEmpty: 'Keine Teilnehmer gefunden',
    to: 'bis',
    days: 'Tage',
    fullEvent: 'Gesamtes Event',
    fullEventDesc: 'Alle Sessions und Eventdetails',
    session: 'Session',
    roomBlocks: 'Zimmerblöcke',
    subBlock: 'Unterblock',
    subBlocks: 'Unterblöcke',
    individualReservations: 'Hotelgäste',
    dayGuests: 'Tagesgäste',
    noDayGuests: 'Noch keine Tagesgäste',
    externalGuests: 'Extern',
    noExternalGuests: 'Noch keine externen Gäste',
    totalRooms: 'Zimmer gesamt',
    noSpaceBookings: 'Keine',
    noSpaceAssignedAlert: 'Kein Raum zugewiesen — für diese Daten war keiner frei. Bitte im Raum-Tab zuweisen.',
    // EH-0171: Räume-Tab, eine graue Zeile für die mit der Veranstaltung stornierten Buchungen.
    cancelledSpaceBookingsOne: '1 Raumbuchung storniert ({rooms}) — hält keinen Raum',
    cancelledSpaceBookingsMany: '{count} Raumbuchungen storniert ({rooms}) — halten keinen Raum',
    // D133/D145: Rate ist Pflichtfeld, nichts vorausgewählt.
    rateSelectPlaceholder: '— Rate wählen —',
    noRatesConfigured: 'Für diesen Gasttyp sind auf dieser Property keine Raten konfiguriert.',
    dayguestRatesUnidentified: 'Tagesgast-Raten konnten nicht identifiziert werden (MEWS-Ratenabgleich ausstehend) — es werden alle Raten angezeigt.',
    dayguestRateLockedHint: 'Tagesgäste und Externe buchen auf der Tagesgast-Rate — nicht änderbar.',
    eventCheck: 'Event-Check',
    spaceCapacityWarning: 'Zu klein',
    booked: 'gebucht',
    // Overview-Badge für Zimmerblöcke. Nur 'blocksHeld' bedeutet, dass MEWS die
    // Zimmer wirklich hält — das Hotel erzeugt den Hold erst bei der Freigabe.
    // Ein Block bei Anfrage/Qualifizierung hält nichts und darf nicht als
    // "gebucht" erscheinen.
    blocksHeld: 'gehalten',
    blocksHeldPartial: '{held}/{total} gehalten',
    blocksRequested: 'wartet auf Freigabe',
    blocksDraft: 'Entwurf — kein Hold',
    blocksClosed: 'freigegeben',
    // Siehe en.ts: Statuswechsel hat funktioniert, nur der Verlaufseintrag
    // fehlt. Wichtig ist, dass niemand den Wechsel wiederholt.
    statusChangedButNotLogged: 'Der Status wurde geändert, konnte aber nicht im Verlauf gespeichert werden. Die Änderung selbst war erfolgreich — bitte nicht wiederholen und den Fehler melden.',
    syncFailed: 'fehlgeschlagen',
    hotelBlockOk: 'Hotelblock ok',
    hotelBlockFailed: 'Hotelblock benötigt Aufmerksamkeit',
    hotelBlockCreated: 'Erstellt',
    hotelBlockConfirmed: 'Bestätigt',
    hotelBlockNoAvailability: 'Keine Verfügbarkeit',
    hotelBlockNone: 'Kein Hotelblock',
    allHotelStates: 'Alle Hotelblöcke',
    night: 'Nacht',
    pending: 'Ausstehend',
    addSpaceBooking: 'Raumbuchung hinzufügen',
    spaceBookingInquiryHint: 'Keine Raumbuchung bei verlorenen oder stornierten Events',
    reservation: 'Reservierung',
    addReservation: 'Reservierung hinzufügen',
    addParticipant: 'Teilnehmer hinzufügen',
    filterOnlyOpenTasks: 'Nur Veranstaltungen mit mindestens einer offenen Aufgabe',
    removeFilter: 'Filter entfernen',
    phEventName: 'z.B. ADG Führungskräfte Seminar',
    phEventModule: 'z.B. Modul 3',
    phCostCenter: 'z.B. 220103',
    exportParticipants: 'Als Excel exportieren',
    exportColName: 'Name',
    exportColType: 'Typ',
    exportColLecturer: 'Dozent',
    exportColInvoiceOwner: 'Rechnungsempfänger',
    exportColArrival: 'Anreise',
    exportColDeparture: 'Abreise',
    exportColNights: 'Nächte',
    exportColRoomCategory: 'Zimmerkategorie',
    exportColRoom: 'Zimmer',
    exportColRate: 'Rate',
    exportColAdults: 'Erwachsene',
    exportColChildren: 'Kinder',
    exportColStatus: 'Status',
    exportColMewsId: 'MEWS-Reservierung',
    groupEditor: 'Gruppen-Editor',
    groupEditorHint: 'Alle Teilnehmer in einem Rutsch bearbeiten und neue hinzufügen.',
    groupEditorTitle: 'Gruppen-Editor',
    groupEditorSubtitle: 'Bearbeite bestehende Teilnehmer und lege neue an. Speichere alles gemeinsam.',
    groupEditorEmpty: 'Noch keine Teilnehmer — füge welche hinzu.',
    groupEditorAddRow: 'Neuen Teilnehmer hinzufügen',
    groupEditorUpdatedLabel: 'zu ändern',
    groupEditorAddedLabel: 'neu',
    groupEditorRowSaved: 'Gespeichert',
    groupEditorRowFailed: 'Fehlgeschlagen',
    groupEditorRowSaving: 'Speichert…',
    groupEditorRowQueued: 'Wartet…',
    groupEditorRateMissing: '{n} ohne Rate',
    rateRequiredHint: 'Rate ist erforderlich',
    groupEditorNameRequired: 'Name fehlt — Zeile wurde nicht gebucht',
    groupEditorTypeLocked: 'Typ nur bei neuen Teilnehmern wählbar. Bestehende in den Teilnehmer-Details über ⋯ → „Teilnehmerart“ umbuchen.',
    groupEditorAllOk: '{u} aktualisiert · {a} neu hinzugefügt.',
    groupEditorReposting: 'Bereits berechnete Produkte von {n} Teilnehmer(n) werden geprüft und bei Bedarf neu gebucht.',
    groupEditorPartial: '{u} aktualisiert · {a} neu · {f} fehlgeschlagen:',
    newParticipantPlaceholder: 'Vor- und Nachname',
    creatingParticipant: 'Teilnehmer wird erstellt...',
    pleaseWait: 'Dies kann einen Moment dauern, bitte warten.',
    searchBooker: 'Bucher in MEWS suchen (mind. 4 Zeichen)...',
    bookerOptional: 'Bucher (optional)',
    searchCompany: 'Firma aus MEWS auswählen...',
    addRoomBlock: 'Zimmerblock hinzufügen',
    dateAndTime: 'Datum & Uhrzeit',
    space: 'Raum',
    setup: 'Aufbau',
    actions: 'Aktionen',
    customName: 'Bezeichnung',
    customNamePlaceholder: 'z.B. Workshop-Raum A',
    customPrice: 'Preis',
    spaceDefault: 'Standard',
    spacePrice: 'Raumpreis',
    spaceTotal: 'Gesamt',
    perDayShort: 'Tag',
    room: 'Fläche',
    list: 'Liste',
    calendar: 'Kalender',
    timelineView: 'Zeitstrahl',
    rooms: 'Zimmer',
    nights: 'Nächte',
    guest: 'Gast',
    guests: 'Gäste',
    noRoom: 'Kein Raum',
    spaceNotConfirmedYet: '{n} Raumbuchung(en) noch nicht bestätigt',
    noSpace: 'Kein Raum',
    slimSessionHint: 'Pax und Bestuhlung werden aus der Buchung unten übernommen.',
    noRoomBlocks: 'Keine Blöcke',
    reservations: 'Reservierungen',
    mismatch: 'Abweichung',
    synced: 'Synchronisiert',
    noReservations: 'Noch keine Reservierungen',
    mews: 'MEWS',
    syncedWithMews: 'Mit MEWS synchronisiert',
    notSynced: 'Nicht synchronisiert',
    notSyncedWithMews: 'nicht mit MEWS verknüpft',
    openInMews: 'In MEWS öffnen',
    openBlockInMewsHint: 'Diesen Block im MEWS Commander öffnen',
    deleteReservation: 'Reservierung löschen',
    name: 'Name',
    email: 'E-Mail',
    phone: 'Telefon',
    checkedIn: 'Eingecheckt',
    dietary: 'Diät',
    serviceTime: 'Servicezeit',
    items: 'Artikel',
    equipment: 'Ausstattung',
    quantity: 'Menge',
    notes: 'Notizen',
    noteNoAvailability: 'Keine Verfügbarkeit',
    noteAutoDetachFailure: 'Auto-Detach MEWS-Fehler',
    // Charged-products panel inside the participant detail modal
    participantProductsTotal: 'Produkte (EventHub)',
    participantProductsOffBill: 'auf anderen Rechnungen dieses Gastes ({n})',
    participantMewsOpenOnCancelledStays: 'offen auf stornierten Aufenthalten ({n})',
    participantProductsOffBillHint: 'Diese Positionen sind in MEWS berechnet, liegen aber auf einer anderen Rechnung dieses Gastes — in der Regel auf einer Reservierung, die durch einen Typwechsel (Hotel ↔ Tagesgast) ersetzt wurde. Sie sind nicht in „Produkte (EventHub)“ enthalten, weil diese Rechnung sie nicht bezahlt.',
    participantProductsPending: 'noch nicht berechnet ({n})',
    participantProductsPendingHint: 'Diese Positionen wurden nie an MEWS gesendet. Der Betrag ist eine Vorschau, keine Rechnungsposition, und zählt deshalb nicht in „Produkte (EventHub)“.',
    participantProductsPartialHint: 'Mindestbetrag — eine gezählte Position hat keinen Preis.',
    offThisBill: 'andere Rechnung',
    participantRoomTotal: 'Zimmer (MEWS)',
    participantRoomTotalHint: 'Zimmerpreis der Reservierung \u2014 der \u00fcberschriebene Preis, sonst der aktuelle Rate-Preis aus MEWS. Nicht der Rechnungssaldo in MEWS.',
    participantGrandTotal: 'Produkte + Zimmer',
    participantRoomNights: '{n} × {price}',
    participantMewsStay: 'MEWS-Rechnung (dieser Aufenthalt)',
    participantMewsStayPayer: 'an {name}',
    participantMewsStayPayerOther: 'an ein anderes Konto',
    participantMewsStayHint: 'Saldo der MEWS-Rechnung(en), auf denen die N\u00e4chte dieser Reservierung liegen \u2014 das, was MEWS bei der Reservierung als \u201eZu bezahlen\u201c zeigt. Rate-Inklusivleistungen z\u00e4hlen hier mit, daher kann der Betrag Produkte + Zimmer um genau diese \u00fcbersteigen.',
    participantMewsMatches: 'Entspricht Produkte + Zimmer',
    participantMewsInclusive: 'davon Inklusivleistungen der Rate',
    participantMewsDeltaHint: 'Differenz MEWS \u2212 EventHub. Rate-Inklusivleistungen (Fr\u00fchst\u00fcck, WLAN \u2026) stehen auf der MEWS-Rechnung, sind aber keine EventHub-Produkte.',
    participantMewsGuest: 'MEWS-Saldo (Gast)',
    participantMewsGuestHint: 'Alle offenen Posten auf dem MEWS-Konto des Gastes, \u00fcber alle Rechnungen und Aufenthalte.',
    participantMewsOtherStays: 'inkl. anderer Aufenthalte',
    participantMewsLoad: 'Aus MEWS laden',
    participantMewsLoading: 'MEWS-Beträge werden geladen',
    participantMewsChecking: 'MEWS wird abgeglichen …',
    participantChargesReposting: 'Produkte werden neu gebucht …',
    participantMewsAsOf: 'Stand MEWS {time}',
    participantMewsReload: 'Neu laden',
    participantMewsUnchecked: 'MEWS nicht erreichbar – Angaben ungeprüft',
    participantMewsRetry: 'Erneut versuchen',
    participantProductsOtherCustomer: 'bei anderem Kunden ({n})',
    billedPriceHint: 'Abgerechnet mit {billed} je Einheit (Preisliste {list}) \u2014 die Zeile trug {row}. Die Preisliste entscheidet beim Buchen.',
    billedZeroPrice: '0 \u20ac laut Preisliste {list} \u2014 MEWS f\u00fchrt f\u00fcr diese Zeile eine kostenlose Bestellung.',
    allRates: 'alle Raten',
    chargePreflightLines: 'Es werden {n} Zeile(n) gebucht:',
    chargePreflightWarnings: 'Hinweise zu diesen Zeilen',
    chargePreflightPriceCheck: 'Preislisten werden gepr\u00fcft\u2026',
    chargePreflightMismatchTitle: 'Preisliste weicht vom angezeigten Preis ab f\u00fcr',
    chargePreflightMismatchHint: 'Der angezeigte Betrag ist der Zeilenpreis. Beim Buchen bewertet MEWS nach der Preisliste, daher weicht der gebuchte Betrag vom hier angezeigten ab. Erst die Preisliste korrigieren \u2014 oder trotzdem buchen.',
    chargePreflightMismatchLine: '{name}: angezeigt {row} \u2192 Preisliste {list}',
    chargePreflightBookingRate: '{rate}: {price} je Einheit (Preisliste {list})',
    chargeAbsenteesTitle: 'Nicht belastet \u2014 am Session-Tag nicht anwesend',
    chargeAbsenteesGroup: '{lines} \u00b7 Session am {day} \u00b7 {count} nicht belastet',
    chargeAbsenteeStay: 'Aufenthalt {arrival} \u2013 {departure}',
    chargeAbsentArrivesLater: 'reist sp\u00e4ter an',
    chargeAbsentLeavesEarlier: 'reist fr\u00fcher ab',
    chargeAbsentOutsideEvent: 'Aufenthalt au\u00dferhalb der Veranstaltung',
    chargeAbsentSessionOutside: 'Der Session-Tag liegt au\u00dferhalb der Veranstaltung \u2014 diese Zeile belastet niemanden.',
    cancelledLinesShort: 'storniert',
    internalLine: 'intern \u00b7 kein MEWS',
    internalLineHint: 'Interne Veranstaltungen werden nie an MEWS belastet. Diese Zeile dient nur der Planung.',
    ruleBundleSubtitle: '(Regel, je Teilnehmer)',
    ruleBundleProducts: '{n} Produkte',
    ruleBundleUnits: '{n} Einheiten',
    ruleBundleShow: 'Zeilen anzeigen',
    ruleBundleHide: 'Zeilen ausblenden',
    chargePartialLegacyHint: 'Diese Zeile wurde vor den Teilnehmer-Tags gebucht, die fehlenden Personen k\u00f6nnen hier nicht nachgebucht werden. Eine eigene Zeile genau f\u00fcr sie anlegen (\u201eAusgew\u00e4hlte Teilnehmer\u201c) \u2014 eine zweite Zeile f\u00fcr alle w\u00fcrde die \u00fcbrigen doppelt berechnen.',
    duplicateChargeNamed: '{name} \u2014 bereits gebucht f\u00fcr: {names} (Zeile vom {date}).',
    duplicateChargeInRun: '{name} \u2014 wird in diesem Lauf zweimal gebucht f\u00fcr: {names}.',
    duplicateChargeUntagged: '{name}: dieses Produkt wurde auf dieser Veranstaltung bereits gebucht (Zeile vom {date}, ohne Teilnehmer-Tags \u2014 wer bezahlt hat, ist nicht erkennbar).',
    chargePreflightDuplicateTitle: 'M\u00f6gliche Doppelberechnung',
    chargePreflightDuplicateHint: 'Ist diese Zeile f\u00fcr die noch nicht berechneten Personen gedacht, auf \u201eAusgew\u00e4hlte Teilnehmer\u201c stellen und nur diese w\u00e4hlen.',
    chargePreflightDuplicateHintPicked: 'Bei \u201eAusgew\u00e4hlte Teilnehmer\u201c: die genannten Personen aus der Auswahl entfernen oder die Zeile l\u00f6schen.',
    legacyNotBilled: 'auf dieser Zeile nicht abgerechnet',
    legacyNotBilledHint: 'Diese Zeile wurde vor den Teilnehmer-Tags gebucht, und MEWS f\u00fchrt darauf keine Bestellung f\u00fcr diese Person \u2014 sie kam nach der Buchung dazu. Es wurde nichts storniert.',
    ruleAuditLineCancelled: 'zur Stornierung markiert \u2014 die Regel greift f\u00fcr diesen Aufenthalt nicht mehr (oder die Zeile wurde ersetzt)',
    ruleAuditLineUnchanged: 'unver\u00e4ndert',
    ruleAuditTitle: 'Regelpr\u00fcfung',
    ruleAuditLastRun: 'letzter Lauf {when}',
    ruleAuditLastRunBeforeCancel: 'letzter Lauf vor der Stornierung {when}',
    ruleAuditNothing: 'F\u00fcr diese Reservierung wurde noch keine Regel gepr\u00fcft.',
    ruleAuditNoProducts: 'keine Produkte',
    ruleAuditFired: 'ausgel\u00f6st \u2014 {count} Produktzeile(n)',
    ruleAuditCancelled: 'ausgel\u00f6st, seither storniert \u2014 nichts berechnet',
    ruleAuditDays: '{fired} von {total} Tagen',
    ruleAuditBoundaryArrival: 'nur am Anreisetag',
    ruleAuditBoundaryDeparture: 'nur am Abreisetag',
    ruleAuditNoDayFired: 'passt, hat aber an keinem der {days} Aufenthaltstage ausgel\u00f6st \u2014 die An-/Abreise-Trigger treffen keinen Tag dieses Aufenthalts',
    ruleAuditError: 'Fehler',
    ruleAuditGate_validity: 'nicht angewendet: die Regel ist am Leistungstag nicht g\u00fcltig',
    ruleAuditGate_stream: 'nicht angewendet: die Regel gilt nicht f\u00fcr diesen Event-Stream',
    ruleAuditGate_rate: 'nicht angewendet: die Regel f\u00fchrt die Rate dieser Reservierung nicht',
    ruleAuditGate_participant_scope: 'nicht angewendet: dieser Teilnehmertyp liegt au\u00dferhalb des Regel-Scopes',
    ruleAuditGate_unknown: 'nicht angewendet',
    chargedProductsTitle: 'Berechnete Produkte',
    notYetCharged: 'noch nicht berechnet',
    chargedProductsNone: 'Keine Produkte diesem Teilnehmer zugeordnet.',
    source: 'Quelle',
    totalPrice: 'Summe',
    products: 'Produkte',
    total: 'Gesamt',
    viaPackage: 'via Paket',
    noEventSelected: 'Kein Event ausgewählt',
    loadingSeriesData: 'Lade Seriendaten...',
    selectSeries: 'Serie auswählen',
    chooseSeries: 'Serie wählen...',
    notPartOfSeries: 'Dieses Event gehört keiner Serie an',
    basicInformation: 'Grundinformationen',
    datesTimes: 'Datum & Zeiten',
    participants: 'Teilnehmer',
    sourceSystem: 'Quellsystem',
    sourceData: 'Quelldaten (BC/Externes System)',
    eventNameLabel: 'Veranstaltungsname',
    copyEventLink: 'Link kopieren',
    locationLabel: 'Standort',
    selectLocation: 'Standort wählen',
    description: 'Beschreibung',
    description2: 'Beschreibung 2',
    externalId: 'Externe ID',
    categoryLabel: 'Stream',
    selectCategory: 'Stream wählen',
    internal: 'Intern',
    eventType: 'Veranstaltungstyp',
    selectType: 'Typ wählen',
    participationType: 'Teilnahmeart',
    selectParticipationType: 'Art wählen',
    onSite: 'Vor Ort',
    hybrid: 'Hybrid',
    statusLabel: 'Status',
    startDateLabel: 'Startdatum',
    optionalMiceHint: 'optional, v. a. für MICE',
    daySlotsTitle: 'Gebucht wird pro Tag:',
    selectSetupFirst: 'Zuerst Aufbau wählen',
    groupEditorPickGuest: 'Kunde suchen oder anlegen…',
    noEmail: 'Keine E-Mail',
    groupEditorHalfDayUnset: 'Keine Zeit hinterlegt – zählt für die Regeln als Nachmittag',
    spaceBookingMissing: 'Noch offen: {fields}',
    spaceBookingPaxSetupRequired: 'Bitte Pax und Aufbau angeben – beides wird für die Raumbuchung benötigt.',
    spaceBookingOutsideEvent: 'Die Buchung muss im Zeitraum der Veranstaltung liegen.',
    endDateLabel: 'Enddatum',
    futureDatesOnlyHint: 'Start- und Enddatum müssen am oder nach dem {date} liegen.',
    futureDatesOnlyAlert: 'Start- und Enddatum müssen am oder nach dem {date} liegen.',
    endDateAfterStartDate: 'Das Enddatum muss am oder nach dem Startdatum liegen.',
    startTime: 'Startzeit',
    endTime: 'Endzeit',
    minParticipants: 'Min. Teilnehmer',
    maxParticipants: 'Max. Teilnehmer',
    numberOfParticipants: 'Anzahl Teilnehmer',
    lunchTime: 'Mittagessen',
    clearSelection: 'Zurücksetzen',
    lunchCrowdEmpty: 'Noch keine bestätigten Gäste zu dieser Zeit',
    lunchCrowdBusy: 'Bereits {n} bestätigte Gäste um {time} Uhr',
    lunchTimeNotSet: 'Mittagszeit nicht gesetzt',
    lunchOverCapacity: 'Um {time} Uhr sitzen bereits {limit} oder mehr bestätigte Gäste – die Zeit wurde nicht übernommen. Bitte mit dem F&B-Team abstimmen.',
    lunchConfirmSetTitle: 'Mittagszeit setzen?',
    lunchConfirmChangeTitle: 'Mittagszeit ändern?',
    lunchConfirmRemoveTitle: 'Mittagszeit entfernen?',
    lunchConfirmSet: 'Mittagessen für diese Veranstaltung auf {time} Uhr setzen.',
    lunchConfirmChange: 'Mittagessen von {from} Uhr auf {to} Uhr ändern.',
    lunchConfirmRemove: 'Die Mittagszeit ({time} Uhr) wird entfernt – die Veranstaltung hat dann keine Mittagszeit.',
    lunchFullTitle: 'Mittagszeit nicht möglich',
    lunchFullText: 'Um {time} Uhr sitzen bereits {n} bestätigte Gäste – die Grenze liegt bei {limit}. Diese Zeit kann nicht vergeben werden. Bitte mit dem F&B-Team abstimmen.',
    lunchFullUnset: 'Die bisherige Mittagszeit ({time} Uhr) wird entfernt.',
    lunchFullAck: 'Verstanden',
    lunchCrowdUnknown: 'Auslastung nicht verfügbar',
    manageSessions: 'Sessions verwalten',
    sessionName: 'Session-Name',
    sessionDate: 'Session-Datum',
    sessionUntil: 'Mehrtägig bis',
    sessionSingleDay: 'Nur dieser Tag',
    sessionUntilHint: 'zuerst Datum wählen',
    sessionDaysCreated: '{n} Tage werden angelegt',
    sessionRunDays: '{n} Tage',
    sessionDeleteRunWarning: 'Session „{name}" umfasst {n} Tage. Alle {n} Tage werden gelöscht — das kann nicht rückgängig gemacht werden.',
    sessionShortenRunBlocked: 'Diese Session läuft bis {last}. Tage entfernst du über Löschen in der Liste — dort werden Raumbuchungen, Technik und Catering des Tages mit geprüft.',
    selectDate: 'Datum wählen',
    spaceOptional: 'Raum (optional)',
    noSpaceSelected: 'Kein Raum gewählt',
    selectSpaceForSession: 'Raum für diese Session wählen',
    sessionDescription: 'Beschreibung',
    selectSession: 'Session wählen',
    spaceBooking: 'Raumbuchung',
    selectSpaceBooking: 'Raumbuchung wählen',
    selectEquipment: 'Ausstattung wählen',
    selectAttendee: 'Teilnehmer wählen',
    allSessions: 'Alle Sessions',
    registrationStatus: 'Anmeldestatus',
    invited: 'Eingeladen',
    confirmed: 'Bestätigt',
    suggested: 'Vorschlag',
    bookingConfirmedTooltip: 'Verbindlich gebucht',
    bookingSuggestedTooltip: 'Noch nicht bestätigt',
    confirmDelete: 'Löschen bestätigen',
    confirmDeleteSpaceBooking: 'Möchten Sie diese Raumbuchung wirklich löschen?',
    dedupeTitle: 'Doppelte Raumbuchungen entfernen',
    dedupeIntro: 'Es gibt mehrere identische Raumbuchungs-Einträge für denselben Zeitraum. Einen behalten, die anderen löschen.',
    dedupeDuplicateCount: 'Doppelte Einträge',
    dedupeAction: '{keep} Eintrag behalten, {remove} löschen.',
    dedupeConfirm: '1 behalten, Rest löschen',
    dedupeDuplicatesHint: 'Klicken, um einen zu behalten und Duplikate zu löschen',
    dedupeFailed: 'Bereinigung fehlgeschlagen',
    attendeeLabel: 'Teilnehmer',
    activityState: 'Aktivitätsstatus',
    releaseStrategy: 'Freigabestrategie',
    firstTimeUnitStart: 'Erster Zeitabschnitt (UTC)',
    lastTimeUnitStart: 'Letzter Zeitabschnitt (UTC)',
    released: 'Freigegeben (UTC)',
    created: 'Erstellt (UTC)',
    updated: 'Aktualisiert (UTC)',
    serviceAndRate: 'Service & Rate',
    serviceId: 'Service-ID',
    rateId: 'Raten-ID',
    contacts: 'Kontakte',
    bookerId: 'Bucher-ID',
    companyId: 'Firmen-ID',
    travelAgencyId: 'Reisebüro-ID',
    additionalInfo: 'Zusatzinformationen',
    pickupDistribution: 'Pickup-Verteilung',
    externalIdentifier: 'Externe Kennung',
    budget: 'Budget',
    availabilityAdjustments: 'Verfügbarkeitsanpassungen',
    noAdjustmentsFound: 'Keine Anpassungen für diesen Block gefunden',
    failedLoadMewsBlock: 'MEWS-Blockdetails konnten nicht geladen werden',
    venueMap: 'Lageplan',
    corporate: 'Firmenveranstaltung',
    social: 'Gesellschaftlich',
    businessSchool: 'Business School',
    required: 'Pflichtfeld',
    localReservation: 'Lokale Reservierung',
    cancelledInMews: 'Reservierung wird in MEWS storniert',
    deletedFromDb: 'Reservierung wird aus EventHub-Datenbank gelöscht',
    whatWillBeDeleted: 'Was gelöscht wird',
    mewsSyncWarning: 'Diese Reservierung ist mit MEWS synchronisiert und wird dort storniert. Der Gast hat danach keine Reservierung mehr.',
    page: 'Seite',
    addCateringOrder: 'Catering hinzufügen',
    addEquipment: 'Ausstattung hinzufügen',
    addAttendee: 'Teilnehmer hinzufügen',
    noEquipmentYet: 'Noch keine Ausstattung. Klicke "Ausstattung hinzufügen".',
    roomType: 'Zimmertyp',
    noBlocksOrReservations: 'Keine Blöcke oder Reservierungen für diesen Tag',
    detachFromSeries: 'Von Serie trennen',
    seriesType: 'Typ',
    organizer: 'Veranstalter',
    department: 'Abteilung',
    selectSpaceForBooking: 'Raum für diese Session wählen',
    overnightGuests: 'Übernachtung',
    overnightGuest: 'Übernachtungsgast',
    overnightGuestsPlural: 'Übernachtungsgäste',
    noneBooked: 'Keine',
    assignContacts: 'Kontakte zuweisen',
    devInspectorTitle: 'Rohdaten anzeigen (JSON)',
    devInspectorHint: 'Rohdatensatz & verknüpfte Daten ansehen',
    reloadDataAgoTitle: 'Daten neu laden',
    hotelRooms: 'Hotel Zimmer',
    roomCategorySelect: 'Zimmerkategorie wählen',
    roomTypeComfort: 'Komfort Doppelzimmer',
    roomTypeEconomy: 'Economy Einzelzimmer',
    requested: 'Angefragt',
    tightestDay: 'Engster Tag',
    shortfallTitle: 'Nicht genug Zimmer verfügbar',
    shortfallBodyFull: 'Für {category} konnten nur {available} von {requested} Zimmern gehalten werden — {missing} zu wenig. Engpass am {day}.',
    shortfallBodyCategory: 'Für {category} konnten nur {available} von {requested} Zimmern gehalten werden — {missing} zu wenig.',
    shortfallBodyDay: 'Es konnten nur {available} von {requested} Zimmern gehalten werden — {missing} zu wenig. Engpass am {day}.',
    shortfallBodyCounts: 'Es konnten nur {available} von {requested} Zimmern gehalten werden — {missing} zu wenig.',
    shortfallBodyGeneric: 'Das Zimmerkontingent konnte nicht in voller Größe gehalten werden.',
    shortfallTechnicalDetail: 'Technische Details',
    shortfallHint: 'Bitte eine andere Zimmerkategorie wählen, weniger Übernachtungsgäste anfragen oder den Datumsbereich anpassen.',
    preNight: 'Vorabend',
    overnightGuestsToBlock: 'Übernachtungsgäste zu blocken',
    overnightBadgeInfo: '{count} Teilnehmer + 1 Zimmer ist immer für den Dozenten reserviert (auch wenn noch keine Reservierung vorliegt).',
    healEvent: 'Blöcke prüfen & reparieren',
    autoCreateCustomers: 'Kunden automatisch anlegen',
    runAgain: 'Erneut ausführen',
    healEventMismatch: 'Datenabweichung erkannt — klicken zum Prüfen & Reparieren',
    healEventTitle: 'Event-Gesundheitscheck',
    healAllOk: 'Alles in Ordnung — keine Probleme gefunden.',
    healIssuesFound: 'Probleme erkannt — Details siehe unten.',
    healNoOpPendingBlocks: 'Es wurde nichts repariert. {n} Zimmerblock/-blöcke existieren noch nicht in MEWS — solange das so ist, fasst die Reparatur den Zimmermix der Veranstaltung nicht an. Blöcke vom Hotel freigeben lassen oder den Zimmermix in der Veranstaltung ändern.',
    healCheck_block_capacity: 'Block-Kapazität',
    healCheck_block_dates: 'Block-Daten',
    healCheck_reservation_overflow: 'Reservierungsüberlauf',
    healCheck_orphaned_blocks: 'Verwaiste Blöcke',
    healCheck_connection: 'Verbindung',
    healCheck_pending_lecturers: 'Ausstehende Dozenten',
    healCheck_failed_reservations: 'Fehlgeschlagene Reservierungen',
    openSession: 'Session öffnen',
    mainSpace: 'Hauptraum',
    setMainSpace: 'Als Hauptraum festlegen',
    mainSpaceFailed: 'Hauptraum konnte nicht gesetzt werden.',
    mainSpaceCanceled: 'Eine stornierte Raumbuchung kann nicht Hauptraum sein.',
    mainSpaceIsCurrent: 'Aktueller Hauptraum. Zum Wechseln eine andere Raumbuchung als Hauptraum markieren.',
    mainSpaceDefaultCurrent: 'Aktuell der Hauptraum des Events (Standard: frühester, größter Raum).',
    mainSpaceOnSave: 'Wird beim Speichern als Hauptraum festgelegt.',
    mainSpaceHint: 'Dieser Raum steht in der Übersicht, im Function Sheet und — als „Raum: …“ — in jeder MEWS-Reservierung der Teilnehmer.',
    mainSpaceDefaultHint: 'Aktuell Standard-Hauptraum — zum Festpinnen anklicken.',
    mainSpaceUnavailable: 'Hauptraum kann noch nicht gesetzt werden: Die Datenbank kennt das Feld noch nicht (Migration V191 fehlt).',
    mainSpaceOverCapacity: 'Zu klein für {pax}',
    mainSpaceOverCapacityHint: '{pax} eingebuchte Teilnehmer übersteigen die Kapazität des Hauptraums ({cap}) — {short} Plätze fehlen.',
    standaloneHold: 'Raumhold',
    standaloneHoldHint: 'Direkt gebuchter Raum — gehört zu keiner Session',
    spaceNotRequired: 'Diese Veranstaltung benötigt keinen Seminarraum',
    spaceNotRequiredHint: 'Die Veranstaltung wird dann im Dashboard nicht mehr als „Kein Raum" gemeldet.',
    spaceNotRequiredBadge: 'Ohne Raum',
    openTasksHint: '{count} offene Aufgabe(n) zu diesem Event',
    perHeadQuantityBadge: 'Menge pr\u00fcfen',
    perHeadQuantityBadgeHint: 'Klicken f\u00fcr die Erkl\u00e4rung',
    quantityFormula: '{qty} \u00d7 {people} Pers. = {total}',
    quantityFormulaPerDay: '{qty} \u00d7 {days} Tage \u00d7 {people} Pers. = {total}',
    setQuantityToOne: 'Menge auf 1 setzen',
    // Names behind a "N ausgew\u00e4hlt" charge. The select shows a count (it
    // cannot truncate its own label), so WHO pays lives in its tooltip.
    chargedToNames: 'Belastet: {names}',
    // Effective quantity caption under the Menge box. The box holds a RATE
    // (units per billed person), not a total; MEWS receives quantity x people.
    // Spelling that out on the row is what stops the two being confused.
    effectiveQtyPerPerson: '{qty} \u00d7 {count} Pers. = {total}',
    quantityTotalHeader: 'Menge / Gesamt',
    verifyingInMews: 'Wird in MEWS gepr\u00fcft\u2026',
    occupancy: 'Belegung',
    singleOccupancy: '1 \u2014 Einzelbelegung',
    doubleOccupancy: '2 \u2014 Doppelbelegung',
    singleRoomOnePerson: 'Ein EZ ist f\u00fcr eine Person. Belegung auf 1 setzen oder ein DZ w\u00e4hlen.',
    childrenLegacy: 'Diese Reservierung f\u00fchrt zus\u00e4tzlich {n} Kind(er) \u2014 gebucht, bevor das Feld entfernt wurde.',
    participantType: 'Teilnehmerart',
    forceAllCategories: '\u00dcber alle Zimmerkategorien f\u00fcllen',
    forceAllCategoriesHint: 'Eine Zimmeranfrage darf in die andere Kategorie ausweichen \u2014 zuerst die angefragte, dann die andere. Weiterhin alles oder nichts.',
    forceAllCategoriesApplyHint: 'Gespeichert. Gilt ab dem n\u00e4chsten Pickup \u2014 Blockpr\u00fcfung erneut ausf\u00fchren, um die Zimmer jetzt neu zu verteilen.',
    forceAllCategoriesRunHeal: 'Blockpr\u00fcfung erneut ausf\u00fchren',
    forceAllCategoriesSaveFailed: 'Die Einstellung konnte nicht gespeichert werden.',
    convertParticipantTypeWorking: 'Wird umgebucht\u2026',
    convertParticipantTypeWait: 'Das dauert einige Sekunden \u2014 bitte das Fenster nicht schlie\u00dfen.',
    convertStepIdentity: 'Reservierung wird vorbereitet\u2026',
    convertStepRebooking: 'Storno in MEWS und Neuanlage der Buchung\u2026',
    convertStepReloading: 'Teilnehmerliste wird neu geladen\u2026',
    convertParticipantType: 'Umbuchen',
    convertParticipantTypeHint: 'Ein Wechsel der Art bucht den Gast auf den anderen MEWS-Service um: die aktuelle Reservierung wird storniert und eine neue angelegt. Die alte Zeile bleibt als Audit-Eintrag. Verrechnete Produkte, die weiter gelten, werden auf die Rechnung der neuen Buchung übertragen; Regelprodukte der alten Art werden storniert, und die Regeln laufen für die neue Art neu.',
    adultOne: 'Erwachsener',
    childOne: 'Kind',
    rateChangeChargesHint: 'Bereits verrechnete Produkte behalten ihren Preis \u2014 die neue Rate gilt nur f\u00fcr die \u00dcbernachtung.',
    invoiceOwnerUnnamed: 'gesetzt, Kontakt konnte nicht aufgel\u00f6st werden',
    invoiceOwnerLocalName: 'bei uns gespeichert als',
    invoiceOwnerNameMismatch: 'Angezeigt wird das MEWS-Konto. Bei uns gespeichert als \u201e{local}\u201c \u2014 sollte korrigiert werden.',
    invoiceOwnerLoading: 'wird geladen\u2026',
    releaseChargesFailed: 'Die Verrechnung konnte in MEWS nicht storniert werden. Es wurde nichts ge\u00e4ndert.',
    chargeConfirmedInMews: 'In MEWS best\u00e4tigt f\u00fcr alle {count} Zahler',
    chargePartialInMews: 'Nur {confirmed} von {expected} Zahlern sind in MEWS verrechnet. Fehlt: {names}',
    // Teilnehmer, die nach der Berechnung dazugekommen sind (noch keine MEWS-Order)
    lateParticipantsChip: '{n} noch nicht berechnet',
    lateParticipantsTitle: 'Nach der Berechnung hinzugekommen, noch nicht in MEWS: {names}',
    chargeLateParticipants: '{count} Gast nachberechnen, der noch nicht in MEWS ist | {count} Gäste nachberechnen, die noch nicht in MEWS sind',
    notChargedForParticipant: 'für diesen Teilnehmer nicht berechnet',
    notLiveInMews: 'nicht mehr in MEWS',
    chargeMissingInMews: 'In MEWS liegt keine aktive Verrechnung f\u00fcr diese Zeile \u2014 dort storniert oder nie angekommen.',
    mewsUnavailableChargeTitle: 'MEWS nicht erreichbar \u2014 Verrechnung konnte nicht gepr\u00fcft werden.',
    // EH-0254: ein Wort neben dem MEWS-Pr\u00fcf-Icon, damit die Zeile ohne Hover lesbar ist
    mewsVerifyPartial: 'MEWS: teilweise',
    mewsVerifyMissing: 'MEWS: fehlt',
    mewsVerifyUnchecked: 'MEWS: ungepr\u00fcft',
    mewsNotCharged: 'Nicht verrechnet',
    chargeWarningChip: 'Hinweis',
    // EH-0254: Spaltenerkl\u00e4rungen, ge\u00f6ffnet \u00fcber das Info-Symbol im Spaltenkopf
    colInfoName: 'Das auf dieser Zeile gebuchte Produkt oder Paket.',
    colInfoType: 'Wie die Zeile verrechnet wird \u2014 pro Person, pro Tag oder einmalig.',
    colInfoQuantity: 'Links: Menge pro Teilnehmer. Rechts: Einheiten, die an MEWS gehen (\u00d7 Personen \u00d7 Tage).',
    colInfoPrice: 'Einzelpreis. Ein oranges Feld ist ein manuell \u00fcberschriebener Preislistenpreis.',
    colInfoChargeTo: 'Wem die Zeile belastet wird, oder \u201eintern\u201c f\u00fcr Zeilen, die nie an MEWS gehen.',
    colInfoCalcMode: 'Wie der Betrag berechnet wird \u2014 aus dem Produkt-Katalog \u00fcbernommen.',
    colInfoStatus: 'Verrechnungsstatus und das MEWS-Pr\u00fcfergebnis der Zeile.',
    colInfoValue: 'Zeilensumme: Preis \u00d7 Einheiten.',
    removeScopeTitle: 'Verrechnete Position entfernen',
    removeScopeLede: '\u201e{name}\u201c ist in MEWS auf {count} Teilnehmer verrechnet. F\u00fcr alle stornieren oder nur f\u00fcr einzelne?',
    removeScopeAll: 'F\u00fcr alle stornieren ({count})',
    removeScopeSelected: 'Nur f\u00fcr ausgew\u00e4hlte Teilnehmer stornieren\u2026',
    cancelForSelectedTitle: 'F\u00fcr welche Teilnehmer stornieren?',
    cancelForSelectedHint: 'Die Verrechnung wird in MEWS nur f\u00fcr die hier gew\u00e4hlten Personen storniert. Alle anderen bleiben verrechnet.',
    cancelChargeAction: 'Verrechnung stornieren',
    effectiveQtyHint: 'Menge gilt pro Person. An MEWS gehen {total} Einheiten ({qty} je Person \u00d7 {count} Personen).',
    chipCountOfTotal: '{count} von {all}',
    chipAbsentHint: 'Wird an die am {day} anwesenden Personen berechnet. An diesem Tag nicht da und daher nicht berechnet: {names}.',
    notPresentBadge: '{count} nicht anwesend',
    figureIsCharged: 'Verrechnet \u2014 das h\u00e4lt MEWS.',
    figureIsProjected: 'Vorschau \u2014 so wird verrechnet.',
    sessionDayPeoplePlain: '{count} Teilnehmer',
    sessionDayPeopleOccupancy: '{people} Gäste ({count} Teilnehmer, davon {rooms} mit Doppelbelegung)',
    effectiveQtyHintSessionDay: 'Menge gilt pro Person und Tag. Diese Position geh\u00f6rt zur Session am {day} und wird f\u00fcr diesen EINEN Tag berechnet, an die Anwesenden: {present}. An MEWS gehen {total} Einheiten ({qty} je Person \u00d7 1 Tag).',
    effectiveQtyHintSessionDayPerPerson: 'Menge gilt pro Person. Diese Position geh\u00f6rt zur Session am {day} und wird nur an die an diesem Tag anwesenden Personen berechnet: {present}. An MEWS gehen {total} Einheiten ({qty} je Person).',
    effectiveQtyHintSessionDayPerDay: 'Menge gilt pro Tag. Diese Position geh\u00f6rt zur Session am {day} und wird f\u00fcr diesen EINEN Tag berechnet. An MEWS gehen {total} Einheiten.',
    effectiveQtyHintSessionDayOnce: 'Pauschale. Diese Position geh\u00f6rt zur Session am {day} und wird je anwesendem Zahler einmal berechnet: {present}. An MEWS gehen {total} Einheiten.',
    effectiveQtyHintDays: 'Menge gilt pro Person und Tag. An MEWS gehen {total} Pakete ({qty} je Person \u00d7 {days} Tage \u00d7 {people} Personen).',
    effectiveQtyHintOccupancy: 'Menge gilt pro Person. An MEWS gehen {total} Einheiten ({qty} je Person \u00d7 {people} Gäste \u2014 {count} Teilnehmer, davon {rooms} mit Doppelbelegung).',
    ruleGroupMixedQtyHint: 'Je Teilnehmer {range} Einheiten (Belegung oder verk\u00fcrzter Aufenthalt). An MEWS gehen {total} Einheiten f\u00fcr {count} Teilnehmer.',
    occupancyChipHint: 'Doppelbelegung: {n} Gäste im Zimmer \u2014 zählt bei Produkten pro Person {n}-fach.',
    personsShort: 'Pers.',
    // Second guest of a double room in the participants list, and the row badge (EH-0186).
    plusPersons: '+{count} Person | +{count} Personen',
    doubleOccupancyBadge: '{count} Doppelbelegung | {count} Doppelbelegungen',
    doubleOccupancyBadgeHint: 'Bei Produkten pro Person zählt jeder Gast eines Zimmers. Wer, steht in der Teilnehmerliste (👥).',
    perDayQuantityWarning: 'Die Menge gilt je Person und Tag. Gemeint: 1 pro Person und Tag?',
    perHeadQuantityWarning: 'Die Menge gilt je Person. Gemeint: 1 pro Person?',
    spaceNotRequiredReinstateHint: 'Hinweis: Es wird nicht automatisch wieder ein Raum zugewiesen \u2014 bitte im Reiter \u201eR\u00e4ume\u201c ausw\u00e4hlen.',
    spaceNotRequiredReleaseConfirm: 'Diese Veranstaltung hält aktuell {count} Raumbuchung(en). Wird sie als „benötigt keinen Raum" gespeichert, werden diese Buchungen freigegeben und gelöscht. Fortfahren?',
    spaceReleaseFailed: '{count} Raum/Räume konnten nicht freigegeben werden — bitte im Raum-Tab entfernen.',
    preEveningArrival: 'Vorabendanreise',
    preNightNotEnabled: 'Vorabendanreise ist für dieses Event nicht aktiviert',
    noRate: 'Standard',
    salesperson: 'Vertrieb',
    salespersonCode: 'Vertriebscode',
    salespersonName: 'Vertriebsname',
    salespersonEmail: 'Vertriebs-E-Mail',
    salespersonPhone: 'Vertriebstelefon',
    salespersonJobTitle: 'Vertriebsposition',
    costCenter: 'Kostenstelle',
    customerNo: 'Kunden-Nr.',
    customerName: 'Kundenname',
    productManagerNo: 'Produktmanager-Nr.',
    productManagerName: 'Produktmanager',
    productManager: 'Produktmanager',
    contactPerson: 'Ansprechpartner',
    contactPersonPlaceholder: 'Ansprechpartner aus MEWS auswählen…',
    orgResponsibleNo: 'Org. Verantw.-Nr.',
    orgResponsibleName: 'Org. Verantwortlich',
    orgResponsible: 'Org. Verantwortlich',
    eventManager: 'Veranstaltungsmanager',
    responsiblePerson: 'Verantwortliche Person',
    selectContact: 'Kontakt auswählen...',
    bcData: 'Business Central Daten',
    venueInfo: 'Veranstaltungsort',
    venueContact: 'Kontakt Veranstaltungsort',
    venueAddress: 'Adresse Veranstaltungsort',
    venueCity: 'Stadt Veranstaltungsort',
    customer: 'Kunde',
    searchSalesperson: 'Vertrieb nach Name oder E-Mail suchen...',
    searchEventCustomer: 'Kunde nach Name oder E-Mail suchen...',
    salespersonSelected: 'Vertrieb ausgewählt',
    eventCustomerSelected: 'Kunde ausgewählt',
    sourceId: 'Quell-ID',
    sourceModified: 'Quelle geändert',
    openInBC: 'In Business Central öffnen',
    primaryContact: 'Hauptkontakt',
    eventsInSeries: 'Events in dieser Serie',
    addSession: 'Session hinzufügen',
    suggestedHint: 'Vorgeschlagen — der Raum ist noch nicht bestätigt.',
    duplicateSession: 'Session duplizieren',
    sessionTabDetails: 'Details',
    sessionTabProducts: 'Produkte',
    sessionNoProducts: 'Noch keine Produkte für diese Session.',
    duplicate: 'Duplizieren',
    duplicating: 'Dupliziere…',
    duplicateSessionConfirm: 'Von „{name}" wird eine Kopie erstellt. Der neue Name erhält „(2)".',
    duplicateKeeps: 'Pax, Setup, Datum & Zeit werden übernommen',
    duplicateNoRoom: 'Kein Raum — später zuweisen',
    yes: 'Ja',
    no: 'Nein',
    noWebShop: 'Kein WebShop',
    noSpecificSession: 'Keine Session (Event-Zeiten nutzen)',
    timesFromEvent: 'Zeiten werden vom Event übernommen',
    availabilityNotChecked: 'Verfügbarkeit konnte nicht geprüft werden — belegte Räume sind nicht markiert.',
    selectSpace: 'Raum wählen',
    selectSetupType: 'Bestuhlung wählen',
    setupInRoom: 'Aufbau im Raum {room}',
    sessionRequirement: 'Anforderung der Session',
    roomBookingTitle: 'Raumbuchung {room}',
    roomSetupChange: 'Aufbau ändern',
    paxExceedsRoom: '{pax} Pax übersteigen die Kapazität (max {max}) — Buchung trotzdem möglich',
    setupMatchesWish: 'entspricht dem Wunsch',
    setupDiffersFromWish: 'weicht vom Wunsch ab ({setup})',
    setupWishUnavailable: '{setup} ist in Raum {room} nicht verfügbar — bitte wählen',
    wish: 'Wunsch',
    sessionPaxSetupRequired: 'Bitte Pax und Setup angeben — oder „Kein Raum erforderlich" aktivieren.',
    selectSpaceFirst: 'Zuerst Raum wählen',
    spaceSuggestedTimes: 'Dieser Raum ist zu dieser Zeit bereits {n}× vorgeschlagen',
    manualCreation: 'Manuelle Erstellung',
    betaWarning: 'Hotel-Kontingente werden normalerweise aus MEWS synchronisiert. Manuelle Erstellung ist experimentell.',
    selectService: 'Service wählen',
    selectRate: 'Rate wählen',
    selectRoomCategory: 'Zimmerkategorie wählen',
    roomCategoryHint: 'Zimmer für diese Gruppe blockieren',
    booker: 'Bucher (Kunde)',
    bookerSelected: 'Bucher ausgewählt',
    releaseDate: 'Freigabedatum',
    releaseDateHint: 'Datum, an dem nicht reservierte Zimmer im Hotelblock wieder in den freien Verkauf gehen',
    releaseDateBeforeStart: 'Freigabedatum muss vor dem Veranstaltungsbeginn liegen',
    includeNightBefore: 'Vorabend einschließen (frühe Anreise)',
    arrival: 'Anreise',
    arrivalDate: 'Anreisedatum',
    departure: 'Abreise',
    departureDate: 'Abreisedatum',
    stay: 'Zeitraum',
    checkout: 'Auschecken',
    pickupTooltip: 'Daten direkt aus der MEWS API (Reservierungsebene). Kann von der MEWS Block-Ansicht abweichen, da MEWS Pickups auf Blockebene anders zählt.',
    eventStarts: 'Event beginnt',
    eventEnds: 'Event endet',
    rate: 'Rate',
    ratePerNight: 'Preis pro Nacht',
    noSessions: 'Keine Sessions konfiguriert',
    manageSessionsDesc: 'Sessions für dieses Event erstellen und verwalten.',
    availabilityBlock: 'Verfügbarkeitsblock',
    selectAvailabilityBlock: 'Block wählen',
    selectBlockHint: 'Block wählen, um ein Zimmer zu reservieren',
    selectBlockFirst: 'Zuerst einen Block wählen',
    businessSegment: 'Geschäftssegment',
    selectBusinessSegment: 'Geschäftssegment wählen',
    cateringOrder: 'Catering-Bestellung',
    equipmentReservation: 'Equipment-Reservierung',
    deleteConfirmMsg: 'Möchten Sie dieses Element wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    willAlsoDelete: 'Wird ebenfalls gelöscht',
    deleteEventConfirmIntro: 'Sie sind dabei, das Event endgültig zu löschen',
    deleteEventWillRemove: 'Dabei werden auch endgültig entfernt:',
    deleteEventItemSpaceBookings: 'Alle Raumbuchungen',
    deleteEventItemBlocks: 'Alle Hotelkontingente (inkl. MEWS-Blöcke)',
    deleteEventItemReservations: 'Alle Reservierungen',
    deleteEventItemAttendees: 'Alle Teilnehmer',
    deleteEventItemSessions: 'Alle Sessions',
    deleteEventItemCheckins: 'Alle Check-ins',
    deleteEventIrreversible: 'Diese Aktion kann nicht rückgängig gemacht werden.',
    deleteEventSuccessTitle: 'Event gelöscht',
    deleteEventSuccessIntro: 'Das Event wurde erfolgreich gelöscht.',
    deleteEventCleanedUp: 'Bereinigt:',
    deleteEventItemMewsBlocks: 'MEWS-Blöcke',
    deleteEventItemDbBlocks: 'DB-Blöcke',
    deleteEventFailedTitle: 'Löschen fehlgeschlagen',
    deleteEventFailedIntro: 'Das Event konnte nicht gelöscht werden.',
    blockAwaitingApproval: 'Warten auf Hotel-Freigabe',
    // Siehe en.ts: Karte zeigt die Anfrage statt einer Auslastung, solange
    // kein Block etwas hält.
    blockIntentHeadline: 'Zimmer angefragt',
    blockIntentDraft: 'Noch nicht an das Hotel gesendet — nichts in MEWS geblockt.',
    blockIntentRequested: 'Wartet auf Hotel-Freigabe — bis zur Zusage ist nichts in MEWS geblockt.',
    roomsRequestedShort: 'angefragt',
    blockErrorHint: 'Block muss repariert werden — Pickups schlagen fehl',
    blockNoAvailability: 'Keine Verfügbarkeit',
    blockNoAvailabilityHint: 'MEWS hatte keine freien Zimmer für einige Pickups',
    blockNotDecremented: 'Block nicht reduziert',
    blockNotDecrementedHint: 'Die geblockten Zimmer dieses Blocks wurden nicht um die Pickups reduziert, daher stimmen die Zimmer des Events nicht. Mit „Heilen“ korrigieren.',
    blockHealthy: 'Block erstellt — alles in Ordnung',
    blockRoomsLabel: 'Zimmer geblockt',
    detachedShort: 'entkoppelt',
    detachedFromBlockHint: 'Außerhalb des Blocks (entkoppelt oder verknüpft) — zählen zu „Übernachtungsgästen", belegen aber keinen Block-Platz',
    detachedOutsideLabel: 'außerhalb des Blocks',
    blockProgressLabel: 'Pickup',
    totalShort: 'gesamt',
    reservationsShort: 'Reservierungen',
    independentReservations: 'unabhängig',
    legacyReservationsTooltip: 'Legacy-Reservierungen',
    legacyOnBlock: 'noch am Block',
    legacyDetached: 'alt-detached',
    blockUtilizationLabel: 'Block-Auslastung',
    freeInBlock: 'frei im Block',
    blockFull: 'Block voll',
    blockFullHint: 'Alle Zimmer dieses Blocks sind aufgenommen. Für weitere Gäste bitte den Block vergrößern oder ein Zimmer freigeben.',
    eventBlocksFullHint: 'Das gesamte Kontingent dieser Veranstaltung ist aufgenommen. Der nächste Hotelgast wird abgelehnt — bitte zuerst einen Block vergrößern oder ein Zimmer freigeben. Dozenten, Tagesgäste, Externe und Online-Teilnehmer sind davon nicht betroffen.',
    addBlock: 'Block hinzufügen',
    categoryAlreadyBlocked: 'Bereits belegt',
    categoryAlreadyBlockedHint: 'Ein aktiver Block belegt diese Kategorie in diesem Zeitraum. Zeitraum ändern — außerhalb dieser Nächte ist die Kategorie wieder wählbar — oder den bestehenden Block bearbeiten.',
    addBlockSubtitle: 'Neuer Zimmerblock für diese Veranstaltung',
    addBlockCreate: 'Block anlegen',
    addBlockSuccess: 'Block angelegt',
    addBlockSplitSuccess: '{count} Blöcke angelegt',
    addBlockRoomsRequired: 'Bitte mindestens ein Zimmer angeben.',
    addBlockRowsRequired: 'Bitte mindestens eine Kategorie angeben.',
    addBlockDuplicateCategory: 'Jede Kategorie darf im Split nur einmal vorkommen.',
    addBlockSplitAdd: 'Weitere Kategorie',
    addBlockSplitHint: 'Mehrere Kategorien aufteilen, damit das gesamte Kontingent untergebracht wird — je Kategorie ein eigener Block.',
    categoryAlreadyInSplit: 'Bereits im Split',
    categoryAlreadyInSplitHint: 'Diese Kategorie ist bereits in diesem Split enthalten.',
    addBlockMewsHint: 'Der Block wird in MEWS angelegt, sobald die Verfügbarkeit bestätigt ist.',
    overnightMatchShort: 'stimmt',
    overnightOverShort: 'über Plan',
    overnightPlanShort: 'von',
    overnightPlannedShort: 'geplant',
    overnightTargetHint: 'Geplante Übernachtungsgäste am Event',
    overnightMatchHint: 'Reservierungen stimmen mit den geplanten Übernachtungsgästen überein',
    overnightUnderHint: 'Weniger Reservierungen als geplante Übernachtungsgäste',
    overnightOverHint: 'Mehr Reservierungen als geplante Übernachtungsgäste',
    missingShort: 'frei im Block',
    blockApprove: 'Freigeben',
    blockApproveTitle: 'Freigeben und MEWS-Block erstellen',
    blockApproved: 'Block freigegeben — MEWS-Reservierung erstellt.',
    blockApproveInvalidState: 'Nur angeforderte Blöcke können freigegeben werden.',
    blockApproveFailed: 'Freigabe fehlgeschlagen',
    blockApproveHint: 'Die angefragten Zimmer werden in MEWS gebucht und für die Veranstaltung gehalten. Rückgängig nur durch Ablehnen.',
    blockApproveConfirm: 'Freigeben',
    blockReject: 'Ablehnen',
    blockRejectTitle: 'Block-Freigabe ablehnen',
    blockRejectIntro: 'Die Ablehnung ist endgültig — der Block bleibt im System, aber es wird keine MEWS-Reservierung erstellt.',
    blockRejectReason: 'Grund (optional, aber empfohlen)',
    blockRejectReasonPlaceholder: 'z. B. Hotel an diesen Tagen ausgebucht',
    blockRejectConfirm: 'Ablehnung bestätigen',
    blockRejecting: 'Wird abgelehnt …',
    blockRejected: 'Block abgelehnt.',
    blockRejectInvalidState: 'Nur angeforderte Blöcke können abgelehnt werden.',
    blockRejectFailed: 'Ablehnung fehlgeschlagen',
    blockReRequest: 'Erneut anfragen',
    blockReRequestTitle: 'Block erneut zur Hotel-Freigabe senden',
    blockReRequested: 'Block erneut angefragt — wartet auf Hotel-Freigabe.',
    blockReRequestInvalidState: 'Nur abgelehnte Blöcke können erneut angefragt werden.',
    blockReRequestFailed: 'Erneute Anfrage fehlgeschlagen',
    blockNotFound: 'Block existiert nicht mehr.',
    blockDates: 'Termine',
    deleteResMewsWarning: 'Diese Reservierung ist mit MEWS synchronisiert und wird in MEWS storniert.',
    deleteResLocalInfo: 'Diese Reservierung existiert nur im EventHub und wird gelöscht.',
    resCancelledInMews: 'Reservierung wird in MEWS storniert',
    resDeletedFromDb: 'Reservierung wird aus EventHub gelöscht',
    cancelling: 'Wird storniert...',
    cancelReservation: 'Reservierung stornieren',
    cancelMewsNote: 'Diese Reservierung wird auch in MEWS storniert.',
    cannotBeUndone: 'Diese Aktion kann nicht rückgängig gemacht werden!',
    eventsOn: 'Events am',
    noEventsOnDay: 'Keine Events an diesem Tag',
    functionSheetPreview: 'Function Sheet Vorschau',
    proposalDesign: 'Design',
    proposalChooseDesign: 'Design wählen',
    proposalChooseDesignHint: 'Vorschau mit den Daten dieser Veranstaltung.',
    proposalNoPreview: 'Keine Vorschau verfügbar',
    proposalBetaHint: 'Neues Design — noch nicht im Kundeneinsatz erprobt. Bitte vor dem Versand prüfen.',
    proposalChangeDesign: 'Design wechseln',
    proposalPreview: 'Angebots-Vorschau',
    proposals: 'Angebote',
    proposalHotelSchlossDesc: 'Elegantes Angebot im Hotel Schloss Montabaur Stil',
    proposalAdgQuoteDesc: 'ADG-Angebot mit Veranstaltungsdetails und Preisen',
    exportPdf: 'PDF exportieren',
    functionSheet: 'Veranstaltungsplan',
    functionSheets: 'Function Sheets',
    sessionsTab: 'Sessions',
    spacesTab: 'Räume',
    alsoBlocks: 'blockt mit',
    combinedBlocksHint: 'Kombinierter Raum – diese Räume werden mitgeblockt',
    blockedIndirectly: 'geblockt',
    indirectBlockedCount: '{n} indirekt geblockte Räume',
    blockedIndirectlyHint: 'Nicht direkt gebucht – durch einen kombinierten Raum mitgeblockt',
    participantsTab: 'Hotel',
    hotelBlockTab: 'Hotel Block',
    cateringTab: 'Catering',
    equipmentTab: 'Ausstattung',
    infoTab: 'Info',
    seriesTab: 'Serie',
    productsTab: 'Produkte',
    addPackage: 'Paket hinzufügen',
    addProduct: 'Produkt hinzufügen',
    assignedPackages: '{count} Paket | {count} Pakete',
    individualProducts: 'Produkte',
    allProductsPackages: 'Alle Produkte & Pakete',
    wholeEvent: 'Ganzes Event',
    noPackagesAssigned: 'Noch keine Pakete zugewiesen',
    noProductsAssigned: 'Noch keine Einzelprodukte',
    pickPackage: 'Paket wählen',
    localPackages: 'Lokal',
    packages: 'Pakete',
    loadingMewsPackages: 'MEWS Pakete werden geladen...',
    noMewsPackages: 'Keine MEWS Pakete gefunden',
    pickProduct: 'Produkt wählen',
    removePackage: 'Paket entfernen',
    removeProduct: 'Produkt entfernen',
    hardDeleteWarning: 'Dieses Element ist nicht mit MEWS synchronisiert und wird endgültig gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
    softDeleteWarning: 'Dieses Element wurde bereits an MEWS verrechnet und wird als storniert markiert (Soft Delete).',
    confirmRemovePackageTitle: 'Dieses Paket entfernen?',
    confirmRemoveProductTitle: 'Dieses Produkt entfernen?',
    confirmRemoveDesc: 'wird aus diesem Event entfernt. Diese Aktion kann nicht rückgängig gemacht werden.',
    packageTotal: 'Paket-Summe',
    productsSummary: 'Produkt-Übersicht',
    totalValue: 'Gesamtwert',
    priceOverride: 'Preis',
    unitPrice: 'Stückpreis',
    searchPackages: 'Pakete suchen...',
    createNewPackage: 'Neues Paket',
    packageAddedCount: '{count}× hinzugefügt',
    ruleGenerated: 'Automatisch durch Regel erzeugt',
    ruleGeneratedHint: 'Durch eine Regel erzeugt und bei jedem Pickup neu berechnet — hier nicht bearbeitbar.',
    ruleLineOtherCategoryHint: 'Per Regel je Teilnehmer berechnet; die Katalogkategorie des Produkts ist keine F&B-Kategorie, deshalb wird es hier bei den Verpflegungspositionen gef\u00fchrt.',
    ruleLinesMerged: '{count} Teilnehmerzeilen zusammengefasst',
    rulePerLineQtyHint: 'Je Teilnehmer, durch die Regel festgelegt',
    chargeToParticipantsFromRule: 'Je Teilnehmer (Regel)',
    addPackageAgainHint: 'Klicken zum erneuten Hinzufügen (z. B. für eine zweite Sitzung)',
    noPackagesFound: 'Keine Pakete gefunden',
    productsInPackage: 'Produkte',
    chargingType: 'Abrechnungsart',
    pricePerPackage: 'Preis pro Paket',
    viewParticipants: 'Teilnehmer anzeigen',
    participantMissing: 'nicht gefunden',
    chargedParticipantsTitle: 'Belastete Teilnehmer',
    // Berechnungs-Detail (D179) — erklärt eine gebuchte Zeile aus dem im
    // Backend eingefrorenen charge_resolution_snapshot.
    calcOpen: 'Berechnung anzeigen',
    calcDetailTitle: 'Berechnung im Detail',
    calcRule: 'Regel',
    calcPricingDate: 'Preisstichtag',
    calcStateCharged: 'berechnet',
    calcStateResolved: 'ermittelt',
    calcNoDetailTitle: 'Noch keine Berechnung gespeichert',
    calcNoDetailHint: 'Die Aufschlüsselung wird eingefroren, sobald die Zeile an MEWS berechnet wird.',
    calcPackageFactorHint: 'Die Paketpositionen teilen sich einen Gesamtpreis — die Einzelpreise werden anteilig verteilt und weichen daher vom Katalogpreis ab.',
    calcRecipient: 'Empfänger',
    calcRate: 'Rate',
    calcUnitPrice: 'Einzelpreis',
    calcLineTotal: 'Summe',
    calcPriceList: 'Preisliste',
    calcPriceListNotRecorded: 'nicht erfasst',
    calcPriceListManual: 'Manueller Preis',
    calcNotCharged: 'Nicht berechnet',
    calcNotChargedHint: 'nicht in dieser Berechnung — meist nach dem Einfrieren hinzugefügt',
    sessionDeleteBlockedCharged: 'Session "{name}" kann nicht gel\u00f6scht werden: {count} zugeordnete Produktposition(en) wurden f\u00fcr diesen Tag bereits an MEWS verrechnet. Bitte zuerst diese Positionen freigeben oder stornieren.',
    sessionDeleteMovesToEvent: 'Wird zur Veranstaltung verschoben',
    sessionDeleteProductsLine: '{count} Produkt(e)',
    sessionDeletePackagesLine: '{count} Paket(e)',
    sessionMoveChargedWarning: '{count} zugeordnete Produktposition(en) wurden f\u00fcr den bisherigen Tag bereits an MEWS verrechnet. Wird die Session verschoben, \u00e4ndert sich der Abrechnungstag, w\u00e4hrend MEWS die bestehenden Auftr\u00e4ge beh\u00e4lt. Trotzdem verschieben?',
    calcNotChargedNotPresent: 'am Session-Tag nicht anwesend \u2014 diese Position wird nur f\u00fcr diesen einen Tag berechnet',
    calcNotChargedOutside: 'Aufenthalt überschneidet sich nicht mit der Veranstaltung',
    calcFrozenAt: 'Eingefroren am',
    calcTotal: 'Gesamt',
    calcHeadcount: '{payers} Teilnehmer \u00b7 {people} Personen',
    calcHeadcountPayersOnly: '{payers} Teilnehmer',
    calcPackageItems: '{n} Positionen',
    calcShowItems: 'Positionen anzeigen',
    calcHideItems: 'Positionen ausblenden',
    calcOccupancyCurrentHint: 'Aktuelle Belegung ({n} Personen) \u2014 das Zimmer wurde nach der Berechnung ge\u00e4ndert; die eingefrorene Menge passt nicht mehr dazu.',
    calcCustomer: 'Kunde',
    eventNotFound: 'Veranstaltung nicht gefunden',
    chargeTypeUniform: 'Alle Produkte haben dieselbe Abrechnungsart:',
    chargeTypeMixed: 'Produkte haben gemischte Abrechnungsarten — vor dem Belasten prüfen',
    // Ein Paket kann nur berechnet werden, wenn JEDES enthaltene Produkt
    // dieselbe gültige Abrechnungsart hat — sonst lehnt MEWS das ganze Paket ab.
    chargeTypeMissing: 'Mindestens ein Produkt hat keine Abrechnungsart. Das Paket kann erst berechnet werden, wenn jedes Produkt eine Abrechnungsart hat (in der Produktverwaltung setzen).',
    chargingTypeNone: 'kein Typ',
    chargingTypeNoneInPackage: 'Keine Abrechnungsart gesetzt — ein Paket kann erst berechnet werden, wenn jedes enthaltene Produkt eine hat',
    packageMissingChargingType: '{count} Produkt(e) im Paket ohne Abrechnungsart — Abrechnungsart in der Produktverwaltung setzen',
    packageInvalidChargingType: 'Ein Produkt im Paket hat eine ungültige Abrechnungsart',
    packageMixedChargingType: 'Produkte im Paket haben unterschiedliche Abrechnungsarten — MEWS benötigt eine einheitliche',
    package: 'Paket',
    product: 'Produkt',
    productCategory: 'Kategorie',
    productCharging: 'Abrechnung',
    chargeTo: 'Belasten',
    calcMode: 'Berechnung',
    calcModeOnce: 'Einmalig',
    calcModePerDay: 'Pro Tag',
    calcModePerPerson: 'Pro Person',
    calcModePerPersonPerDay: 'Pro Person & Tag',
    calcModeHint: 'Berechnungsart für die Menge (interne Veranstaltung — keine MEWS-Verrechnung).',
    calcModeEffectiveQtyHint: 'Tatsächliche Menge = {mode} ({days} Tage × {people} Pers.)',
    calcModeSaveFailed: 'Berechnungsart konnte nicht gespeichert werden',
    calcModeFromProductHint: 'Aus dem Produkt-Katalog übernommen — kann dort geändert werden.',
    cancelInternalTitle: 'Veranstaltung stornieren?',
    cancelInternalLede: 'Die Veranstaltung wird auf „storniert" gesetzt. Verknüpfte Buchungen werden ebenfalls storniert.',
    confirmStorno: 'Stornieren',
    internalCancelDefaultReason: 'Interne Stornierung',
    chargeToParticipant: 'Teilnehmer',
    chargeToCustomer: 'Kunde',
    chargeAllParticipants: 'Alle Gäste',
    chargeHotelParticipants: 'Nur Teilnehmer (ohne Dozenten & Tagesgäste)',
    chargeLecturerParticipants: 'Nur Dozenten',
    chargeDayguestParticipants: 'Nur Tagesgäste',
    // A scope option the line's charging type cannot use says why IN the option (EH-0186).
    chargeScopeBlockedShort: 'nur bei Preis pro Person',
    chargeScopeHotelHint: 'Reguläre Teilnehmer — ohne Dozenten, Tagesgäste und Externe. Dozenten übernachten meist ebenfalls im Hotel, werden hier aber NICHT belastet (dafür "Nur Dozenten").',
    chargeScopeLecturerHint: 'Alle Dozenten — auch Dozenten, die nur als Tagesgast teilnehmen. Wird auf das Dozenten-Rechnungskonto belastet, nicht auf den Kunden.',
    chargeScopeDayguestHint: 'Alle Teilnehmer mit Tagesgast-Badge, einschließlich Dozenten und Externer, die nur tagsüber da sind. Überschneidet sich daher mit "Nur Dozenten" — die Summen ergeben nicht "Alle Teilnehmer".',
    chargeSelectParticipants: 'Teilnehmer auswählen',
    chargeToChoose: 'Bitte wählen …',
    chargeInternal: 'Intern (nicht an MEWS)',
    chargeInternalHint: 'Intern verbucht — wird nicht an MEWS belastet',
    selectParticipants: 'Teilnehmer zum Belasten auswählen',
    cancelledHidden: '{n} stornierte Reservierung(en) werden nicht angezeigt — nur bestätigte Teilnehmer können belastet werden.',
    cancelledShort: 'storniert',
    lecturersIncluded: '{n} Dozent(en) sind enthalten — Dozenten werden mitbelastet (auf das Dozenten-Rechnungskonto).',
    inclShort: 'inkl.',
    participantsSelected: 'ausgewählt',
    picksNotBilled: '{count} nicht belastbar',
    noParticipants: 'Noch keine Teilnehmer',
    customerNotSet: 'Belastung auf Kunde nicht möglich — kein Kunde für dieses Event hinterlegt. Bitte zuerst einen Kunden setzen.',
    noCustomer: 'kein Kunde',
    allServices: 'Alle Services',
    allCategories: 'Alle Kategorien',
    typeCustom: 'Custom',
    typeInternal: 'Intern',
    allCharging: 'Alle Abrechnungen',
    confirmRemovePackage: 'Paket „{name}" von diesem Event entfernen?',
    confirmRemoveProduct: 'Produkt „{name}" von diesem Event entfernen?',
    loadError: 'Daten konnten nicht geladen werden',
    preview: 'Vorschau',
    sessionFunctionSheetDesc: 'Function Sheet für diese Session.',
    viewEvent: 'Event ansehen',
    externalEventReadonly: 'Dieses Event wird von einem externen System verwaltet und kann hier nicht bearbeitet werden.',
    externalEventLocked: 'Dieses Event wird extern synchronisiert und kann nicht geändert werden',
    eventTimeline: 'Event-Zeitstrahl',
    adgSeminars: 'ADG Seminare',
    date: 'Datum',
    allotted: 'Kontingent',
    pickedUp: 'Abgerufen',
    available: 'Verfügbar',
    noEventsInSeries: 'Keine Events in dieser Serie',
    optional: 'Optional',
    reservationInfo: 'Reservierungsinformation',
    reservationId: 'Reservierungs-ID',
    reservationNumber: 'Reservierungsnummer',
    state: 'Status',
    origin: 'Herkunft',
    groupId: 'Gruppen-ID',
    availabilityBlockId: 'Kontingent-ID',
    guestInfo: 'Gastinformation',
    customerId: 'Kunden-ID',
    guestName: 'Gastname',
    adults: 'Erwachsene',
    children: 'Kinder',
    roomAndDates: 'Zimmer & Daten',
    checkIn: 'Check-in (UTC)',
    checkOut: 'Check-out (UTC)',
    requestedCategoryId: 'Kategorie-ID',
    roomCategory: 'Zimmerkategorie',
    categoryMoveTitle: 'Zimmerkategorie wechseln',
    roomOtherCategory: 'Andere Kategorie',
    roomCategoryChangeTag: 'Kategoriewechsel',
    categoryMoveNeedsRoom: 'Bitte ein Zimmer der neuen Kategorie wählen — sonst bleibt in MEWS das alte Zimmer zugeordnet und die Kategorie ist nur angefragt.',
    pickRoomInNewCategory: 'Zimmer passt nicht zur neuen Kategorie — bitte neu wählen.',
    roomOtherCategoryHint: 'Kategoriewechsel — dieses Zimmer liegt in:',
    noRoomsAvailable: 'Keine Zimmer verfügbar',
    categoryMoveIntro: 'Die Reservierung wechselt in MEWS die Kategorie. Zimmer und Kategorie gehen dabei in einer Aktualisierung — MEWS lehnt ein Zimmer außerhalb der Kategorie ab.',
    roomCategoryChoose: 'Kategorie wählen…',
    pickDatesFirstForCategory: 'Zuerst Zeitraum wählen',
    rateChoose: 'Rate wählen…',
    roomCategoryAdd: 'Kategorie hinzufügen',
    roomTypesUnavailable: 'Keine Zimmerkategorien für diese Property konfiguriert.',
    roomsTotal: 'Gesamt',
    assignedSpaceId: 'Zugewiesene Raum-ID',
    notAssigned: 'Nicht zugewiesen',
    assignedRoom: 'Zugewiesenes Zimmer',
    bookingDetails: 'Buchungsdetails',
    blockInfo: 'Block-Information',
    blockId: 'Block-ID',
    blockNumber: 'Blocknummer',
    datesLabel: 'Daten',
    notesLabel: 'Notizen',
    resourceCategory: 'Ressourcenkategorie',
    firstDate: 'Erstes Datum',
    lastDate: 'Letztes Datum',
    roomCount: 'Zimmeranzahl',
    roomsBlocked: 'geblockt',
    roomsReleased: 'freigegeben',
    businessSegmentId: 'Geschäftssegment-ID',
    na: 'k.A.',
    noEventSelected2: 'Kein Event ausgewählt',
    webinar: 'Webinar',
    seminar: 'Seminar',
    workshop: 'Workshop',
    forum: 'Forum',
    tagung: 'Tagung',
    online: 'Online',
    roomDates: 'Zimmer & Daten',
    checkInUtc: 'Check-in (UTC)',
    checkOutUtc: 'Check-out (UTC)',
    hotelGuest: 'Hotelgast',
    dayGuest: 'Tagesgast',
    external: 'Extern',
    noBlockForHotelPickup: 'Hotel-Pickup nicht möglich — kein Zimmerkontingent für diese Veranstaltung konfiguriert.',
    noHeldBlockForHotelPickup: 'Noch kein Zimmerblock reserviert — das Hotel muss zuerst einen Block freigeben (Veranstaltung auf „Qualifizieren“ setzen), bevor Hotelgäste hinzugefügt werden können. Tagesgäste sind weiterhin möglich.',
    blockExhaustedForHotelPickup: 'Zimmerblock ausgeschöpft — im MEWS-Block ist kein Zimmer mehr frei. Kontingent erhöhen oder eine Reservierung stornieren. Tagesgäste sind weiterhin möglich.',
    allRoomsPickedUp: 'Alle Zimmer vergeben ({used}/{total}). Neues Kontingent anlegen oder bestehende Reservierung entfernen.',
    searchCustomer: 'Kunde in MEWS suchen (min. 4 Zeichen)...',
    roomPreference: 'Zimmerwunsch',
    roomPreferencePlaceholder: 'z.B. Ruhige Lage, Obergeschoss',
    typeOfStay: 'Aufenthaltsart',
    isLecturer: 'Dozent',
    paymentMethod: 'Zahlungsart',
    participantsCountBulk: 'Anzahl Teilnehmer (Bulk)',
    bulkPickupHint: '{n} identische Buchungen werden erstellt.',
    roomsCount: 'Anzahl Zimmer (Bulk)',
    invoiceOwner: 'Rechnungsempfänger',
    invoiceOwnerSet: 'Gesetzt',
    invoiceOwnerNone: 'Kein separater Rechnungsempfänger',
    selectInvoiceOwner: 'Rechnungsempfänger aus MEWS auswählen...',
    selectCustomerShort: 'Kunde auswählen…',
    selectInvoiceOwnerShort: 'Empfänger auswählen…',
    invoiceOwnerApplyOpen: 'Für weitere Teilnehmer übernehmen…',
    invoiceOwnerApplyTitle: 'Rechnungsempfänger übernehmen für',
    invoiceOwnerApplyHint: 'Wird beim Speichern auf die gewählten Teilnehmer übertragen.',
    invoiceOwnerApplyOk: 'Rechnungsempfänger auf {n} Teilnehmer übernommen',
    invoiceOwnerApplyPartial: 'Rechnungsempfänger teils übernommen – einige fehlgeschlagen',
    selectAll: 'Alle',
    invoiceOwnerHint: 'Optional, unabhängig von Gast / Buchender / Firma.',
    invoiceOwnerCompany: 'Rechnungsempfänger / Firma',
    selectInvoiceOwnerCompany: 'Rechnungsempfänger / Firma aus MEWS auswählen...',
    alsoSetAsCompany: 'Auch als Firma gesetzt (MEWS-Firma + K-Nummer).',
    splitFields: 'Trennen',
    combineFields: 'Zusammenführen',
    splitInvoiceCompanyHint: 'Rechnungsempfänger und Firma getrennt setzen',
    combineInvoiceCompanyHint: 'Als ein Feld zusammenführen',
    companyInfoOnly: 'Firma dient nur zur Information (MEWS-Firma + K-Nummer) – sie zahlt nicht. Zahlender ist der Rechnungsempfänger.',
    priceOverwrite: 'Preisüberschreibung',
    priceOverwriteHint: 'Preis wurde manuell überschrieben — abweichend vom Rate-Standard',
    priceColShort: 'Preis',
    priceEditTooltip: 'Preis überschreiben oder anpassen',
    priceEditTitle: 'Preis überschreiben',
    priceEditSubtitleAll: 'Alle Teilnehmer',
    perNight: 'Nacht',
    priceApplyAll: 'Für alle',
    priceApplySingle: 'Nur dieser',
    priceApplyAllOk: 'Preis auf {n} Reservierungen übertragen.',
    priceApplyAllPartial: '{ok} übernommen, {fail} fehlgeschlagen:',
    priceInvalid: 'Ungültiger Preis.',
    priceCurrentMews: 'Aktuell in MEWS',
    priceCurrentMewsHint: 'Aktueller Rate-Preis aus MEWS (nicht überschrieben)',
    priceUseCurrent: 'übernehmen',
    priceAmount: 'Betrag',
    priceReason: 'Grund',
    priceReasonPlaceholder: 'z.B. Sonderkondition',
    linkStatus: 'Block-Bezug',
    linkPickup: 'Pickup',
    linkDetached: 'Detached',
    linkFailed: 'Fehlgeschlagen',
    morning: 'Vormittag',
    afternoon: 'Nachmittag',
    failedEditTitle: 'Fehlgeschlagene Aufnahme — korrigieren und erneut versuchen.',
    failedEditHint: 'Korrigiere die Ursache (z. B. Rate, Datum, Kategorie) und speichere. Die Änderung wird lokal gespeichert; klicke danach auf ↻ in der Liste, um die MEWS-Aufnahme erneut zu versuchen. Zimmer-Zuweisung und Rechnungsempfänger greifen erst nach erfolgreicher Aufnahme.',
    // Variante für Restriktionen. ↻ bleibt bestehen — aber erst NACH einer
    // echten Änderung, und „anderes Datum" ist meist nicht die Änderung, die
    // hilft. Die Zimmerkategorie wird bewusst genannt: MEWS-Restriktionen gelten
    // pro Rate UND pro Kategorie, und die Kategorie wird dabei übersehen.
    failedEditRestrictedTitle: 'Durch eine MEWS-Restriktion abgelehnt — Rate oder Zimmerkategorie ändern.',
    failedEditRestrictedHint: 'MEWS sperrt diese Rate zusammen mit dieser Zimmerkategorie an diesen Tagen (Anreisesperre, Aufenthaltssperre oder Mindest-/Höchstaufenthalt). Es liegt nicht an fehlenden Zimmern — freie Zimmer helfen nicht, und ein bloßer erneuter Versuch schlägt wieder fehl. Bitte Zimmerkategorie oder Rate ändern, speichern und danach auf ↻ in der Liste klicken. Hilft nichts davon, muss die Restriktion in MEWS geprüft werden.',
    linkLinked: 'Linked',
    legacyPickupHint: 'Reservierung hängt noch am Block — Legacy-Form vor Detached-only-Migration',
    legacyDetachedHint: 'Pre-Migration detached — last_action=detached_from_block',
    linkPhantom: 'Phantom',
    phantomLinkTooltip: 'Diese Reservierung teilt sich eine MEWS-ID mit einer anderen, aber die MEWS-Buchung deckt evtl. nicht diese Daten ab. Bitte an der Rezeption prüfen.',
    phantomLinkCancelTitle: 'Phantom-Verknüpfung erkannt',
    phantomLinkCancelHint: 'Diese Reservierung teilt sich eine MEWS-ID mit einer anderen, aber die MEWS-Buchung deckt evtl. nicht diese Daten ab. Bitte vor dem Stornieren mit der Rezeption abklären.',
    renderCapHint: 'Zeige {shown} von {total} – bitte Filter oder Suche verwenden um die Liste einzugrenzen.',
    renderCapShowAll: 'Alle anzeigen',
    prevEvent: 'Vorheriges Event',
    nextEvent: 'Nächstes Event',
    loadingRoomFromMews: 'Zimmer wird von MEWS geladen…',
    roomNotYetAssigned: 'Nicht zugewiesen',
    roomNotYetAssignedTitle: 'MEWS weist Zimmer üblicherweise erst beim Check-in zu.',
    pickCategoryFirstForRoom: 'Zuerst eine Zimmerkategorie wählen',
    noRoomsInCategory: 'Keine Zimmer in dieser Kategorie',
    roomsLoadFailed: 'Zimmer konnten nicht geladen werden',
    roomOccupied: 'belegt',
    roomBlocked: 'Block',
    roomOutOfService: 'außer Betrieb',
    roomCurrent: 'aktuell',
    reservationNotCreated: 'Nicht gebucht',
    reservationNotCreatedTitle: 'MEWS hat keine Reservierung angelegt. Es gibt deshalb weder eine MEWS-Reservierung noch eine Zimmernummer.',
    reservationFailed: 'Reservierung fehlgeschlagen',
    roomMatchesMews: 'Identisch mit MEWS',
    roomMissingInMews: 'In MEWS nicht gesetzt',
    matchesMews: 'Übereinstimmend mit MEWS',
    mewsDriftTitle: 'MEWS hat einen abweichenden Wert — angezeigt wird der MEWS-Wert (überschrieben).',
    roomConflictTitle: 'Dasselbe Zimmer ist im selben Zeitraum {n} weiteren Reservierung(en) zugewiesen — vermutlich wurden mehrere Zeilen durch einen fehlgeschlagenen Pickup auf eine MEWS-Reservierung verlinkt.',
    mewsUnavailableRoomTitle: 'MEWS nicht erreichbar – Zimmer-Status kann nicht geprüft werden.',
    roomMewsCanceledTitle: 'In MEWS bereits storniert – unser System ist noch nicht synchronisiert.',
    roomMewsMissingTitle: 'In MEWS nicht mehr vorhanden – vermutlich storniert und archiviert.',
    roomCategoryFromMews: 'Aus MEWS – kein Wunsch / keine Zuweisung auf unserer Seite gespeichert',
    mewsStatusNotFound: 'nicht gefunden',
    roomTypePickHint: 'Auswählen',
    companyPartySet: 'Firma gesetzt',
    roomTypeMismatchTitle: 'MEWS hat einen anderen Zimmertyp bestätigt als gewünscht',
    roomTypeConfirmed: 'Wunsch bestätigt',
    roomTier: 'Kategorie',
    teilnehmerSearchPlaceholder: 'Name, E-Mail, Firma…',
    teilnehmerSearchScope: 'Sucht in Name, E-Mail und Firma',
    productsColHint: 'R = Reservierung · K = Kunde',
    bulkSelected: '{n} ausgewählt',
    bulkCancel: 'Stornieren',
    bulkClearSelection: 'Auswahl aufheben',
    bulkCancelConfirm: '{n} Reservierungen stornieren?',
    bulkCancelReason: 'Sammelstorno',
    bulkCancelTitle: '{n} Reservierungen stornieren',
    bulkCancelPartial: '{ok} storniert, {fail} fehlgeschlagen.',
    duplicateRowTitle: 'Wie diesen anlegen',
    linkedLegInHouse: 'im Haus',
    linkedLegInHouseTitle: 'Übergang aus vorheriger Veranstaltung',
    linkedLegContinues: 'Folge',
    linkedLegContinuesTitle: 'Reise wird in der nächsten Veranstaltung fortgesetzt',
    updateFailed: 'Aktualisierung fehlgeschlagen',
    updateMissingId: 'Reservierungs-ID fehlt — Aktualisierung nicht möglich.',
    // Ein Retry ersetzt eine fehlgeschlagene Reservierung durch eine neue mit
    // neuer ID. Beide Meldungen erklären, warum die Zeile unter der Hand
    // gewechselt hat — ohne die rohe „Reservation not found"-Fehlermeldung.
    reservationReplacedRetried: 'Diese Reservierung wurde durch einen Retry ersetzt — Ihre Änderung wurde auf die aktuelle Reservierung angewendet.',
    reservationReplacedGone: 'Diese Reservierung wurde durch einen Retry ersetzt und ist nicht mehr auffindbar. Die Liste wurde aktualisiert.',
    swapGuest: 'Gast tauschen',
    swapGuestTitle: 'Gast auf dieser Reservierung tauschen',
    swapGuestSubtitle: 'Reservierung, Folio, Termine und Zimmer bleiben erhalten.',
    swapGuestOld: 'Aktueller Gast',
    swapGuestNew: 'Neuer Gast',
    swapGuestPreservedTitle: 'Bleibt erhalten',
    swapGuestPreservedFolio: 'MEWS-Reservierungsnummer + Folio',
    swapGuestPreservedDates: 'Anreise, Abreise und Aufenthaltsdauer',
    swapGuestPreservedRoom: 'Zugewiesenes Zimmer und Rate',
    swapGuestConfirm: 'Tausch bestätigen',
    swapGuestSwapping: 'Wird getauscht …',
    swapGuestFailed: 'Gasttausch fehlgeschlagen',
    swapGuestMenuHint: 'Gast auf derselben Reservierung ersetzen',
    openInMewsHint: 'Diese Reservierung im MEWS Commander öffnen',
    change: 'Ändern',
    choose: 'Auswählen',
    noChanges: 'Keine Änderungen',
    fieldChanged: 'Feld geändert',
    fieldsChanged: 'Felder geändert',
    invoiceOwnerProducts: 'Positionen für Rechnungsempfänger',
    rateMember: 'Mitglied',
    // Block-Status. 'new' und 'requested' halten in MEWS NICHTS — die Wortwahl
    // muss das klarmachen, sonst liest ein Operator einen Entwurf als echten Hold.
    blockStatusLabel: {
      new: 'Entwurf — kein Hold',
      requested: 'Wartet auf Hotel-Freigabe',
      created: 'Gehalten',
      confirmed: 'Gehalten',
      definite: 'Gehalten',
      rejected: 'Vom Hotel abgelehnt',
      no_availability: 'Keine Verfügbarkeit',
      released: 'Freigegeben',
      delete_pending: 'Löschung ausstehend',
      pending: 'Ausstehend',
      error: 'Fehler',
      canceled: 'Storniert',
      cancelled: 'Storniert',
    },
    saveBlocked: 'Änderung abgelehnt: Die Zimmerkontingente der Veranstaltung sind nicht bereit.',
    statusChangeBlocked: 'Statuswechsel abgelehnt: Die Zimmerkontingente der Veranstaltung sind nicht bereit.',
    // Der Statuswechsel wurde gespeichert, die Zimmeranfrage dahinter nicht (upsert pmsBlockError).
    roomRequestNotSent: 'Die Zimmeranfrage hat das Hotel nicht erreicht. Der Status wurde trotzdem geändert – bitte den Hotel-Tab prüfen und den Fehler melden.',
    warningBlocksNotApproved: 'Einige Zimmerkontingente sind noch nicht vom Hotel freigegeben — der Statuswechsel wird abgelehnt.',
    invoice: 'Rechnung',
    creditCard: 'Kreditkarte',
    companyPayment: 'Firmenrechnung',
    companyName: 'Firma',
    selectCustomerFirst: 'Bitte Kunde suchen und auswählen',
    guestSwapped: 'Gast getauscht.',
    guestSwappedProductsStay: 'Gast getauscht. Bereits berechnete Produkte stehen noch beim bisherigen Gast.',
    guestSwappedProductsReposting: 'Gast getauscht. Bereits berechnete Produkte werden für den neuen Gast neu gebucht.',
    invoiceOwnerChangedProductsReposting: 'Rechnungsempfänger geändert. Bereits berechnete Produkte werden für den neuen Rechnungsempfänger neu gebucht.',
    stayChangedProductsReposting: 'Gespeichert. Bereits berechnete Produkte werden geprüft und bei Bedarf für den geänderten Aufenthalt neu gebucht.',
    swapNeedsParty: 'Der gewählte Kontakt konnte nicht zugeordnet werden – bitte erneut auswählen.',
    datesOutsideEvent: 'Der Aufenthalt muss mindestens einen Tag mit der Veranstaltung ({from} – {to}) gemeinsam haben. Es wurde nichts gespeichert.',
    datesRequired: 'Start- und Enddatum sind erforderlich',
    fromBlock: 'Aus Block',
    signageFrom: 'Von',
    signageTo: 'Bis',
    fnbTab: 'F&B',
    signagePreview: 'Beschilderung Vorschau',
    signageSettings: 'Beschilderung Einstellungen',
    signageLine3: 'Beschilderung Zeile 3',
    signageLine3Placeholder: 'Dritte Zeile des Beschilderungstextes...',
    signageLine3DisabledHint: 'Zeile 3 wird ausgeblendet wenn ein Logo gesetzt ist',
    signageLogo: 'Logo',
    signageLogoLabel: 'Logo (Kontakt-Nr.)',
    signageLogoPlaceholder: 'Kontaktnummer eingeben um Logo anzuzeigen...',
    signageLogoHint: 'Wenn gesetzt, wird ein Firmenlogo angezeigt und Zeile 3 ausgeblendet',
    beschilderung: 'Beschilderung',
    signage: 'Beschilderung',
    signageNotAvailable: 'Digitale Beschilderung ist für diesen Raum nicht aktiviert. Aktivieren unter Einstellungen → Räume.',
  },
  spaceAvailability: {
    title: 'Verfügbarkeit',
    confirmedLegend: 'Bestätigt',
    suggestedLegend: 'Vorgemerkt (buchbar)',
    suggestedHint: 'Nur vorgeschlagene Buchungen – blockieren nicht, Raum ist noch buchbar',
    legendFormat: 'Format',
    legendTotal: 'Gesamt',
    legendGood: 'gut verfügbar (>10)',
    legendTight: 'knapp (1–10)',
    legendNone: 'nichts frei (0)',
    legendOverbooked: 'überbucht',
    today: 'Heute',
    week: 'Woche',
    month: 'Monat',
    year: 'Jahr',
    day: 'Tag',
    available: 'Verfügbar',
    occupied: 'Belegt',
    booked: 'Gebucht',
    maintenance: 'Wartung',
    room: 'Raum',
    capacity: 'Kapazität',
    bookings: 'Buchungen',
    viewDetails: 'Details anzeigen',
    allProperties: 'Alle Objekte',
    all: 'Alle',
    spaces: 'Räume',
    rooms: 'Zimmer',
    withBookings: 'Mit Buchungen',
    withoutBookings: 'Ohne Buchungen',
    searchSpaces: 'Räume suchen...',
    legend: 'Legende',
    spaceTypeFilter: 'Raumtyp-Filter',
    bookingFilter: 'Buchungsfilter',
    loadingData: 'Verfügbarkeitsdaten werden geladen...',
    loadingCategories: 'Zimmerkategorien werden geladen...',
    noCategories: 'Keine Zimmerkategorien gefunden',
    noCategoriesDesc: 'Zimmerkategorien erscheinen hier, sobald verfügbar.',
    stayDetails: 'Aufenthalt Details',
    availabilityBlocks: 'Verfügbarkeitsblöcke',
    noBlocks: 'Keine Verfügbarkeitsblöcke für diesen Tag',
    reservation: 'Reservierung',
    reservations: 'Reservierungen',
    category: 'Kategorie',
    noReservations: 'Keine Reservierungen für diesen Tag',
    noEvent: 'Ohne Event',
    time: 'Zeit',
    customer: 'Kunde',
    noBookings: 'Keine Buchungen',
    noBookingsDesc: 'Keine Raumbuchungen für diesen Tag',
    roomCategory: 'Zimmerkategorie',
    roomsBlocked: 'Zimmer geblockt',
    bookedSpaces: 'gebucht',
    clickToOpen: 'Klicken für Details',
    hotelRoomsTotal: 'Verfügbare Zimmer',
    blockedRooms: 'Geblockte Zimmer',
    meetingRoomsTotal: 'Verfügbare Räume',
    blockedMeetingRooms: 'Geblockte Tagungsräume',
    blocked: 'Blockiert',
    reserved: 'Reserviert',
    totalRooms: 'Gesamt',
    overbooked: 'Überbucht',
    external: 'Extern',
    releasedHint: '{raw} Block-Einheiten unten sichtbar, aber MEWS rechnet nur {held} als belegt — die Differenz wurde wahrscheinlich freigegeben/storniert.',
    pickup: 'Pickup',
    pickedUp: 'Abgerufen',
    direct: 'Direkt',
    pickupHint: 'Auf das Zimmerkontingent der Veranstaltung gebucht — das Kontingent wurde um eins reduziert, also keine zusätzliche Belegung.',
    directHint: 'Direkte Reservierung ohne Block — reduziert das Inventar zusätzlich.',
    unknownReservations: 'davon nicht in EventHub',
    unknownReservationsHint: 'Reservierung existiert in MEWS, aber es gibt keine passende Zeile in unseren Tabellen — z. B. direkt in MEWS Operations angelegt, über einen anderen Kanal, oder ein EventHub-Walk-in (die werden absichtlich nicht gespiegelt). Muss kein Problem sein.',
    clickToVerify: 'Klicken für Details',
    pickupClassification: 'Klassifizierung',
    dateRange: 'Zeitraum',
    assignedRoom: 'Zimmer',
    dbRowRaw: 'DB-Zeile (rohe Felder)',
  },
  // EH-0174 — room size on the room picker, the Räume tab and the checks.
  // Pl. = Plätze. "bis" = no seating chosen, so the largest seating is shown.
  spaceCapacity: {
    hybrid: 'Hybrid',
    noHybrid: 'Kein Hybrid',
    hybridRequired: 'Hybrid-Event – Raum mit Hybrid-Setup nötig',
    hybridFitCount: '{fit} von {total} Räumen haben ein Hybrid-Setup',
    selectedNoHybrid: 'Dieser Raum hat kein Hybrid-Setup, das Event ist aber hybrid.',
    setupFitCount: '{fit} von {total} Räumen eignen sich für {setup}',
    suggestedCount: '{n}× angefragt',
    upTo: 'bis {n} Pl.',
    upToTitle: 'Bis zu {n} Plätze in der größten Bestuhlung. Wie viele es wirklich sind, hängt von der Bestuhlung ab.',
    seats: '{n} Pl.',
    seatsTitle: '{n} Plätze in {setup}',
    noSetupData: '{setup}: keine Angabe',
    noSetupDataTitle: 'Für {setup} ist bei diesem Raum keine Kapazität hinterlegt.',
    bestFit: 'Best Fit',
    tooSmall: 'Zu klein',
    tooSmallAnySeatingTitle: 'Auch in der größten Bestuhlung ({cap} Plätze) zu klein für {pax} Personen.',
    large: 'Groß',
    veryLarge: 'Sehr groß',
    overCapacity: 'Überbelegt ({pax}/{cap})',
    // Change-room dialog confirmations. With a seating: that seating's number.
    // Without one: only what is true in every seating.
    promptTooSmallSeating: '{room} hat in {setup} {cap} Plätze – zu wenig für {pax} Personen.',
    promptTooBigSeating: '{room} hat in {setup} {cap} Plätze – deutlich mehr als nötig für {pax} Personen. {best} ({bestCap} Plätze) passt besser.',
    promptTooSmallAnySeating: '{room} ist auch in der größten Bestuhlung zu klein für {pax} Personen (bis {cap} Plätze).',
    promptTooBigAnySeating: '{room} ist in jeder Bestuhlung größer als nötig für {pax} Personen – selbst die kleinste ({setup}) hat {cap} Plätze.',
  },
  pickupErrors: {
    // Operator-facing text for the typed codes the backend returns when a hotel
    // pickup is refused. Keyed by the backend `code` so a new code cannot
    // silently fall back to English prose. References the ACTUAL German UI
    // labels ("Qualifizieren", "Blöcke prüfen & reparieren"), not the English
    // names used in the code.
    PARTICIPANT_IDENTITY_REQUIRED: 'Diese Buchung konnte nicht zugeordnet werden und wurde nicht gespeichert. Es wurde nichts berechnet. Bitte das Formular schließen, erneut öffnen und noch einmal versuchen — falls es weiterhin auftritt, bitte melden.',
    BLOCK_NOT_YET_APPROVED: 'Hotelfreigabe steht noch aus — das Zimmerkontingent wartet auf die Freigabe durch das Hotel. Eine Zuweisung ist erst nach der Freigabe möglich.',
    BLOCK_FULL: 'Für die gewünschte Kategorie ist noch kein Zimmer reserviert. Ist die Veranstaltung noch eine Anfrage, bitte auf „Qualifizieren“ setzen und das Kontingent vom Hotel freigeben lassen; andernfalls ist das Kontingent voll — bitte ein Zimmer freigeben oder eine andere Kategorie wählen.',
    // Variant of BLOCK_FULL for `details.event_fully_picked_up === true`: EVERY
    // block is exhausted, so the advice above ("eine andere Kategorie wählen")
    // is a dead end — the backend returns an empty claimable_categories.
    BLOCK_FULL_EVENT_EXHAUSTED: 'Das Zimmerkontingent dieser Veranstaltung ist vollständig belegt — in keinem Block ist noch ein Zimmer frei. Eine andere Kategorie hilft hier nicht: bitte das Kontingent vergrößern oder ein Zimmer freigeben, um weitere Gäste aufzunehmen.',
    BLOCK_REJECTED: 'Das Hotel hat diese Buchung abgelehnt — bitte ein anderes Zimmer oder Datum wählen.',
    BLOCK_RECONCILIATION_REQUIRED: 'Das Zimmerkontingent dieser Veranstaltung stimmt nicht mit MEWS überein. Bitte „Blöcke prüfen & reparieren“ für die Veranstaltung ausführen und es dann erneut versuchen.',
    NO_ROOM_IN_TARGET_CATEGORY: 'In der gewünschten Zimmerkategorie ist kein Zimmer mehr frei. Bitte eine andere Zimmerkategorie wählen oder zuerst ein Zimmer freigeben.',
    ROOM_TYPE_UNRESOLVABLE: 'Die gewünschte Zimmerkategorie existiert für dieses Haus nicht. Bitte die Zimmertypen des Hauses prüfen.',
    RATE_ID_UNRESOLVABLE: 'Die gewählte Rate ist für dieses Haus nicht gültig. Bitte eine andere Rate wählen.',
    DATES_OUTSIDE_EVENT: 'Der Aufenthalt hat keinen gemeinsamen Tag mit der Veranstaltung. Früher anreisen oder länger bleiben ist möglich, aber mindestens ein Tag muss in den Veranstaltungszeitraum fallen. Es wurde nichts gespeichert.',
    // Gibt bewusst KEINE Handlungsanweisung: das ist der Sammelfall für eine
    // nicht klassifizierte MEWS-Ablehnung, und die möglichen Ursachen haben
    // gegensätzliche Lösungen. Die klassifizierten Codes unten sagen konkret,
    // was zu tun ist.
    AUTO_DETACH_FAILED: 'MEWS hat diese Buchung abgelehnt — es wurde nichts angelegt und nichts berechnet. Die Begründung von MEWS steht unten. Ein erneuter Versuch mit derselben Kombination führt nicht zum Erfolg.',
    // ── Klassifizierte Ursachen ──────────────────────────────────────────────
    rate_restricted_for_dates: 'MEWS hat diese Buchung abgelehnt: Reservierungen sind für die ausgewählten Tage beschränkt. Ursache ist eine Restriktion in MEWS auf dieser Rate und Zimmerkategorie (Anreisesperre, Aufenthaltssperre oder Mindest-/Höchstaufenthalt) — nicht fehlende Zimmer. Freie Zimmer ändern daran nichts. Bitte eine andere Zimmerkategorie oder Rate versuchen oder die Restriktion in MEWS prüfen lassen. Es wurde nichts angelegt und nichts berechnet.',
    rate_not_valid: 'MEWS akzeptiert die gewählte Rate für diesen Zeitraum und diese Zimmerkategorie nicht („Rate gilt nicht."). Die Rate existiert, ist hier aber nicht anwendbar — bitte eine andere Rate wählen oder die Rate in MEWS korrigieren lassen. Es wurde nichts angelegt und nichts berechnet.',
    rate_not_found: 'Die gewählte Rate existiert in MEWS nicht mehr. Bitte eine andere Rate wählen oder die Rate in MEWS wiederherstellen lassen. Es wurde nichts angelegt und nichts berechnet.',
    MEWS_UPDATE_FAILED: 'MEWS hat die Änderung abgelehnt — es wurde nichts gespeichert.',
    CUSTOMER_SWAP_FAILED: 'Das Gastprofil konnte in MEWS nicht getauscht werden. Es wurde nichts gespeichert.',
    GUEST_NO_MEWS_ID: 'Für diesen Kontakt gibt es kein MEWS-Profil. Bitte einen Kontakt mit MEWS-Profil wählen.',
    BILL_ALREADY_ISSUED: 'Für diesen Aufenthalt wurde bereits eine Rechnung erstellt. Bitte die Rechnung zuerst in MEWS stornieren (Gutschrift) und die Änderung dann wiederholen.',
    GUEST_SWAP_SHARED_CHAIN: 'Dieser Aufenthalt ist mit weiteren Veranstaltungen verknüpft – der Gast kann hier nicht getauscht werden.',
    INVOICE_OWNER_SHARED_CHAIN: 'Dieser Aufenthalt ist mit weiteren Veranstaltungen verknüpft – der Rechnungsempfänger kann hier nicht geändert werden.',
    BILL_STATE_UNKNOWN: 'MEWS war gerade nicht erreichbar, daher wurde nichts geändert. Bitte gleich noch einmal versuchen.',
  },
  reservations: {
    weekStartLabel: 'Woche ab',
    weekStartHint: 'Erster Wochentag in dieser Ansicht. Die KW bleibt die ISO-Kalenderwoche (Montag) — sie zählt weiter wie in BC und MEWS.',
    title: 'Zimmer- & Raumplanungsliste',
    requestedSetup: 'Wunsch aus Session',
    loadingData: 'Reservierungen werden geladen...',
    mewsLoading: 'Belegung wird aus MEWS geladen …',
    mewsLoadFailed: 'Belegung aus MEWS konnte nicht geladen werden.',
    confirmedShort: 'Bestätigt',
    definiteShort: 'Definitiv',
    inquiryShort: 'Anfrage',
    tentativeShort: 'Option',
    cancelledShort: 'Storniert',
    eventStatusTooltip: 'Event-Status',
    bookingsTotal: 'Buchungen',
    filterAll: 'Alle',
    filterWith: 'Belegt',
    filterBlocked: 'Geblockt',
    blockOverbooked: 'Blockzimmer ohne freies Zimmer',
    showBlockedRooms: 'Zimmer mit Blockierung',
    filterWithout: 'Frei',
    showAllRooms: 'Alle Räume zeigen',
    showWithBookings: 'Räume mit Buchungen',
    showWithoutBookings: 'Räume ohne Buchungen',
    showEventName: 'Event-Name zeigen',
    showEventNumber: 'Event-Nr. zeigen',
    eventNumberShort: 'Nr.',
    eventNameShort: 'Name',
    all: 'Alle',
    spaces: 'Räume',
    rooms: 'Zimmer',
    dayGuests: 'Tagesgäste',
    printPdf: 'PDF',
    printPdfHint: 'Aktuellen Zeitraum als PDF speichern oder drucken',
    printPreviewTitle: 'Druckvorschau',
    printBookings: 'Buchungen',
    printEmpty: 'Keine Reservierungen im gewählten Zeitraum.',
    printPrintedOn: 'Stand',
    printColSpace: 'Raum',
    printColRoom: 'Zimmer',
    printColGuest: 'Gast',
    printColEvent: 'Veranstaltung',
    printColFrom: 'Von',
    printColTo: 'Bis',
    printColArrival: 'Anreise',
    printColDeparture: 'Abreise',
    printColPax: 'Pax',
    printColStatus: 'Status',
    event: 'Veranstaltung',
    eventFilter: 'Veranstaltung',
    eventFilterHint: 'Nach Veranstaltung filtern',
    eventsSelected: 'Veranstaltungen',
    searchEvents: 'Veranstaltung suchen…',
    noEvents: 'Keine Veranstaltungen',
    selected: 'ausgewählt',
    reset: 'Zurücksetzen',
    room: 'Zimmer',
    availableInclBlocks: 'Verfügbar (inkl. Blöcke)',
    dailyOccupancy: 'Freie Zimmer pro Tag',
    dailyOccupancyLegend: 'Frei (Reservierungen / Blöcke) · Gesamt',
    freeShort: 'Frei',
    dailySpaceAvailability: 'Freie Räume pro Tag',
    suggestedShort: 'Vorgeschl.',
    collapseGroup: 'Zuklappen',
    categoryMismatchChipHint: 'Zählt nur Reservierungen, die auf diesem Tab ein Zimmer haben — ohne Zimmerzuweisung oder auf einem anderen Tab werden sie hier nicht mitgezählt.',
    syncFilterApply: 'Nur diese Reservierungen zeigen',
    syncFilterClear: 'Filter aufheben',
    syncFilterNone: 'Keine Reservierungen in diesem Status',
    weeksShort: 'Wo.',
    shiftWindowHint: 'Zeitfenster verschieben — gleiche Länge, anderer Ausschnitt (für Aufenthalte über den Monatswechsel)',
    shiftWindowReset: 'Zurück zum Kalendermonat',
    collapseAll: 'Alle zuklappen',
    expandAll: 'Alle aufklappen',
    expandGroup: 'Aufklappen',
    reservationsShort: 'Reserv.',
    blocksShort: 'Blöcke',
    totalShort: 'Gesamt',
    sortByRoomNumber: 'Zimmer-Nr.',
    sortByReserved: 'Reservierungen',
    mewsBusyRetry: 'MEWS verarbeitet gerade eine andere Änderung an dieser Reservierung. Bitte ein paar Sekunden warten und erneut versuchen.',
    moveFailed: 'Die Buchung konnte nicht in den neuen Raum verschoben werden. Es wurden keine Änderungen vorgenommen – bitte erneut versuchen.',
    moveSuperseded: 'Diese Buchung wurde zwischenzeitlich an anderer Stelle geändert. Die Ansicht wurde aktualisiert – bitte den aktuellen Stand prüfen.',
    space: 'Raum',
    spaceRoom: 'Raum / Zimmer',
    booked: 'Gebucht',
    doubleBooking: 'Doppelbuchung',
    multipleRequestsHint: '{n} vorgemerkte Anfragen für diesen Raum zu dieser Zeit (nur eine wird bestätigt)',
    kpiTotalHint: 'Alle Event-Blockungen im sichtbaren Zeitraum (Hotel-Reservierungen werden separat als eigene Blöcke angezeigt).',
    kpiConfirmedHint: 'Events mit Status Bestätigt oder Definitiv.',
    filterConfirmedBookingsHint: 'Bestätigte Raumbuchungen. Klicken zum Filtern; erneut klicken für alle.',
    filterConfirmedReservationsHint: 'Bestätigte Hotelreservierungen, inklusive eingecheckter und abgeschlossener Aufenthalte. Klicken zum Filtern; erneut klicken für alle.',
    filterPendingReservationsHint: 'Noch unbestätigte Hotelreservierungen. Klicken zum Filtern; erneut klicken für alle.',
    filterSuggestedBookingsHint: 'Vorgeschlagene Raumbuchungen. Klicken zum Filtern; erneut klicken für alle.',
    kpiInquiryHint: 'Events mit Status Anfrage — noch nicht bestätigt.',
    kpiDoubleBookingHint: 'Überlappende Buchungen zweier verschiedener Veranstaltungen auf demselben Raum, der nicht als teilbar markiert ist. Jede Überschneidung zählt einmal.',
    kpiDoubleBookingClickHint: 'Klick: nur diese Buchungen anzeigen.',
    kpiCategoryMismatchHint: 'Hotel-Reservierungen, bei denen die zugewiesene Zimmerkategorie NICHT der ursprünglich angefragten entspricht (Downgrade oder Upgrade).',
    categoryMismatchShort: 'Kategorie ≠ Wunsch',
    categoryMismatchTooltip: 'Wunsch → zugewiesen',
    kpiCategoryMismatchClickHint: 'Klick: nur diese Reservierungen anzeigen.',
    checkinShort: 'Check-in',
    checkoutShort: 'Check-out',
    allSizes: 'Alle Größen',
    allRoomTypes: 'Alle Raumtypen',
    spaceTypeSeminar: 'Seminarraum',
    spaceTypeGroup: 'Gruppenraum',
    spaceTypeEvent: 'Veranstaltungsraum',
    spaceTypeEventSeminar: 'VA- & Seminarraum',
    spaceTypeBar: 'Bar',
    spaceTypeLounge: 'Lounge',
    allStreams: 'Alle Streams',
    colName: 'Name',
    colStatus: 'Status',
    bookingStatus: 'Buchungsstatus',
    pax: 'PAX',
    eventType: 'Event-Typ',
    stream: 'Stream',
    participation: 'Teilnahme',
    eventPeriod: 'Event-Zeitraum',
    participantsMinMax: 'Teilnehmer (Min/Max)',
    estRevenue: 'Geschätzter Umsatz',
    contact: 'Kontakt',
    eventNotes: 'Event-Notizen',
    roomBlock: 'Zimmerblock',
    category: 'Kategorie',
    period: 'Zeitraum',
    changeBlock: 'Block ändern',
    arrival: 'Anreise',
    departure: 'Abreise',
    moveToOtherCategory: 'In andere Kategorie verschieben',
    targetCategory: 'Zielkategorie',
    upTo: 'bis',
    noBookingsFound: 'Keine Buchungen für diesen Zeitraum.',
    edit: 'Bearbeiten',
    save: 'Speichern',
    cancel: 'Abbrechen',
    toEvent: 'Zum Event',
    start: 'Start',
    end: 'Ende',
    expectedPax: 'Erwartete PAX',
    setupType: 'Bestuhlung',
    notes: 'Notizen',
    confirmMoveTitle: 'Raum ändern',
    confirmMoveDesc: 'Möchten Sie diese Buchung wirklich verschieben?',
    fromSpace: 'Von Raum',
    toSpace: 'Zu Raum',
    categoryLabel: 'Kategorie',
    categoryMoveWarn: 'Kategorie-Wechsel: Dies ändert die Kategorie der Reservierung in MEWS. Wähle, ob der Aufenthalt neu bepreist wird oder der aktuelle Preis erhalten bleibt.',
    moveReprice: 'Verschieben & neu bepreisen',
    moveKeepPrice: 'Verschieben, Preis behalten',
    date: 'Datum',
    confirmMove: 'Ja, verschieben',
    confirmResizeTitle: 'Zeit ändern',
    confirmResizeDesc: 'Möchten Sie die Zeit dieser Buchung wirklich ändern?',
    from: 'Von',
    to: 'Zu',
    confirmResize: 'Ja, ändern',
    viewDay: 'Tag',
    viewWeek: 'Woche',
    viewMonth: 'Monat',
    dropHere: 'Hier ablegen',
    blocked: 'Belegt',
    sharedBooking: 'Geteilt',
    goToEvent: 'Event öffnen',
    hotelReservation: 'Hotelreservierung',
    checkIn: 'Anreise',
    checkOut: 'Abreise',
    guests: 'Gäste',
    syncedWithMews: 'Mit MEWS synchronisiert',
    mewsOnly: 'Nur in MEWS (nicht in DB)',
    changeRoom: 'Zimmer ändern',
    mewsOnlyNoRoomChange: 'Nur in MEWS — Zimmerwechsel hier nicht möglich',
    dbOnly: 'Nur in DB (nicht in MEWS)',
    deleteBooking: 'Buchung löschen',
    deleteBookingConfirm: 'Möchten Sie diese Raumbuchung wirklich löschen?',
    deleteBookingWarning: 'Diese Aktion kann nicht rückgängig gemacht werden.',
    deleting: 'Löschen...',
    availableRooms: 'Verfügbare Räume',
    details: 'Details',
    moveHere: 'Hierhin verschieben',
    noAvailableRooms: 'Keine freien Räume im Zeitraum.',
    currentRoom: 'Aktueller Raum',
    capacity: 'Kapazität',
    available: 'Frei',
    conflict: 'Belegt',
  },
  cateringOrders: {
    title: 'Catering-Bestellungen',
    newOrder: 'Neue Bestellung',
    editOrder: 'Bestellung bearbeiten',
    deleteOrder: 'Bestellung löschen',
    orderNumber: 'Bestellnummer',
    orderDate: 'Bestelldatum',
    deliveryDate: 'Lieferdatum',
    items: 'Artikel',
    totalAmount: 'Gesamtbetrag',
    pending: 'Ausstehend',
    confirmed: 'Bestätigt',
    delivered: 'Geliefert',
    cancelled: 'Storniert',
  },
  roomOccupancy: {
    showSpaceNotRequired: 'Ohne Raum anzeigen',
    spaceNotRequiredHint: 'Veranstaltungen, die ausdrücklich keinen Seminarraum benötigen, werden hier standardmäßig ausgeblendet.',
    title: 'Freigabeübersicht Seminar- & Veranstaltungsräume',
    loading: 'Belegungsdaten laden...',
    event: 'Events',
    inquiryShort: 'Anfrage',
    cancelledShort: 'Storniert',
    participants: 'Teilnehmer',
    overnightGuests: 'Übernachtungen',
    searchEvents: 'Events suchen...',
    spaceBooking: 'Raumbuchung',
    hotelReservation: 'Hotel',
    sessionBooking: 'Session',
    noSpace: 'Kein Raum',
    roomRequest: 'Raumanfrage',
    eventTime: 'Event-Zeitraum',
    pmsBlock: 'Blockiert/Gebucht',
    roomBlocks: 'Zimmerblöcke',
    rooms: 'Zimmer',
    reservations: 'Reservierungen',
    noReservations: 'Noch keine Reservierungen',
    guest: 'Gast',
    arrival: 'Anreise',
    departure: 'Abreise',
    roomType: 'Zimmertyp',
    state: 'Status',
    meetingSpaces: 'Tagungsräume',
    hotelRooms: 'Hotelzimmer',
    available: 'frei',
    booked: 'Belegt',
    blocked: 'Blockiert',
    pickedUp: 'Gebucht',
    noAvailable: 'Alle Räume belegt',
    total: 'gesamt',
    noBlocks: 'Keine Zimmerblöcke an diesem Tag',
    noEvents: 'Keine Events in diesem Zeitraum',
    assignRoom: 'Raum zuweisen',
    changeRoom: 'Raum ändern',
    clickToAssign: 'Klicken um Raum zuzuweisen',
    requestedSetup: 'Wunsch',
    searchRooms: 'Räume suchen...',
    noRoomsFound: 'Keine Räume gefunden',
    checkingAvailability: 'Verfügbarkeit wird geprüft...',
    current: 'Aktuell',
    removeBooking: 'Buchung entfernen',
    suggested: 'Vorgeschlagen',
    confirmed: 'Bestätigt',
    confirmBooking: 'Bestätigen',
    confirmRoomNamed: '{room} fixieren',
    confirmNeedsEndTime: 'Diese Session hat keine gültige Endzeit, daher lässt sich der Raum nicht freigeben. Bitte die Session öffnen, eine Endzeit setzen und speichern.',
    actionFailed: 'Aktion fehlgeschlagen. Bitte erneut versuchen.',
    roomSuggestedHint: 'Raum nur vorgeschlagen – noch nicht fixiert (unabhängig vom Status der Veranstaltung)',
    suggestedRoomFixHint: '{room} ist für diese Veranstaltung erst vorgeschlagen und noch nicht fixiert. Das ist unabhängig vom Status der Veranstaltung – ein bestätigtes Event behält vorgeschlagene Räume, bis sie hier fixiert werden.',
    suggestedRoomFixHintGeneric: 'Dieser Raum ist für diese Veranstaltung erst vorgeschlagen und noch nicht fixiert – unabhängig vom Status der Veranstaltung.',
    setToSuggested: 'Auf Vorschlag setzen',
    sortBy: 'Sortierung',
    sort_auto: 'Beste Passung',
    sortByName: 'Name A-Z',
    sort_size: 'Größe',
    sort_usage: 'Nutzung',
    sortByDate: 'Datum',
    sortByPax: 'Pax',
    sortByDuration: 'Dauer',
    sortByStream: 'Stream',
    sortByStatus: 'Status',
    sortBySpace: 'Raumbuchung',
    removeBookingTitle: 'Buchung entfernen?',
    removeBookingWarning: 'Die Raumzuweisung wird entfernt. Diese Aktion kann nicht rückgängig gemacht werden.',
    sizeWarningTitle: 'Raumgröße nicht passend',
    chooseDifferent: 'Anderen wählen',
    useAnyway: 'Trotzdem verwenden',
    cancel: 'Abbrechen',
    theatre: 'Theater',
    classroom: 'Klassenzimmer',
    uShape: 'U-Form',
    allTypes: 'Alle Typen',
    allBuildings: 'Alle Gebaeude',
  },
  beo: {
    title: 'Bankett-Veranstaltungsauftrag',
    createBEO: 'BEO erstellen',
    eventDetails: 'Veranstaltungsdetails',
    setupRequirements: 'Aufbauanforderungen',
    foodAndBeverage: 'Speisen & Getränke',
    audioVisual: 'Audio & Video',
    specialRequests: 'Sonderwünsche',
    timeline: 'Zeitplan',
    notes: 'Notizen',
  },
  exporter: {
    title: 'Datenexport',
    selectData: 'Daten auswählen',
    selectFormat: 'Format auswählen',
    exportData: 'Daten exportieren',
    dateRange: 'Datumsbereich',
    from: 'Von',
    to: 'Bis',
    includeArchived: 'Archivierte einbeziehen',
    csv: 'CSV',
    excel: 'Excel',
    pdf: 'PDF',
    json: 'JSON',
  },
  mewsServices: {
    title: 'MEWS Dienstleistungen & Produkte',
    services: 'Dienstleistungen',
    products: 'Produkte',
    rules: 'Regeln',
    selectService: 'Wählen Sie einen Service aus, um seine Produkte und Regeln anzuzeigen',
    loadingServices: 'Lade Dienstleistungen...',
    loadingProducts: 'Lade Produkte...',
    clickToLoadProducts: 'Klicken Sie, um Produkte zu laden',
    searchProducts: 'Produkte suchen...',
    activeOnly: 'Nur aktive',
    noProductsFound: 'Keine Produkte gefunden',
    noRulesFound: 'Keine Regeln für diesen Service gefunden',
    productDetails: {
      ordering: 'Bestellung',
      capacity: 'Kapazität',
      categoryId: 'Kategorie-ID',
      accountingCategoryId: 'Buchhaltungskategorie-ID',
      classifications: 'Klassifizierungen',
    },
    ruleDetails: {
      created: 'Erstellt',
      updated: 'Aktualisiert',
      conditions: 'Bedingungen',
      rateId: 'Raten-ID',
      rateGroupId: 'Ratengruppen-ID',
      businessSegmentId: 'Geschäftssegment-ID',
      resourceCategoryId: 'Ressourcenkategorie-ID',
      origin: 'Herkunft',
      minTimeUnits: 'Min. Zeiteinheiten',
      maxTimeUnits: 'Max. Zeiteinheiten',
    },
  },
  bookingPlan: {
    exportPdf: 'PDF',
    exportPdfHint: 'Wochenplan als PDF speichern oder drucken (Querformat)',
    weekLabel: 'KW {n}',
    printedOn: 'Stand {date}',
    title: 'Belegungsplan',
    subtitle: 'Wöchentliche Hotelzimmerbelegung Übersicht',
    week: 'Woche',
    selectWeek: 'Woche auswählen',
    previousWeek: 'Vorherige Woche',
    nextWeek: 'Nächste Woche',
    thisWeek: 'Diese Woche',
    goToCurrentWeek: 'Zur aktuellen Woche gehen',
    event: 'Veranstaltung',
    loadingData: 'Lade Buchungsdaten...',
    noEvents: 'Keine Veranstaltungen Diese Woche',
    noEventsDescription: 'Es gibt keine Hotelzimmerbuchungen für die ausgewählte Woche',
    free: 'Frei',
    freeCapacity: 'Freie Kapazitäten (Betten-Pool)',
    occupiedCapacity: 'Tatsächlich belegte Kapazitäten',
    totalCapacity: 'zur Verfügung stehenden Kapazitäten',
    of: 'von',
    anreise: 'Anreise (ABN)',
    abreise: 'Abreise (ANN)',
    calendarTitle: 'Blocks & Reservierungen Kalender',
    sollBlocked: 'SOLL (Geblockt)',
    istReserved: 'IST (Reserviert)',
    status: 'Status',
    availabilityAdjustments: 'Verfügbarkeitsanpassungen',
    unitCount: 'Zimmeranzahl',
    rooms: 'Zimmer',
    period: 'Zeitraum',
    reservations: 'Reservierungen',
    customer: 'Kunde',
    state: 'Status',
    email: 'E-Mail',
    loadingCustomers: 'Lade Kundendaten...',
    total: 'Gesamt',
    openInMews: 'In MEWS Commander öffnen',
  },
  analytics: {
    title: 'Analytik',
    subtitle: 'Event-Performance und Einblicke',
    eventsByStreamStatus: 'Events nach Stream und Status',
    eventsByStreamStatusDesc: 'Anzahl der Events gruppiert nach Stream und Status',
    loadingData: 'Analysedaten werden geladen...',
    eventStream: 'Event-Stream',
    numberOfEvents: 'Anzahl der Events',
    events: 'Events',
    total: 'Gesamt',
    noData: 'Keine Daten verfügbar',
    noDataDesc: 'Event-Daten werden hier angezeigt, sobald sie geladen sind',
    monthlyTrend: 'Monatlicher Event-Trend',
    monthlyTrendDesc: 'Anzahl der Events pro Monat im Zeitverlauf',
    hotelTimeline: 'Teilnehmer & geblockte Zimmer im Zeitverlauf',
    hotelTimelineDesc: 'Reservierungen und geblockte Zimmer pro Monat',
    participants: 'Teilnehmer',
    blockedRooms: 'Geblockte Zimmer',
    totalRoomsCapacity: 'Zimmerkapazität',
    allStatuses: 'Alle Status',
    allGuestTypes: 'Alle Gäste',
    hotelGuests: 'Hotelgäste',
    dayGuests: 'Tagesgäste',
    statusDistribution: 'Statusverteilung',
    statusDistributionDesc: 'Aufschlüsselung der Events nach aktuellem Status',
    eventHeatmap: 'Event-Dichte',
    thisMonth: 'Aktueller Monat',
    thisYear: 'Aktuelles Jahr',
    month: 'Monat',
    year: 'Jahr',
    allTime: 'Alle',
    allYears: 'alle Jahre',
    loadError: 'Analysedaten konnten nicht geladen werden',
  },
  stockManagement: {
    title: 'Lagerverwaltung',
    subtitle: 'Bestandsübersicht und Lagerbestandswarnungen',
    refresh: 'Aktualisieren',
    loading: 'Lagerdaten werden geladen...',
    totalValue: 'Gesamtbestandswert',
    totalProducts: 'Lagerbare Produkte',
    lowStockProducts: 'Niedriger Bestand',
    outOfStockProducts: 'Nicht auf Lager',
    inventoryOverview: 'Bestandsübersicht',
    stockByCategory: 'Bestandsstatus nach Produktkategorie',
    recentActivity: 'Letzte Aktivitäten',
    units: 'Einheiten',
    noMovements: 'Keine aktuellen Lagerbewegungen',
    lowStockAlert: 'Niedrigbestandswarnungen',
    items: 'Artikel',
    productName: 'Produkt',
    category: 'Kategorie',
    stock: 'Bestand',
    minimum: 'Min. Bestand',
    status: 'Status',
    outOfStock: 'Nicht auf Lager',
    low: 'Niedrig',
    healthy: 'In Ordnung',
    allStockHealthy: 'Alle Bestände sind in Ordnung',
    allStock: 'Gesamtbestand',
    searchProducts: 'Produkte suchen...',
    onHand: 'Verfügbar',
    reserved: 'Reserviert',
    noProducts: 'Keine Produkte gefunden',
    noData: 'Keine Bestandsdaten verfügbar',
    noDataDesc: 'Bestandsdaten werden hier angezeigt, sobald Produkte hinzugefügt werden',
    uncategorized: 'Ohne Kategorie',
    available: 'verfügbar',
    availableCol: 'Verfügbar',
    overbooked: 'Überbucht',
    viewWeek: 'Woche',
    viewMonth: 'Monat',
    viewQuarter: 'Quartal',
    today: 'Heute',
    movReserved: 'Für Event reserviert',
    movReleased: 'Vom Event freigegeben',
    movAdjusted: 'Menge angepasst',
    movIn: 'Eingang',
    movOut: 'Ausgang',
    stockOverTime: 'Bestandsverlauf',
    stockOverTimeDesc: 'Produktbestände im gewählten Zeitraum',
    last7d: '7 Tage',
    last30d: '30 Tage',
    last90d: '90 Tage',
    allTime: 'Alle',
    settings: 'Einstellungen',
    settingsTitle: 'Lager-Einstellungen',
    settingsSubtitle: 'Lagerfähige Produkte und Standorte konfigurieren',
    stockable: 'Lagerfähig',
    filterAll: 'Alle',
    filterStockable: 'Lagerfähig',
    filterNotStockable: 'Nicht lagerfähig',
    noLocations: 'Noch keine Lagerstandorte konfiguriert. Füge einen hinzu.',
    location: 'Standort',
    floor: 'Etage (Gebäude)',
    selectFloor: 'Etage wählen',
    quantityOnHand: 'Bestand',
    minLevel: 'Min. Menge',
    addLocation: 'Standort hinzufügen',
    enableStockableHint: 'Aktiviere den Lagerfähig-Schalter, um Lagerstandorte zu konfigurieren.',
    productsShown: 'Produkte angezeigt',
    modeGlobal: 'Global',
    modeBuilding: 'Pro Gebäude',
    modeFloor: 'Pro Etage',
    modeGlobalDesc: 'Ein Gesamtbestand für alle Standorte.',
    modeBuildingDesc: 'Separater Bestand pro Gebäude.',
    modeFloorDesc: 'Separater Bestand pro Etage, gruppiert nach Gebäude.',
  },
  valid: {
    filterAll: 'Alle (Gültigkeit)',
    filterLabel: 'Gültigkeit',
    notValidShort: 'Nicht gültig',
    since: 'seit {date}',
    confirmSetBodySession: 'Diese Session ist fertig vorbereitet? Sie wird für alle als gültig angezeigt (bei mehrtägigen Sessions für alle Tage).',
    confirmUnsetBodySession: 'Die Session wieder als nicht gültig markieren?',
    isValid: 'Gültig',
    notValid: 'Noch nicht gültig',
    byAt: 'Gültig gesetzt von {who} am {when}',
    confirmSetTitle: 'Als gültig markieren',
    confirmUnsetTitle: 'Gültig zurücknehmen',
    confirmSetBody: 'Deine Arbeit an diesem Event ist abgeschlossen? Das Event wird für alle als gültig angezeigt.',
    confirmUnsetBody: 'Das Event wieder als nicht gültig markieren?',
    setAction: 'Gültig setzen',
    unsetAction: 'Zurücknehmen',
    noPermission: 'Gültig setzen darf nur, wer die Berechtigung „Events ▸ Mark as Valid“ für den Stream dieser Veranstaltung hat.',
    saveFailed: 'Konnte nicht gespeichert werden.',
    historyTitle: 'Verlauf: Gültig',
    historyEmpty: 'Noch nie gesetzt.',
    historySet: 'Gültig gesetzt',
    historyUnset: 'Gültig zurückgenommen',
  },
  businessSchool: {
    title: 'Business School',
    year: 'Jahr',
    subtitle: 'Veranstaltungen und Studierende der ADG Business School',
    loading: 'Lade Business-School-Daten…',
    loadFailed: 'Daten konnten nicht geladen werden.',
    quarter: 'Quartal',
    kpiEvents: 'Veranstaltungen',
    kpiEventsSub: '{l} Vorlesungen · {e} Klausuren',
    kpiStudents: 'Studierende',
    kpiStudentsSub: '+ {n} Dozenten-Einsätze',
    kpiRegistrations: 'Teilnahmen',
    kpiPerEvent: 'Ø {n} pro Veranstaltung',
    kpiUtilisation: 'Auslastung',
    kpiUtilSub: '{r} von {c} Plätzen',
    kpiHotel: 'Mit Übernachtung',
    kpiHotelSub: '{h} Hotel · {d} Tagesgast',
    tabEvents: 'Veranstaltungen',
    tabStudents: 'Studierende',
    tabProgrammes: 'Studiengänge',
    searchModules: 'Modul oder Nummer suchen…',
    searchStudents: 'Name, E-Mail oder Arbeitgeber…',
    programme: 'Studiengang',
    allProgrammes: 'Alle Studiengänge',
    semester: 'Semester',
    allSemesters: 'Alle Semester',
    semesterN: '{n}. Semester',
    semesterShort: '{n}. Sem.',
    kindAll: 'Alle',
    kindLectures: 'Vorlesungen',
    kindExams: 'Klausuren',
    upcomingOnly: 'Nur kommende',
    noEvents: 'Keine Veranstaltungen in diesem Zeitraum',
    noEventsHint: 'Zeitraum oder Filter ändern.',
    noStudents: 'Keine Studierenden gefunden',
    exam: 'Klausur',
    hybrid: 'hybrid',
    utilTitle: 'Studierende / max. Teilnehmer',
    studentsShort: 'Stud.',
    hotelDay: '{h} Hotel · {d} Tag',
    student: 'Studierende/r',
    employer: 'Arbeitgeber',
    modules: 'Module',
    nextDate: 'Nächster Termin',
    studentCount: '{count} Studierende/r | {count} Studierende',
    noProgramme: 'Ohne Studiengang',
    eventsShort: 'Termine',
    examsShort: 'Klausuren',
    nextOn: 'Nächster Termin: {date}',
    noUpcoming: 'Kein kommender Termin',
  },
  eventRelease: {
    more: '{n} weitere in Hotel-Optimierung',
    search: 'Event oder Nummer suchen…',
    count: '{count} Event | {count} Events',
    loading: 'Lade Freigaben…',
    emptyTitle: 'Keine offenen Freigaben',
    emptyHint: 'Alle Events sind vollständig freigegeben.',
    sideAll: 'Alle',
    sideHotel: 'Hotel',
    sideRooms: 'Räume',
    sideSessions: 'Sessions',
    hotelOpen: 'Hotel: {b} Blöcke · {r} Zi.',
    hotelDone: 'Hotel ok',
    roomsOpen: '{count} Raum offen | {count} Räume offen',
    roomsDone: 'Räume ok',
    sessionsOpen: '{count} Session ohne Raum | {count} Sessions ohne Raum',
    sessionsDone: 'Sessions ok',
    ready: 'Bereit',
    openTotal: '{count} offen',
    openEvent: 'Event öffnen',
    today: 'heute',
    inDays: 'in {n} T.',
  },
  myEvents: {
    countValid: '{n}/{total} gültig',
    countValidSessions: '{n}/{total} Sessions gültig',
    personMe: 'Meine Events',
    personSearch: 'Name oder E-Mail suchen…',
    personNoMatch: 'Keine Treffer',
    viewingOther: 'Events von {name}',
    backToMine: 'Zurück zu meinen',
    showSessions: 'Sessions anzeigen',
    sessionsLoading: 'Sessions werden geladen…',
    noSessions: 'Keine Sessions',
    sessionUnnamed: 'Ohne Namen',
    roleAll: 'Alle',
    rolePm: 'PM',
    roleEm: 'EM',
    rolePmLong: 'Produktmanager',
    roleEmLong: 'Eventmanager',
    showCancelled: 'Stornierte anzeigen',
    matchedAs: 'Gefunden über {local} —',
    loading: 'Lade deine Events…',
    noEmailTitle: 'Deine E-Mail ist nicht bekannt',
    noEmailHint: 'Ohne E-Mail im Benutzerprofil können wir dich keinem Kontakt zuordnen.',
    noPartyTitle: 'Kein Kontakt mit {local} gefunden',
    noPartyHint: "Events werden über den Produkt- oder Eventmanager-Kontakt zugeordnet. Lege dich als Kontakt an (gleicher Teil vor dem {'@'}) und trage dich am Event ein.",
    countEvents: '{count} Event | {count} Events',
    countPax: '{n} Teilnehmer',
    countRunning: '{n} laufend',
    emptyTitle: 'Keine Events in diesem Zeitraum',
    emptyHint: 'Zeitraum oder Filter ändern.',
    running: 'Laufend',
    paxShort: 'TN',
    paxTitle: 'Max. Teilnehmer',
  },
  availabilityPicker: {
    loading: 'MEWS lädt…',
    unknown: 'nicht geladen',
    loadingLong: 'Verfügbarkeit wird aus MEWS geladen — Zahlen folgen gleich.',
    unknownLong: 'Verfügbarkeit konnte nicht aus MEWS geladen werden.',
  },
  contactPicker: {
    sectionOptional: 'Weitere Angaben (optional)',
    sectionPersonal: 'Persönliches',
    sectionNames: 'Rechts-/Vertragsname & Ansprechpartner',
    new: 'Neu',
    createSubtitle: 'Wird direkt in MEWS angelegt und danach ausgewählt.',
    createTitleCustomer: 'Neuer Kunde',
    createTitleCompany: 'Neue Firma',
    createFromSearchCustomer: '„{q}“ als neuen Kunden anlegen',
    createFromSearchCompany: '„{q}“ als neue Firma anlegen',
    invoiceableNotApplied: 'Kunde angelegt \u2014 der Debitor-Status (fakturierbar) wurde in MEWS NICHT gesetzt. Bitte dort im Kundenprofil nachtragen.',
    countryOther: 'Anderes \u2014 Code eingeben\u2026',
    requiredForInvoicing: 'f\u00fcr Debitor erforderlich',
    invoiceableOffHint: 'Ohne dies kann der Kunde nicht fakturiert werden \u2014 das muss sp\u00e4ter in MEWS nachgeholt werden.',
    titleCustomer: 'Kontakt auswählen',
    subtitleCustomer: 'MEWS Kontakte nach Name oder E-Mail suchen',
    titleCompany: 'Firma auswählen',
    subtitleCompany: 'MEWS Firmen nach Name suchen',
    customers: 'Kunden',
    companies: 'Firmen',
    searchCustomers: 'Nach Name oder E-Mail suchen...',
    searchCompanies: 'Nach Firmenname suchen...',
    search: 'Suchen',
    searching: 'Suche läuft...',
    loadingRecent: 'Letzte Einträge laden...',
    noResults: 'Keine Ergebnisse. Andere Suche versuchen.',
    noData: 'Keine Daten verfügbar.',
    results: 'Ergebnisse',
    cancel: 'Abbrechen',
    newCustomer: 'Kontakt hinzufügen',
    newCompany: 'Neue Firma',
    createCustomer: 'Kunde anlegen',
    createCompany: 'Firma anlegen',
    firstName: 'Vorname',
    lastName: 'Nachname',
    email: 'E-Mail',
    phone: 'Telefon',
    companyName: 'Firmenname',
    contactPerson: 'Ansprechpartner',
    contact: 'Kontakt (E-Mail/Telefon)',
    creating: 'Wird angelegt...',
    created: 'Erfolgreich angelegt',
    createError: 'Fehler beim Anlegen',
    backToList: 'Zurück zur Liste',
    required: 'Pflichtfeld',
    sectionIdentity: 'Identität',
    sectionContact: 'Kontakt',
    sectionAddress: 'Adresse',
    sectionBusiness: 'Geschäftliches',
    sectionIdCard: 'Ausweisdokument',
    sectionOptions: 'Optionen & Notizen',
    sectionNotes: 'Notizen',
    secondLastName: 'Zweiter Nachname',
    title: 'Anrede',
    titleMister: 'Herr',
    titleMisses: 'Frau',
    titleMiss: 'Frl.',
    sex: 'Geschlecht',
    sexMale: 'Männlich',
    sexFemale: 'Weiblich',
    sexOther: 'Andere',
    birthDate: 'Geburtsdatum',
    nationalityCode: 'Nationalität (ISO-2)',
    languageCode: 'Sprache (ISO-2)',
    addrLine1: 'Straße',
    addrLine2: 'Adresszusatz',
    addrPostalCode: 'PLZ',
    addrCity: 'Stadt',
    addrCountryCode: 'Land (ISO-2)',
    addrStateCode: 'Bundesland',
    loyaltyCode: 'Loyalty Code',
    taxIdentifier: 'Steuer-ID',
    billingCode: 'Billing Code',
    idNumber: 'Ausweisnummer',
    idType: 'Ausweistyp',
    idIssuance: 'Ausstellungsdatum',
    idExpiration: 'Ablaufdatum',
    sendMarketingEmails: 'Marketing-E-Mails senden',
    sendBillsByEmail: 'Rechnungen per E-Mail senden',
    invoiceable: 'Als Debitor anlegen (fakturierbar)',
    invoiceableHint: 'Erforderlich: Name, E-Mail und vollständige Adresse inkl. Ländercode.',
    notes: 'Notizen',
    telephone: 'Telefon',
    legalName: 'Rechtsname',
    contractualName: 'Vertragsname',
    contactPersonEmail: 'Ansprechpartner E-Mail',
    contactPersonTelephone: 'Ansprechpartner Telefon',
    additionalTaxIdentifier: 'Zusätzliche Steuer-ID',
    accountingCode: 'Buchhaltungscode',
    iata: 'IATA-Nr.',
    degreeOfTrust: 'Vertrauensstufe',
  },
  // Reduktionsschutz ("do not reduce") — eigener Abschnitt, weil Badge und
  // Schalter sowohl in der Hotel-Optimierung als auch im Event-Hotel-Tab
  // erscheinen. Ein gemeinsamer Abschnitt verhindert zwei Übersetzungen
  // desselben Satzes, die auseinanderlaufen.
  reductionProtection: {
    badge: 'Nicht reduzieren',
    badgeShort: 'Geschützt',
    tooltipPlain: 'Zimmer dieses Events dürfen nicht freigegeben werden.',
    tooltipBy: 'Gesetzt von {by}',
    tooltipAt: 'am {at}',
    tooltipReason: 'Grund: {reason}',
    toggleOn: 'Reduktionsschutz aktivieren',
    toggleOff: 'Reduktionsschutz aufheben',
    modalTitleOn: 'Zimmer vor Freigabe schützen',
    modalTitleOff: 'Reduktionsschutz aufheben',
    modalBodyOn: 'Solange der Schutz aktiv ist, lehnt jede Freigabe- und Verkleinerungsfunktion dieses Event ab. Vergrößern und Datumsänderungen bleiben möglich.',
    modalBodyOff: 'Nach dem Aufheben kann dieses Event wieder verkleinert und in die Massenfreigabe aufgenommen werden.',
    reasonLabel: 'Grund (optional)',
    reasonPlaceholder: 'z. B. Gruppe fest zugesagt',
    confirmOn: 'Schutz aktivieren',
    confirmOff: 'Schutz aufheben',
    successOn: 'Reduktionsschutz aktiviert.',
    successOff: 'Reduktionsschutz aufgehoben.',
    failed: 'Reduktionsschutz konnte nicht geändert werden.',
    blockedTitle: 'Freigabe nicht möglich',
    blockedBody: 'Dieses Event ist als „Nicht reduzieren" markiert. Bitte zuerst den Reduktionsschutz aufheben.',
    excludedFromBulk: 'Geschützte Events sind von der Massenfreigabe ausgenommen.',
    notSelectable: 'Geschützt — nicht auswählbar',
  },
  revenueManagement: {
    title: 'Revenue Management',
    subtitle: 'Pace, Pickup-Prognose und das Geld in nicht abgerufenen Blöcken.',
    tabPace: 'Pace & Pickup',
    tabForecast: 'Prognose',
    tabBlocks: 'Blockwert',
    refresh: 'Aktualisieren',
    retry: 'Erneut versuchen',
    loading: 'Umsatzdaten werden geladen…',
    loadFailed: 'Umsatzdaten konnten nicht geladen werden.',
    loadFailedHint: 'Verbindung prüfen und erneut versuchen — das ist kein leerer Zeitraum.',
    daysShort: 'T',
    nights: 'Nächte',
    nightsShort: 'N',
    roomNightsShort: 'ZN',
    staysWord: 'Buchungen',
    blocksWord: 'Blöcke',
    todayLabel: 'heute',
    vsStly: 'vs. VJ',
    noData: 'Keine Zimmernächte in diesem Zeitraum.',
    noForecast: 'In diesem Zeitraum gibt es nichts zu prognostizieren.',
    noBlocks: 'Kein kommender Block hält unverkaufte Zimmer. Nichts zurückzuholen.',
    noCapacity: 'Zimmeranzahl nicht verfügbar',
    sourceLabel: 'Umsatzquelle',
    sourceNote: 'Vergangene Nächte nutzen den tatsächlich in MEWS gebuchten Umsatz (Order Items nach Verbrauchsdatum). Künftige Nächte werden aus der erzielten Durchschnittsrate × Zimmer auf den Büchern abgeleitet — ein Modell, keine Buchung.',
    revenueLoading: 'gebuchter Umsatz wird aus MEWS geladen…',
    revenueUnavailable: 'MEWS-Umsatz ist derzeit nicht verfügbar — €-Werte vergangener Nächte fehlen, die Zimmerzahlen sind unberührt.',
    orderItems: 'Order Items',
    derivedItalicNote: 'Grau-kursive Umsatzwerte sind abgeleitet, nicht gebucht.',
    kpiRoomNights: 'Zimmernächte',
    kpiOccupancy: 'Belegung',
    kpiAdr: 'Durchschnittsrate',
    kpiRevpar: 'RevPAR',
    kpiTrevpar: 'TrevPAR',
    kpiTrevparHint: 'Zimmer + F&B + Sonstiges',
    kpiAtRisk: 'Gehalten, unverkauft',
    occupancyTitle: 'Belegung pro Nacht vs. Vorjahr',
    occupancyDesc: 'Zimmer auf den Büchern ÷ verkaufbare Zimmer. Vorjahr sind dieselben Nächte 364 Tage früher, damit die Wochentage passen.',
    rateTitle: 'Durchschnittsrate und RevPAR pro Nacht',
    rateDesc: 'Beide in €, daher eine gemeinsame Achse. Bis heute aus gebuchtem MEWS-Umsatz, danach aus der erzielten Durchschnittsrate abgeleitet.',
    pickupTitle: 'Wie weit im Voraus gebucht wird',
    pickupDesc: 'Zimmernächte im Zeitraum nach Vorlaufzeit der Buchung. Diese Kurve schreibt die Prognose fort.',
    leadDaysAxis: 'Tage vor Anreise gebucht',
    monthTableTitle: 'Nach Monat',
    monthTableDesc: 'Zimmernächte und Belegung gegen denselben Monat im Vorjahr. Die Tabellenansicht des Diagramms oben.',
    methodLabel: 'Methode',
    methodNote: 'Die Zimmer auf den Büchern werden um das Wachstum hochgerechnet, das die Bücher historisch ab derselben Vorlaufzeit noch hatten, zuzüglich des Anteils der Blockkontingente, der laut Historie abgerufen wird',
    methodCap: 'Begrenzt auf die verkaufbaren Zimmer. Das Band ist die Streuung der historischen Faktoren — kein Konfidenzintervall.',
    methodHistory: 'Historie',
    forecastTitle: 'Prognostizierte Zimmer pro Nacht',
    forecastDesc: 'Heute auf den Büchern gegen den erwarteten endgültigen Pickup. Die graue Linie sind die verkaufbaren Zimmer.',
    forecastTableTitle: 'Prognose nach Monat',
    forecastTableDesc: 'Die Stichprobe zeigt, auf wie vielen historischen Aufenthaltstagen der Pickup-Faktor des Monats beruht — eine kleine Zahl bedeutet eine schwache Prognose.',
    capacityLabel: 'verkaufbare Zimmer',
    adrBasis: 'Ratenbasis',
    basisAchieved: 'erzielt, MEWS',
    basisPriceList: 'Preisliste',
    atRiskTotal: 'Wert im Risiko',
    unsoldNights: 'Unverkaufte Zimmernächte',
    displacing: 'An engen Nächten',
    displacingHint: 'hält bei über 85% Belegung',
    blockValueTitle: 'Was die unverkauften Kontingente wert sind',
    blockValueDesc: 'Zimmer, die ein Block noch unverkauft hält — zur Rate des Blocks bewertet. „Abgerufen“ bezieht sich auf die ursprüngliche Anforderung. Das größte Geld zuerst.',
    blockPriceNote: '€/Nacht ist der Zimmertyp des Blocks zu seiner eigenen Rate aus den Preislisten. “—” bedeutet, dass diese Kombination nicht bepreist ist; dann gilt die erzielte Durchschnittsrate.',
    releaseThem: 'In der Hotel-Optimierung freigeben →',
    colMonth: 'Monat',
    colRoomNights: 'Zimmernächte',
    colLastYear: 'Vorjahr',
    colOccupancy: 'Belegung',
    colRevenue: 'Umsatz',
    colOtb: 'Auf den Büchern',
    colForecast: 'Prognose',
    colBand: 'Band',
    colForecastRevenue: 'Prognostizierter Umsatz',
    colSample: 'Stichprobe',
    colEvent: 'Veranstaltung',
    colDates: 'Datum',
    colStillHeld: 'Noch gehalten',
    colPickedUp: 'Abgerufen',
    colUnsoldRn: 'Unverkaufte ZN',
    colPricePerNight: '€/Nacht',
    colAtRisk: 'Im Risiko',
    colInDays: 'In',
    colPeakOcc: 'Spitzenbelegung',
    seriesThisYear: 'Dieses Jahr',
    seriesLastYear: 'Vorjahr',
    seriesAdr: 'Durchschnittsrate',
    seriesRevpar: 'RevPAR',
    seriesRoomNights: 'Zimmernächte',
    seriesOtb: 'Auf den Büchern',
    seriesForecast: 'Prognose',
    seriesBandHigh: 'Band oben',
    seriesBandLow: 'Band unten',
  },
  hotelOptimisation: {
    bulkNoPermission: 'Keine Berechtigung: Blockverwaltung (Bearbeiten) erforderlich',
    title: 'Hotel-Optimierung',
    subtitle: 'Belegte Zimmer freigeben, bevor sie verloren gehen — Massenfreigabe für bevorstehende Events.',
    tabActions: 'Aktionen',
    tabRelease: 'Hotel-Freigabe',
    tabSpaceConfirmations: 'Raum-Freigabe',
    tabEventRelease: 'Event-Freigabe',
    tabForecast: 'Prognose',
    loadFailed: 'Hotel-Optimierungsdaten konnten nicht geladen werden.',
    loadFailedHint: 'Bitte Verbindung prüfen und erneut versuchen — dies ist keine leere Liste.',
    releaseTitle: 'Offene Freigabeanfragen',
    releaseDesc: 'Die Hotel-Freigabe ist erforderlich, bevor diese Blöcke in MEWS angelegt werden. Frühestes Event zuerst.',
    releaseEmpty: 'Keine offenen Freigabeanfragen.',
    releaseRequested: 'Angefragt',
    releaseAvailable: 'Verfügbar',
    releaseMinAcrossNights: 'Minimum über alle Nächte',
    releasePossible: 'Möglich',
    releaseNotPossible: 'Überkapazität',
    releaseUnknown: 'Unbekannt',
    releaseRequestSingular: 'Anfrage',
    releaseRequestPlural: 'Anfragen',
    releaseApprove: 'Freigeben',
    releaseReject: 'Ablehnen',
    releaseResize: 'Anpassen',
    releaseChangeType: 'Kategorie ändern',
    releaseTooltipOverCap: 'Nicht genügend Zimmer verfügbar — anpassen oder ablehnen',
    releaseTooltipOverCapWarn: 'Diese Kategorie scheint über der Kapazität — MEWS lehnt evtl. ab. Anpassen, Kategorie ändern oder freigeben und MEWS entscheiden lassen.',
    releaseResizeOverWarn: 'Mehr als die für diese Kategorie freien Zimmer — MEWS lehnt den Block evtl. ab. Sie können trotzdem speichern.',
    releaseTypeOverWarn: 'Diese Kategorie hat nicht genügend freie Zimmer für den ganzen Block — MEWS lehnt evtl. ab. Sie können trotzdem speichern.',
    releaseFreeShort: 'frei',
    releaseRoomsShort: 'Zimmer',
    releaseResizeTitle: 'Anzahl der Zimmer reduzieren',
    releaseResizeModalTitle: 'Angefragten Block anpassen',
    releaseResizeLabel: 'Neue Zimmeranzahl',
    releaseTypeTitle: 'Zimmerkategorie ändern',
    releaseTypeModalTitle: 'Zimmerkategorie ändern',
    releaseTypeIntro: 'Die neue Kategorie wird im angefragten Block gespeichert. MEWS verwendet sie bei der Freigabe.',
    releaseTypeLabel: 'Zimmerkategorie',
    releaseRejectTitle: 'Freigabeanfrage ablehnen',
    forecastTitle: 'Blocks vs Pickups Prognose',
    forecastDesc: 'Bestätigte Blöcke (indigo) · Pickups (grün) · Bestätigt + ausstehend (grau gestrichelt). Rot erscheint nur, wenn die Summe die Hotelkapazität überschreitet. Balken = aktive Events an dem Tag.',
    kpiPeakBlocked: 'Spitzenbelegung',
    kpiBlockedNights: 'Belegte Zimmernächte gesamt',
    kpiSpreadNights: 'Spread (offen)',
    kpiSpreadNote: 'ungenutzte Zimmernächte',
    kpiUtilisation: 'Auslastung',
    kpiUtilisationNote: 'Pickups ÷ belegt',
    barVolumeLabel: 'Events pro Tag',
    totalShort: 'gesamt',
    roomCapacity: 'Hotel-Kapazität',
    dayBreakdownEventsShort: 'Events',
    dayBreakdownBlocksShort: 'belegte Zimmer',
    dayBreakdownReservationsShort: 'Reservierungen',
    dayBreakdownBlocks: 'Belegte Zimmer',
    dayBreakdownReservations: 'Reservierungen',
    dayBreakdownEmpty: 'Keine Events an diesem Tag.',
    roomsReleasable: 'freigebbar',
    roomsSuggested: 'empfohlen',
    roomsHeld: 'belegt',
    selectAll: 'Alle auswählen',
    deselectAll: 'Alle abwählen',
    selectedEventsLabel: 'Events ausgewählt',
    bulkReleaseLabel: 'Zimmer freigeben ({n})',
    bulkProposeLabel: '−50% anwenden ({n})',
    bulkRightSizeLabel: 'An Pickups anpassen ({n})',
    bulkTitleRelease: 'Ungenutzte Zimmer freigeben',
    bulkTitlePropose: '−50%-Reduzierung anwenden',
    bulkTitleRightSize: 'An tatsächliche Pickups anpassen',
    bulkSubtitle: 'Die Block-Zimmeranzahl wird reduziert — bestehende Pickups bleiben erhalten.',
    bulkSummaryEvents: 'Betroffene Events',
    bulkSummaryRooms: 'Freigegebene Zimmer',
    bulkPreviewTitle: 'Was wird geändert',
    bulkPreviewNote: 'Block-Zimmeranzahl: vorher → nachher',
    bulkPreviewSkip: 'nichts freizugeben',
    // MEWS-geprüfte Freigabe (EH-0039 Teil 2) / MEWS-verified release
    bulkVerifying: 'Verfügbare Zimmer werden in MEWS geprüft…',
    bulkVerifyingNote: 'Die Freigabe wird gegen den tatsächlichen MEWS-Bestand berechnet, nicht gegen unsere Kopie.',
    bulkVerifyFailed: 'Prüfung gegen MEWS fehlgeschlagen',
    bulkVerifyFailedNote: 'Es wurde nichts geändert. Ohne bestätigten MEWS-Bestand wird keine Freigabe angeboten — bitte später erneut versuchen.',
    bulkSkipPartial: 'in MEWS nicht prüfbar',
    bulkSkipNoBlocks: 'kein aktiver Block',
    bulkSkipUnverified: 'nicht geprüft',
    bulkSkipVerifyFailed: 'in MEWS nicht erreichbar',
    bulkPreviewDrift: 'DB wich ab',
    bulkHeadsUpVerified: 'Zahlen stammen aus MEWS, nicht aus unserer Kopie. Nicht prüfbare Events werden übersprungen.',
    bulkPreviewRelease: 'Freigabe',
    bulkHeadsUpTitle: 'Hinweis',
    bulkHeadsUpMews: 'MEWS wird zuerst aktualisiert — die DB wird nur gespeichert, wenn MEWS akzeptiert.',
    bulkHeadsUpRev: 'Bestehende Pickups bleiben erhalten. Nur die ungenutzte Kapazität wird freigegeben.',
    bulkHeadsUpRetry: 'Fehler werden am Ende aufgelistet — fehlgeschlagene Operationen können erneut versucht werden.',
    bulkConfirm: 'Freigabe bestätigen',
    bulkRunning: 'Freigabe läuft … {done}/{total}',
    bulkResultSuccessTitle: 'Zimmer freigegeben',
    bulkResultPartialTitle: 'Mit Fehlern abgeschlossen',
    bulkResultOk: 'erfolgreich',
    bulkResultFailed: 'fehlgeschlagen',
    bulkResultRooms: 'Zimmer insgesamt',
    bulkResultFailureLabel: 'Diese Events sind fehlgeschlagen:',
    bulkResultAllOk: 'Jedes ausgewählte Event wurde erfolgreich angepasst.',
    roomsShort: 'Zimmer',
    historyButton: 'Shrink-Verlauf',
    historyTooltip: 'Letzte 50 Shrink-Operationen anzeigen',
    historyTitle: 'Shrink-Verlauf',
    historySubtitle: 'Letzte 50 Bulk-Resize-Operationen, neueste zuerst.',
    historyEmpty: 'Noch keine Bulk-Resize-Operationen.',
    historyEntries: 'Einträge',
    historyOpenEvent: 'Event öffnen',
    justNow: 'gerade eben',
    errMewsVerifyShort: 'MEWS hat die Reduzierung stillschweigend abgelehnt.',
    errMewsVerifyHint: 'Vermutlich würden bestehende Reservierungen verwaisen — kleinere Schritte versuchen oder den Block manuell prüfen.',
    errMews5xxShort: 'MEWS-Server-Fehler (5xx).',
    errMews5xxHint: 'Temporäres MEWS-Problem — in ein paar Minuten erneut versuchen.',
    errMewsRejectShort: 'MEWS hat die Änderung abgelehnt.',
    errSystemShort: 'Unbekannter Fehler.',
    errShowDetails: 'Details',
    errHideDetails: 'Details ausblenden',
    alreadyOptimised: 'Bereits optimiert',
  },
  noShow: {
    settleOpen: 'Abrechnen…',
    confirmNoShowTitle: 'No-Show abrechnen',
    confirmStornoTitle: 'Storno abrechnen',
    settled: 'Produkte abgerechnet (No-Show)',
    noShowScope: 'Nur unsere Produkte — die Reservierung bleibt in MEWS.',
    stornoScope: 'Mit Gebühr: Produkte nach Stornoregel + Zimmer-Storno in MEWS. Ohne: keine Gebühr, alle Produkte storniert.',
    stornoWithFee: 'Storno mit Gebühr',
    stornoWithoutFee: 'Storno ohne Gebühr',
    saveFailed: 'Entscheidung nicht gespeichert',
    previewCharge: 'Gebühr ansehen',
    nothingToCharge: 'Keine Produkte zu berechnen',
    chargeWillBeRefused: 'Wird abgelehnt: Storno-/No-Show-Produkte in der Administration fehlen oder eine Zeile hat keinen Preis',
    chargeNoShow: 'Ausfall berechnen (nur Produkte)',
    chargeStorno: 'Storno berechnen & stornieren',
    cancelReasonNoShow: 'No-Show',
    cancelReasonStorno: 'Storno (No-Show-Board)',
    intro: 'Teilnehmer, deren Anreisetag vorbei ist, die aber nicht erschienen sind (in MEWS weder eingecheckt noch storniert). Pro Teilnehmer festlegen: No-Show oder Storno — dann die Gebühr ansehen und berechnen (die Produkte werden berechnet, danach wird storniert).',
    loading: 'Lade Teilnehmer und MEWS-Status…',
    empty: 'Keine offenen No-Shows im Zeitraum.',
    future: 'Der Zeitraum liegt in der Zukunft — No-Shows gibt es erst nach dem Anreisetag.',
    mewsUnchecked: 'MEWS konnte nicht gelesen werden — die Liste kann bereits eingecheckte Gäste enthalten.',
    notChecked: 'nicht geprüft',
    notCheckedHint: 'Kein MEWS-Status — keine MEWS-Reservierung oder MEWS nicht erreichbar',
    colGuest: 'Teilnehmer', colEvent: 'Event', colType: 'Art', colStay: 'Aufenthalt', colMews: 'MEWS', colDecision: 'Entscheidung',
    typeHotel: 'Hotel', typeDayguest: 'Tagesgast', typeLecturer: 'Dozent',
    decideNoShow: 'No-Show', decideNoShowHint: 'Als No-Show markieren',
    decideStorno: 'Storno', decideStornoHint: 'Als Storno markieren',
    withdraw: 'Entscheidung zurücknehmen',
    filterOpen: 'Offen', filterAll: 'Alle',
    you: 'Du',
  },
  conflictResolution: {
    tabNoShow: 'No-Show',
    title: 'Conflict Board',
    subtitle: 'Datenprobleme bei Events erkennen und lösen',
    conflicts: 'Konflikte',
    type: 'Typ',
    refresh: 'Aktualisieren',
    tabConflicts: 'Konflikte',
    tabWasting: 'Zimmerverschwendung',
    tabHotelOptimisation: 'Hotel-Optimierung',
    scopeAllUpcoming: 'Alle bevorstehenden Events',
    eventCount: 'Events',
    roomsShort: 'Zimmer',
    roomsReleasableTitle: 'Anzahl Zimmer, die sofort freigegeben werden können',
    roomsSuggestedTitle: 'Anzahl Zimmer, die in Summe zur Reduzierung vorgeschlagen werden',
    roomsAtRiskTitle: 'Anzahl Zimmer, die für diese Kleingruppen-Events belegt sind',
    optList1Title: 'Jetzt freigeben',
    optList1Desc: 'Startet innerhalb 30 Tagen · sortiert nach nicht abgerufenen Zimmern',
    optList1Empty: 'Keine kurzfristigen Überbuchungen zum Freigeben.',
    optList2Title: '−50% vorschlagen',
    optList2Desc: '31–60 Tage im Voraus · offene Zimmer um die Hälfte reduzieren',
    optList2Empty: 'Keine mittelfristigen Überbuchungen zum Reduzieren.',
    optList3Title: 'Kleine Gruppen',
    optList3Desc: 'Startet innerhalb 90 Tagen · weniger als 7 bestätigte Pickups',
    optList3Empty: 'Keine kleinen Gruppen in den nächsten 90 Tagen.',
    notPickedUp: 'Offen',
    suggestRelease: 'Freigeben',
    pickups: 'Pickups',
    wastingTitle: 'Zimmerverschwendungs-Rangliste',
    wastingDesc: 'Sortiert nach verschwendeten Nächten × Dringlichkeit. Nahe Events mit großem Overblock führen.',
    noWasting: 'Keine Zimmerverschwendung erkannt',
    noWastingDesc: 'Bei allen kommenden Events entsprechen die blockierten Zimmer der Teilnehmerzahl.',
    blocked: 'Blockiert',
    actual: 'Tatsächlich',
    spread: 'Differenz',
    days: 'Tage',
    wastedRoomNights: 'Verschwendete Nächte',
    wastedRoomNightsTooltip: 'Nicht verkaufte Zimmer × Eventdauer',
    totalRoomNights: 'Gesamt Nächte',
    totalRoomNightsTooltip: 'Blockiert × Eventdauer — gesamtes Kontingent des Events',
    today: 'heute',
    inOneDay: 'in 1 Tag',
    inNDays: 'in {n} Tagen',
    loading: 'Konflikte werden gesucht...',
    noConflicts: 'Keine Konflikte erkannt',
    noConflictsDesc: 'Alle Events und Sessions sehen gut aus.',
    periodPast: 'Zeitraum liegt in der Vergangenheit',
    periodPastDesc: 'Das Board zeigt nur laufende und künftige Veranstaltungen — abgeschlossene lassen sich nicht mehr korrigieren.',
    pastEvents: 'Vergangene',
    pastShow: 'Auch abgeschlossene Veranstaltungen anzeigen',
    pastHide: 'Nur laufende und künftige Veranstaltungen anzeigen',
    triggerNoSpace: 'Kein Raum',
    triggerNoSpaceSession: 'Kein Raum (Session)',
    triggerHotelBlockMissing: 'Hotel Block fehlt',
    triggerHotelBlockDifference: 'Hotel Block Differenz',
    triggerRoomTooSmall: 'Raum zu klein',
    triggerRoomTypeMismatch: 'Zimmertyp ≠ Gastwunsch',
    triggerHotelBlockError: 'Hotel Block Fehler',
    triggerChargeError: 'Verrechnung-Fehler',
    triggerChargeNoOrder: 'Verrechnet ohne MEWS-Beleg',
    triggerInternalCharged: 'Intern, trotzdem verrechnet',
    triggerParticipantError: 'Teilnehmer Fehler',
    triggerParticipantNoCapacity: 'Teilnehmer keine Kapazität',
    triggerUnlinkedFollowup: 'Folge nicht verknüpft',
    triggerInvoiceOwner: 'Rechnungsempfänger nicht übernommen',
    free: 'frei',
    descEventNoSpace: 'Dieses Event hat keine Raumbuchung.',
    descSessionNoSpace: 'Session in {event} hat keine Raumbuchung.',
    descNoOvernightGuests: '{maxPax} Teilnehmer aber 0 Übernachtungsgäste konfiguriert.',
    descNoBlock: '{overnight} Übernachtungsgäste aber kein Zimmerblock reserviert.',
    descBlockMismatch: '{overnight} Übernachtungsgäste aber {blocked} Zimmer geblockt.',
  },
  fnbEquipment: {
    pmsCharged: 'PMS-Posten',
    pmsChargedHint: 'Im PMS berechnet, aber nicht von EventHub gesendet: Kasse, Rezeption, Frühstück zur Übernachtung. Zählt bei aktivierter Ansicht in die Pax-Zahl.',
    pmsChargedTitle: 'Im PMS berechnet (nicht von EventHub)',
    pmsOnlyFilter: 'Nur PMS',
    printWithPms: 'PMS-Positionen',
    printPmsHint: 'Druckt zusätzlich die bereits im PMS berechneten Positionen. Standardmäßig aus: der Küchenzettel zeigt nur den Bedarf, nicht bereits Berechnetes.',
    pmsToggle: 'PMS',
    collapseAll: 'Alle zuklappen',
    expandAll: 'Alle aufklappen',
    pmsChargedEmpty: 'Für diesen Zeitraum hat das PMS keine fremden Posten.',
    pmsChargedAmount: 'Betrag',
    pmsLoading: 'Lädt PMS-Posten aus MEWS …',
    pmsLoadingDay: 'Ein Tag — dauert meist einige Sekunden.',
    pmsLoadingWeek: 'Sieben Tage — das kann eine halbe Minute dauern.',
    pmsNoQuantity: 'Das PMS liefert für diese Zeile keine verlässliche Menge — die Anzahl steht nur im Buchungstext.',
    originPms: 'PMS-Produkt',
    originExternal: 'Kasse / extern',
    fromPms: 'aus PMS',
    title: 'F&B / Equipment',
    subtitle: 'Tagesübersicht für Küche, IT und Housekeeping',
    events: 'Events',
    pax: 'zu verpflegen',
    paxHint: 'Personen, die an diesem Tag laut Produkten und Paketen verpflegt werden',
    uncharged: 'nicht verrechnet',
    unchargedHide: 'Nur verrechnete Positionen anzeigen — wie im Reporting',
    chargedOnly: 'Nur verrechnete',
    unchargedShow: 'Auch noch nicht verrechnete Positionen anzeigen',
    allCategories: 'Alle',
    fnb: 'F&B',
    equipment: 'Equipment',
    service: 'Service',
    other: 'Sonstiges',
    products: 'Produkte',
    product: 'Produkt',
    quantity: 'Menge',
    noProducts: 'Keine Produkte an diesem Tag',
    noProductsHint: 'Wählen Sie einen anderen Tag oder fügen Sie Produkte zu Events hinzu.',
    total: 'Gesamt',
    preview: 'Vorschau',
    exportPdf: 'PDF Export',
    thisWeek: 'Diese Woche',
    productsTab: 'Produkte & Equipment',
    lunchTab: 'Mittagessen',
    lunchShowEvents: 'Events anzeigen',
    lunchSitting: 'Mittagszeit',
    lunchUnset: 'Nicht gesetzt',
    lunchAtTime: '{time} Uhr',
    lunchEmpty: 'Keine Mittagsgäste in dieser Woche',
    lunchHint: 'Bestätigte Gäste pro Tag, gruppiert nach der Mittagszeit des Events.',
  },
  auditLog: {
    viewLog: 'Protokoll',
    viewActivity: 'Aktivität pro Nutzer',
    activity: {
      week: 'Woche', month: 'Monat', quarter: 'Quartal',
      searchUser: 'Nutzer suchen…', usersLabel: 'Nutzer',
      kpiActiveUsers: 'Aktive Nutzer', kpiChanges: 'Änderungen', kpiPerUser: 'Ø pro aktivem Nutzer', kpiBusiest: 'Am aktivsten',
      changesShort: 'Änderungen', noPrev: 'keine Vorperiode', vsPrev: 'ggü. Vorperiode',
      user: 'Nutzer', activeDays: 'Aktive Tage', activeDaysHint: 'Tage mit mindestens einer Änderung in der aktuellen Periode',
      mix: 'Art (aktuell)', mostlyOn: 'Meist an', lastActive: 'Zuletzt aktiv',
      empty: 'Keine Aktivität in diesem Zeitraum',
      footnote: 'Gezählt werden Einträge im Audit-Log (eine Änderung = ein Eintrag). Systemänderungen ohne Nutzer sind nicht enthalten.',
    },
    title: 'Änderungslog',
    subtitle: 'Alle Änderungen und Aktionen im System verfolgen',
    entries: 'Einträge',
    refresh: 'Aktualisieren',
    searchPlaceholder: 'Logs durchsuchen...',
    allTypes: 'Alle',
    allActions: 'Alle Aktionen',
    allUsers: 'Alle Benutzer',
    actionCreate: 'Erstellt',
    actionUpdate: 'Aktualisiert',
    actionDelete: 'Gelöscht',
    reset: 'Zurücksetzen',
    loading: 'Audit-Logs werden geladen...',
    noEntries: 'Keine Audit-Log-Einträge gefunden.',
    dateRange: 'Zeitraum wählen',
  },
  errorLog: {
    title: 'Fehlerlog',
    subtitle: 'Systemfehler, Warnungen und Probleme überwachen',
    entries: 'Einträge',
    refresh: 'Aktualisieren',
    searchPlaceholder: 'Fehler suchen...',
    allTypes: 'Alle',
    allSeverities: 'Alle Stufen',
    allSources: 'Alle Quellen',
    allStatuses: 'Alle Status',
    resolved: 'Gelöst',
    unresolved: 'Offen',
    markResolved: 'Als gelöst markieren',
    markUnresolved: 'Wieder öffnen',
    reset: 'Zurücksetzen',
    loading: 'Fehlerlogs werden geladen...',
    noEntries: 'Keine Fehlerlog-Einträge gefunden.',
    loadFailed: 'Die Abfrage ist fehlgeschlagen — dies ist KEINE Entwarnung.',
    dateRange: 'Zeitraum wählen',
  },
  miceBoard: {
    showTerminal: 'Verloren & Storniert',
    showTerminalHint: 'Verlorene und stornierte Events als eigene Spalten anzeigen',
    searchAllEvents: 'Alle Events durchsuchen…',
    statPipelineValue: 'Pipeline-Wert',
    statWithEstimate: '{n} von {total} mit Prognose',
    statWeighted: 'Gewichteter Forecast',
    statWeightedSub: 'nach Phase',
    statWeightedHint: 'Prognose × Abschlusswahrscheinlichkeit der Phase: Inquiry 10 %, Qualify 25 %, Proposal 50 %, Tentative 75 %, Definite 100 %',
    statThisMonth: 'Events diesen Monat',
    statLostCancelled: 'Verloren / Storniert',
    paxN: '{n} Pers.',
    roomsN: '{n} Zimmer',
    daysN: '{n} Tage',
    staleHint: '{n} Tage seit der letzten Änderung',
    live: 'Live',
    liveHint: 'Findet gerade statt',
    pastLabel: 'Vergangen',
    addRevenue: '+ Umsatz',
    dropHere: 'Hierher ziehen',
    moreActions: 'Weitere Aktionen',
    openEvent: 'Event öffnen',
    title: 'MICE Board',
    subtitle: 'Vertriebspipeline, Funnel und Kennzahlen',
    showPast: 'Vergangene anzeigen',
    hidePast: 'Vergangene ausblenden',
    pastShown: 'Vergangene sichtbar',
    pastHidden: 'Nur aktuelle',
    addEstimateHint: 'Erwarteten Umsatz hinzufügen',
    createInquiryTitle: 'Neue MICE-Anfrage',
    loading: 'MICE Board wird geladen...',
    allStreams: 'Alle Streams',
    allSales: 'Alle Verkäufer',
    refresh: 'Aktualisieren',
    today: 'Heute',
    yearView: 'Jahr',
    totalEvents: 'Gesamt Events',
    activePipeline: 'Aktive Pipeline',
    confirmed: 'Bestätigt',
    conversionRate: 'Abschlussrate',
    lost: 'Verloren',
    cancelledKpi: 'Storniert',
    avgDaysToClose: 'Ø Tage bis Abschluss',
    staleEvents: 'Inaktive Events',
    inDateRange: 'im Zeitraum',
    inquiries: 'Anfragen',
    tentatives: 'Vorläufig',
    proposals: 'Angebote',
    closedLost: 'Verloren',
    cancelledEvents: 'Stornierte Events',
    fromInquiry: 'von Anfrage bis Definit',
    noActivityHint: 'kein Update seit 7+ Tagen',
    salesFunnel: 'Vertriebstrichter',
    events: 'Events',
    pipeline: 'Pipeline',
    noEvents: 'Keine Events',
    lostCancelled: 'Verloren & Storniert',
    lostLast30: 'Verloren (30 Tage)',
    cancelledLast30: 'Storniert (30 Tage)',
    lostThisYear: 'Verloren (dieses Jahr)',
    cancelledThisYear: 'Storniert (dieses Jahr)',
    cancellationRate: 'Stornoqoute',
    conversionMetrics: 'Konversions-Kennzahlen',
    inquiryToProposal: 'Anfrage → Angebot',
    proposalToDefinite: 'Angebot → Definit',
    overallConversion: 'Gesamtkonversion',
    noActivity7Days: 'Events ohne Aktivität',
    staleEventsHint: 'Diese Events benötigen Nachverfolgung',
    forecastNext3Months: 'Prognose — Nächste 3 Monate',
    definite: 'Definit',
    tentative: 'Vorläufig',
    total: 'Gesamt',
    tasks: 'Aufgaben',
    addTask: 'Aufgabe hinzufügen',
    taskTitle: 'Aufgabentitel...',
    priorityLabel: 'Priorität',
    priorityLow: 'Niedrig',
    priorityMedium: 'Mittel',
    priorityHigh: 'Hoch',
    dueDate: 'Fälligkeitsdatum',
    linkedEvent: 'Verknüpftes Event',
    assignee: 'Zugewiesen an',
    unassigned: 'Nicht zugewiesen',
    noEvent: 'Kein Event',
    cancel: 'Abbrechen',
    save: 'Speichern',
    taskAll: 'Alle',
    taskOpen: 'Offen',
    taskDone: 'Erledigt',
    noTasks: 'Keine Aufgaben',
    eventName: 'Eventname',
    dates: 'Datum',
    daysInStage: 'Tage in Phase',
    lastUpdated: 'Zuletzt aktualisiert',
    updated: 'Aktualisiert',
    searchEvents: 'Events suchen...',
    moveToNextStage: 'Nächste Phase',
    actions: 'Aktionen',
    configReasons: 'Absagegründe',
    configReasonsHint: 'Gründe verwalten, die beim Absagen oder Verlieren eines Events angezeigt werden',
    noReasons: 'Noch keine Gründe konfiguriert',
    newReasonPlaceholder: 'Neuen Grund hinzufügen...',
  },
  miceAnalytics: {
    lossByMonthTitle: 'Verloren & Storniert pro Monat',
    lossByMonthSub: 'Nach Absagegrund — gezählt im Monat der Entscheidung',
    lossByMonthEmpty: 'In diesem Jahr wurde nichts verloren oder storniert.',
    lossKindAll: 'Alle',
    lossUndated: '{n} weitere ohne Datum der Entscheidung (kein Status-Verlauf) — nicht im Diagramm.',
    lossAdgTitle: 'Absage durch ADG',
    lossAdgSub: 'Von ADG abgesagt — nach Grund, im Monat der Entscheidung',
    lossCustomerTitle: 'Storno Kunde',
    lossCustomerSub: 'Vom Kunden storniert — nach Grund, im Monat der Entscheidung',
    lostRevenueTitle: 'Verlorener Umsatz (entgangen)',
    lostRevenueSub: 'Geplanter Umsatz verlorener & stornierter Events — nach Datum der Veranstaltung',
    lostRevenueEmpty: 'Kein verlorener Umsatz in diesem Jahr.',
    title: 'MICE Analytik',
    subtitle: 'Performance-Einblicke & Trends',
    loading: 'Analytik wird geladen...',
    totalEvents: 'Gesamt Events',
    won: 'Gewonnen',
    lostCancelled: 'Verloren / Storniert',
    pending: 'Ausstehend',
    inPipeline: 'In Pipeline',
    avgDaysToWin: 'Ø Tage bis Gewinn',
    daysAvg: 'Tage Durchschnitt',
    winRate: 'Gewinnrate',
    ofTotal: 'vom Gesamt',
    active: 'aktiv',
    vsLastYear: 'ggü. Vorjahr',
    totalLabel: 'Gesamt',
    monthlyTrend: 'Monatlicher Event-Trend',
    conversionFunnel: 'Conversion Funnel',
    lossAnalysis: 'Verlust-Analyse',
    noLosses: 'Keine verlorenen oder stornierten Events in diesem Zeitraum',
    lostBy: 'Verloren nach Kategorie',
    customerDecision: 'Kundenentscheidung',
    noAvailability: 'Keine Verfügbarkeit',
    otherReasons: 'Sonstige',
    unspecified: 'Nicht angegeben',
    performanceOverview: 'Performance-Übersicht',
    byEventType: 'Nach Eventtyp',
    forecast6Months: '6-Monats-Prognose',
    definite: 'Definitiv',
    tentative: 'Vorläufig',
    avgLeadTime: 'Durchschnittliche Vorlaufzeit',
    inquiryToWin: 'Anfrage → Gewinn',
    avgForWon: 'Durchschnitt für gewonnene Events',
    inquiryToTentative: 'Anfrage → Vorläufig',
    avgForTentative: 'Durchschnitt für vorläufige Events',
    avgPipelineAge: 'Pipeline-Alter',
    openEvents: 'Aktuell offene Events',
    conversionMetrics: 'Conversion-Kennzahlen',
    noData: 'Keine Daten verfügbar',
    seasonality: 'Saisonalität',
    lessActive: 'Weniger aktiv',
    moreActive: 'Aktiver',
  },
  permissions: {
    noStreamRight: 'Keine Berechtigung für diesen Stream (Rollen & Rechte)',
  },
  blockManager: {
    title: 'Block Manager',
    subtitle: 'Zimmerblöcke je Veranstaltung — gehalten, abgerufen, freigebbar',
    property: 'Hotel',
    today: 'Heute',
    week: 'Woche',
    month: 'Monat',
    quarter: 'Quartal',
    kpiHeld: 'Zugeteilte Zimmer',
    kpiHeldSub: 'Gebucht + frei · {n} inkl. angefragt',
    kpiPicked: 'Gebucht',
    kpiPickedSub: '{pct}% der zugeteilten Zimmer',
    kpiReleasable: 'Frei im Block',
    kpiReleasableSub: 'Noch gehalten, nicht gebucht — freigebbar',
    kpiNeverRelease: 'Ohne Freigabedatum',
    kpiNeverReleaseSub: 'Zimmer werden nie automatisch frei',
    colEvent: 'Veranstaltung',
    colPeriod: 'Zeitraum',
    colRelease: 'Freigabe',
    colTotal: 'Gesamt',
    neverRelease: 'Keine Freigabe',
    neverReleaseHint: 'Ohne Freigabedatum hält MEWS die nicht gebuchten Zimmer dauerhaft (NeverRelease).',
    releaseHint: 'Datum, an dem nicht gebuchte Zimmer zurück in den freien Verkauf gehen',
    releaseToday: 'heute',
    releasePassed: 'erfolgt',
    cellTitle: '{picked} gebucht · {free} frei im Block · {size} gesamt',
    cellNoBlock: 'Kein Block in dieser Kategorie',
    state_held: 'In MEWS gehalten',
    state_requested: 'Angefragt — noch kein MEWS-Hold',
    state_draft: 'Entwurf — hält keine Zimmer',
    state_failed: 'Fehlgeschlagen',
    state_closed: 'Freigegeben / storniert',
    loadFailed: 'Blockdaten konnten nicht geladen werden',
    emptyTitle: 'Keine Veranstaltungen in diesem Zeitraum',
    emptyHint: 'Zeitraum wechseln oder ein anderes Hotel wählen.',
    noCategoriesTitle: 'Keine Zimmerkategorien',
    noCategoriesHint: 'Für dieses Hotel sind keine aktiven Zimmerkategorien hinterlegt.',
    legendCell: 'Gebucht / Gesamt',
    legendMeaning: '— Gesamt = gebuchte Zimmer + im Block noch freie Zimmer. MEWS nimmt jedes gebuchte Zimmer aus dem Block; was frei bleibt, kann freigegeben werden. Angefragte Blöcke halten noch nichts.',
    legendExample: 'Beispiel 2/3: 3 Zimmer zugeteilt, 2 gebucht, 1 frei',
  },
  contacts: {
    filterStorno: 'Storno',
    filterNoShowDone: 'No-Show',
    filterOutstanding: 'Ausstehend',
    openInMews: 'In MEWS \u00f6ffnen',
    noMewsLink: 'Kein MEWS-Profil-Link f\u00fcr diesen Eintrag',
    openInEvent: 'Im Event \u00f6ffnen',
    stay: 'Aufenthalt',
    address: 'Adresse',
    debitor: 'Debitor',
    invoiceable: 'Fakturierbar',
    notInvoiceable: 'Nicht fakturierbar',
    findInMews: 'In MEWS suchen',
    title: 'Kontakte',
    customers: 'Kunden',
    companies: 'Unternehmen',
    search: 'Kontakte suchen...',
    searchMews: 'In MEWS suchen (mind. 3 Zeichen)...',
    searching: 'Suche...',
    loadingMews: 'Laden aus MEWS...',
    name: 'Name',
    email: 'E-Mail',
    source: 'Quelle',
    phone: 'Telefon',
    firstName: 'Vorname',
    lastName: 'Nachname',
    nationality: 'Nationalität',
    loyalty: 'Loyalty-Code',
    companyName: 'Firmenname',
    contactPerson: 'Ansprechpartner',
    contact: 'Kontakt',
    taxId: 'Steuernummer',
    customerDetail: 'Kundendetails',
    companyDetail: 'Unternehmensdetails',
    noResults: 'Keine Ergebnisse',
    empty: 'Noch keine Kontakte',
    emptyDesc: 'Kontakte erscheinen hier, wenn sie über Events erstellt oder aus MEWS synchronisiert werden.',
    tryDifferent: 'Versuchen Sie einen anderen Suchbegriff.',
    mewsHint: 'Kunden oder Unternehmen in MEWS suchen',
    mewsHintDesc: 'Geben Sie mindestens 3 Zeichen ein, oder durchsuchen Sie aktuelle Einträge.',
    bcComingSoon: 'Business Central Integration kommt bald.',
    bcCustomers: 'Kunden',
    bcCompanies: 'Firmen',
    bcContacts: 'Kontakte',
    bcVendors: 'Lieferanten',
    bcNumber: 'Nr.',
    bcCompanyName: 'Firma',
    bcPhone: 'Telefon',
    bcCity: 'Ort',
    bcLoadFailed: 'Business-Central-Daten konnten nicht geladen werden.',
    results: 'Ergebnisse',
    searchBc: 'Business Central suchen (min. 2 Zeichen)…',
    bcSearchPrompt: 'Keine Einträge in Business Central',
    bcSearchHint: 'Für diese Auswahl hat Business Central nichts geliefert.',
    bcFirstPage: 'Erste {n} — zum Eingrenzen suchen',
    retry: 'Erneut versuchen',
    kind_contacts: 'Kontakte',
    kind_companies: 'Firmen',
    kind_customers: 'Kunden',
    kind_participants: 'Teilnehmer',
    participants: 'Teilnehmer',
    all: 'Alle',
    dayguest: 'Tagesgast',
    external: 'Extern',
    // Per-type filter pills (participant_type). `otherHotel` sleeps in a
    // different hotel; internal/external guest are the internal-event kinds.
    otherHotel: 'Anderes Hotel',
    online: 'Online',
    internalGuest: 'Intern (ADG)',
    externalGuest: 'Extern',
    type: 'Typ',
    event: 'Event',
    arrival: 'Anreise',
    departure: 'Abreise',
    nights: 'Nächte',
    rate: 'Rate',
    searchParticipants: 'Teilnehmer suchen...',
    noParticipants: 'Keine Teilnehmer gefunden',
    syncFromMews: 'Aus MEWS synchronisieren',
    syncSuccess: 'Kontakt aus MEWS synchronisiert',
    syncFailed: 'Synchronisation fehlgeschlagen',
    createSuccess: 'Kontakt erfolgreich erstellt',
    createFailed: 'Kontakt konnte nicht erstellt werden',
  },
  propertySetup: {
    accountModal: {
      address: 'Adresse',
    },
    title: 'Einstellungen',
    subtitle: 'Räume, Ausrüstung, Menüs, Raten und mehr konfigurieren',
    webhooks: {
      title: 'Webhooks',
      formatTitle: 'Format',
      formatEventHub: 'EventHub (JSON)',
      formatChat: 'Mattermost / Slack',
      formatChatHint: 'Die URL sieht nach einem Mattermost-/Slack-Webhook aus — dafür das Format „Mattermost / Slack“ wählen, sonst lehnt der Empfänger die Nachricht ab.',
      formatChatExplain: 'Sendet eine Chat-Nachricht (Feld „text“). Authentifizierung: keine — der Schlüssel steckt in der URL.',
      messageTemplate: 'Nachricht (optional)',
      messageTemplatePlaceholder: 'Leer = Standardtext je Auslöser, z. B. „Reservierung storniert · #123 (Event #45)“',
      messageTemplateHelp: 'Platzhalter:',
      intro: 'Registriere Ziel-URLs (z. B. Business Central), die bei bestimmten System-Events aufgerufen werden — etwa um bei einer Status-Änderung einer Reservierung den Status im Zielsystem zu aktualisieren.',
      add: 'Webhook hinzufügen',
      deliveryNotice: 'Die Endpunkte werden gespeichert. Die tatsächliche Auslieferung (das Auslösen bei System-Events) benötigt die Backend-Aktivierung und ist noch nicht aktiv.',
      selectProperty: 'Bitte zuerst eine Property auswählen.',
      empty: 'Noch keine Webhooks registriert.',
      unnamed: 'Unbenannt',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      activate: 'Aktivieren',
      deactivate: 'Deaktivieren',
      noEvents: 'Keine Events gewählt',
      editTitle: 'Webhook bearbeiten',
      addTitle: 'Neuer Webhook',
      name: 'Name',
      namePlaceholder: 'z. B. Business Central – Event-Status',
      url: 'Ziel-URL',
      urlInvalid: 'Bitte eine gültige https-URL angeben.',
      secret: 'Signatur-Secret (optional)',
      secretPlaceholder: 'HMAC-Signatur-Header, damit der Empfänger uns verifizieren kann',
      authTitle: 'Authentifizierung am Zielsystem',
      username: 'Benutzername',
      password: 'Passwort',
      keyValue: 'Key-Wert',
      testConnection: 'Verbindung testen',
      probing: 'Teste…',
      probeNeedsUrl: 'https-URL eingeben, dann testen',
      probeWithAuth: 'mit Auth',
      probeWithoutAuth: 'ohne Auth',
      probeOk: 'Erreichbar — Authentifizierung wird geprüft und akzeptiert.',
      probeOpen: 'Erreichbar, aber der Endpunkt nimmt auch Aufrufe OHNE Authentifizierung an.',
      probeAuthRejected: 'Endpunkt erreichbar, aber die Zugangsdaten wurden abgelehnt.',
      probeNotFound: 'Host antwortet, aber unter dieser Adresse gibt es keinen Endpunkt (404/405) — URL prüfen.',
      probeEndpointError: 'Endpunkt antwortet mit einem Fehler.',
      probeUnreachable: 'Nicht erreichbar — keine Antwort (DNS, TLS, Firewall oder Zeitüberschreitung).',
      credsNote: 'Zugangsdaten werden verschlüsselt neben den übrigen Integrations-Einstellungen der Property gespeichert.',
      events: 'System-Events, die diesen Webhook auslösen',
      activeLabel: 'Aktiv (löst aus, sobald die Auslieferung im Backend aktiv ist)',
      saveError: 'Speichern fehlgeschlagen.',
      confirmDelete: 'Diesen Webhook wirklich löschen?',
      mappingTitle: 'Feld- & Wert-Mapping',
      mappingHint: 'Übersetze unsere Werte in die des Zielsystems — z. B. Status „cancelled“ → „0“.',
      addMapping: 'Mapping',
      noMapping: 'Mindestens ein Mapping ist erforderlich.',
      sourceField: 'Unser Feld (z. B. status)',
      targetField: 'Zielfeld (z. B. Status)',
      ourValue: 'unser Wert (z. B. cancelled)',
      targetValue: 'Zielwert (z. B. 0)',
      addValue: 'Wert',
      mappingShort: 'Mapping',
      step1: 'Name & Ziel',
      step2: 'Auslöser',
      required: 'Pflicht',
      orHint: 'ODER-Verknüpfung: der Webhook wird ausgelöst, sobald EINES der gewählten Events eintritt.',
      needName: 'Name fehlt',
      needUrl: 'Gültige https-Ziel-URL fehlt',
      needEvents: 'Mindestens einen Auslöser wählen',
      needMapping: 'Mindestens ein vollständiges Mapping (Feld + Wert-Paar) definieren',
      logsTitle: 'Logs (letzte 10)',
      logsEmpty: 'Noch keine Auslieferungen — die Backend-Auslieferung ist noch nicht aktiv.',
      logTime: 'Zeit',
      logEvent: 'Event',
      logStatus: 'Status',
      logResult: 'Ergebnis',
      settings: 'Einstellungen',
      settingsTitle: 'Zustellungs-Einstellungen',
      settingsHint: 'Gilt für alle Webhooks dieser Property. Poll-Intervall und Batch-Größe sind prozessweit (Server-Konfiguration).',
      maxAttempts: 'Max. Versuche',
      timeoutSec: 'Timeout (Sek.)',
      backoffBase: 'Retry-Basis (Sek.)',
      backoffExplain: 'Retry-Basis verdoppelt sich pro Versuch (z. B. 30s → 60s → 120s …), max. 30 Min.',
      enabledLabel: 'Zustellung aktiviert',
      enabledOn: 'Events werden an die Endpunkte gesendet.',
      enabledOff: 'Alle Webhooks dieser Property sind pausiert — es wird nichts gesendet.',
      deactivated: 'Deaktiviert',
    },
    tabs: {
      spaces: 'Räume',
      products: 'Produkte',
      rules: 'Produkt Regeln',
      webhooks: 'Webhooks',
      packages: 'Pakete',
      series: 'Veranstaltungsreihen',
      tags: 'Tags',
      mews: 'MEWS',
      equipment: 'Equipment',
      fnb: 'F&B',
      rates: 'Raten',
      roomTypes: 'Hotelzimmer',
      storno: 'Storno-Regeln',
      accountingCategories: 'Buchungskategorien',
      taxCodes: 'Steuercodes',
      priceLists: 'Preislisten',
      tax: 'Steuern',
      hotelOptimizer: 'Hotel Optimizer',
    },
    viewMap: 'Karte anzeigen',
    buildingsFloors: 'Gebäude & Etagen',
    venueMap: 'Lageplan',
    mews: {
      customers: 'Kunden',
      customersDesc: 'MEWS Kundendaten',
      searchCustomers: 'Suchen und durchsuchen Sie MEWS Kundendaten',
      companies: 'Firmen',
      companiesDesc: 'MEWS Firmendaten',
      searchCompanies: 'Suchen und durchsuchen Sie MEWS Firmendaten',
      products: 'Produkte',
      productsDesc: 'MEWS Produkte & Services',
      searchProducts: 'Suchen und durchsuchen Sie MEWS Produkte',
      clickToSearch: 'Klicken zum Suchen',
      searchPlaceholder: 'Suchbegriff eingeben...',
      search: 'Suchen',
      searching: 'Suche läuft...',
      noResults: 'Keine Ergebnisse gefunden',
      noResultsDesc: 'Versuchen Sie einen anderen Suchbegriff',
      browseServices: 'Wählen Sie einen Service um Produkte anzuzeigen',
      browseServicesBtn: 'Services durchsuchen',
      selectService: 'Service auswählen',
      viewProducts: 'Produkte anzeigen',
      invoiceable: 'Rechnungsfähig',
      noProductsForService: 'Keine Produkte für diesen Service gefunden',
      perTimeUnit: 'Pro Zeiteinheit',
      once: 'Einmalig',
      categoryId: 'Kategorie-ID',
      external: 'Extern',
      backToServices: 'Zurück zu Services',
    },
    selectProperty: 'Objekt auswählen',
    selectPropertyPrompt: 'Objekt auswählen',
    selectPropertyDescription: 'Wählen Sie ein Objekt aus dem Dropdown-Menü oben aus, um seine Einstellungen zu konfigurieren',
    setDefault: 'Als Standard setzen',
    defaultProperty: 'Standard',
    loadingPropertyData: 'Objektdaten werden geladen...',
    properties: 'Objekte',
    spaces: 'Räume',
    rooms: 'Zimmer',
    equipment: 'Ausrüstung',
    amenities: 'Ausstattung',
    rates: 'Raten',
    taxes: 'Steuern',
    users: 'Benutzer',
    roles: 'Rollen',
    menus: 'Menüs',
    searchEquipment: 'Equipment suchen…',
    equipmentCountLabel: 'Equipment',
    searchMenuItems: 'Gerichte suchen…',
    menuItemsCountLabel: 'Gerichte',
    menuCategories: 'Kategorien',
    dietaryRestrictions: 'Ernährungsformen',
    noMenuItemsMatch: 'Keine Gerichte gefunden',
    searchRates: 'Raten suchen…',
    stornoTitle: 'Storno-Regeln je Rate',
    stornoName: 'Regel',
    stornoScope: 'Gilt für',
    stornoUnnamed: 'Ohne Namen',
    stornoInactive: 'inaktiv',
    stornoPortfolio: 'Portfolio',
    stornoEmpty: 'Noch nicht synchronisiert — MEWS-Synchronisation starten.',
    stornoSyncedAt: 'zuletzt synchronisiert {at}',
    stornoCountLabel: 'Regeln',
    stornoSub: 'Aus MEWS synchronisiert, wie Raten und Hotelzimmer. MEWS ist die führende Quelle — Änderungen dort vornehmen und hier neu synchronisieren.',
    stornoRules: 'Regeln',
    stornoDeadlineCol: 'Greift ab',
    stornoFeeCol: 'Gebühr',
    stornoBasisCol: 'Berechnet auf',
    stornoCapCol: 'Deckel',
    stornoCapValue: 'max. {n} Nächte',
    stornoNoCap: 'ohne Deckel',
    stornoNoFee: 'keine Gebühr',
    stornoAnchorOther: 'Stichtag zählt ab {anchor}, nicht ab Anreise',
    stornoNoRule: 'Keine Regel hinterlegt',
    stornoGroupsTitle: 'Regeln je Ratengruppe',
    stornoGroupsSub: 'So gelten die Regeln in MEWS: jede Rate gehört zu einer Ratengruppe, die Regel hängt an der Gruppe.',
    stornoGroupCol: 'Ratengruppe · Raten',
    stornoArrival: 'Anreise {time}',
    stornoRatesMore: '+{n} weitere',
    stornoRatesLess: 'weniger',
    stornoNoRates: 'keine Rate in EventHub',
    stornoGroupsEmpty: 'Noch keine Regeln je Ratengruppe — MEWS-Synchronisation starten.',
    stornoWithoutRuleTitle: 'Raten ohne Storno-Regel',
    stornoWithoutRuleSub: 'Für diese Raten ist in MEWS keine Storno-Regel hinterlegt. Das ist ein Hinweis auf fehlende Daten, keine Zusage einer kostenfreien Stornierung.',
    stornoCatalogueTitle: 'MEWS-Katalog',
    stornoCatalogueSub: 'Die benannten Regel-Vorlagen in MEWS. Sie gehören zu keinem Service, darum ist bei „ab Anreisezeit“-Regeln keine Uhrzeit bekannt.',
    stornoFailed: 'Storno-Regeln konnten nicht geladen werden. Das heißt NICHT, dass kostenfrei storniert werden kann.',
    ratesCountLabel: 'Raten',
    newRate: 'Neue Rate',
    noRatesMatch: 'Keine passenden Raten',
    tagsTab: {
      search: 'Tags suchen…',
      countLabel: 'Tags',
      type: 'Typ',
      allTypes: 'Alle Typen',
      add: 'Tag hinzufügen',
      noMatch: 'Keine passenden Tags',
      emptyTitle: 'Noch keine Tags',
      emptyHint: 'Tags helfen beim Kategorisieren und Filtern von Events, Sessions, Räumen und mehr.',
      untyped: 'Ohne Typ',
    },
    searchTaxRatesShort: 'Steuersätze suchen…',
    taxRatesCountLabel: 'Steuersätze',
    noTaxRatesMatch: 'Keine passenden Steuersätze',
    taxCodeColumn: 'Steuercode',
    percentageColumn: 'Prozentsatz',
    productsTab: {
      colName: 'Name',
      colCategory: 'Kategorie',
      colType: 'Typ',
      colTax: 'Steuer',
      colAccCat: 'Buchungskat.',
      colCharging: 'Abrechnung',
      colStreams: 'Streams',
      colActive: 'Aktiv',
      newProduct: 'Neues Produkt',
      editProduct: 'Produkt bearbeiten',
      search: 'Produkte suchen…',
      countLabel: 'von {total} Produkten',
      type: 'Typ',
      allTypes: 'Alle Typen',
      categories: 'Kategorien',
      add: 'Hinzufügen',
      emptyTitle: 'Noch keine Produkte',
      emptyHint: 'Aus MEWS importieren oder manuell anlegen.',
      noMatch: 'Keine passenden Produkte',
    },
    buildingsShort: 'Gebäude',
    spacesCountLabel: 'Räume',
    features: 'Merkmale',
    setupTypes: 'Aufbauarten',
    newProperty: 'Neues Objekt',
    editProperty: 'Objekt bearbeiten',
    newSpace: 'Neuer Raum',
    editSpace: 'Raum bearbeiten',
    deleteSpace: 'Raum löschen',
    propertyName: 'Objektname',
    address: 'Adresse',
    city: 'Stadt',
    country: 'Land',
    phone: 'Telefon',
    email: 'E-Mail',
    code: 'Code',
    floor: 'Etage',
    theatre: 'Stuhlreihen',
    classroom: 'Parlamentarisch',
    uShape: 'U-Form',
    block: 'Block',
    round: 'Rund',
    retreat: 'Klausur',
    boardroom: 'Konferenzraum',
    banquet: 'Bankett',
    reception: 'Empfang',
    searchSpaces: 'Räume suchen...',
    noSpacesConfigured: 'Keine Räume konfiguriert',
    noSpacesMatch: 'Keine Räume entsprechen Ihrer Suche',
    gridView: 'Rasteransicht',
    tableView: 'Tabellenansicht',
    gallery: 'Galerie',
    list: 'Liste',
    splitView: 'Split',
    addSpace: 'Raum hinzufügen',
    createSpace: 'Raum erstellen',
    noSpacesFound: 'Keine Räume gefunden',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    name: 'Name',
    description: 'Beschreibung',
    capacity: 'Kapazität',
    area: 'Fläche',
    addEquipment: 'Ausrüstung hinzufügen',
    noEquipmentFound: 'Keine Ausrüstung gefunden',
    createEquipment: 'Ausrüstung erstellen',
    quantity: 'Menge',
    addMenuItem: 'Menüpunkt hinzufügen',
    noMenuItemsFound: 'Keine Menüpunkte gefunden',
    createMenuItem: 'Menüpunkt erstellen',
    category: 'Kategorie',
    price: 'Preis',
    addRate: 'Rate hinzufügen',
    noRatesFound: 'Keine Raten gefunden',
    createRate: 'Rate erstellen',
    rateType: 'Ratentyp',
    amount: 'Betrag',
    addTaxRate: 'Steuersatz hinzufügen',
    noTaxRatesFound: 'Keine Steuersätze gefunden',
    createTaxRate: 'Steuersatz erstellen',
    taxCode: 'Steuercode',
    percentage: 'Prozentsatz',
    addUser: 'Benutzer hinzufügen',
    noUsersFound: 'Keine Benutzer gefunden',
    createUser: 'Benutzer erstellen',
    firstName: 'Vorname',
    lastName: 'Nachname',
    addRole: 'Rolle hinzufügen',
    noRolesFound: 'Keine Rollen gefunden',
    createRole: 'Rolle erstellen',
    permissions: 'Berechtigungen',
    shareable: 'Teilbar',
    autoAssign: 'Auto-Zuweisen',
    digitalSignage: 'Raum Beschilderung',
    status: 'Status',
    actions: 'Aktionen',
    yes: 'Ja',
    pleaseEnterSpaceName: 'Bitte geben Sie einen Raumnamen ein',
    pleaseSelectRoomType: 'Bitte wählen Sie einen Raumtyp aus',
    fnb: 'F&B',
    contacts: 'Kontakte',
    // Parties
    parties: {
      title: 'Parteien',
      customers: 'Kunden',
      companies: 'Unternehmen',
      filterAll: 'Alle',
      searchPlaceholder: 'Nach Name, E-Mail, ID suchen...',
      searchMewsPlaceholder: 'MEWS durchsuchen (mind. 3 Zeichen)...',
      search: 'Suchen',
      searching: 'Suche läuft...',
      loadingRecent: 'Lade aktuelle Einträge...',
      name: 'Name',
      email: 'E-Mail',
      source: 'Quelle',
      mewsId: 'MEWS-ID',
      bcId: 'BC-ID',
      noResults: 'Keine Treffer gefunden',
      tryDifferentFilter: 'Versuchen Sie einen anderen Suchbegriff oder Filter.',
      noPartiesYet: 'Noch keine Parteien',
      noPartiesDesc: 'Parteien werden erstellt, wenn Sie Kunden oder Unternehmen mit Events verknüpfen.',
      mewsNoData: 'Keine MEWS-Daten geladen',
      mewsNoDataDesc: 'Klicken Sie auf MEWS, um aktuelle Kunden oder Unternehmen zu laden.',
      mewsResults: 'Ergebnisse aus MEWS',
      sortedByRecent: 'sortiert nach letzter Änderung',
      syncFromMews: 'Von MEWS aktualisieren',
      syncSuccess: 'Partei von MEWS aktualisiert',
      syncFailed: 'MEWS-Sync fehlgeschlagen',
      createSuccess: 'Partei aus MEWS erstellt und verknüpft',
      createFailed: 'Partei aus MEWS konnte nicht erstellt oder verknüpft werden',
      bcComingSoon: 'BC-Integration kommt bald',
      bcComingSoonDesc: 'Business Central Parteiübersicht wird in einem zukünftigen Update verfügbar sein.',
      detailCustomerSubtitle: 'MEWS-Kunde',
      detailCompanySubtitle: 'MEWS-Unternehmen',
      detailFirstName: 'Vorname',
      detailLastName: 'Nachname',
      detailPhone: 'Telefon',
      detailNationality: 'Nationalität',
      detailLoyalty: 'Treuecode',
      detailBirthDate: 'Geburtsdatum',
      detailTitle: 'Anrede',
      detailCreated: 'Erstellt',
      detailUpdated: 'Zuletzt aktualisiert',
      detailCompanyName: 'Firmenname',
      detailContactPerson: 'Ansprechpartner',
      detailContact: 'Kontakt',
      detailExternalId: 'Externe ID',
      detailNumber: 'Nummer',
      detailTaxId: 'Steuer-ID',
      detailInvoicingEmail: 'Rechnungs-E-Mail',
      detailBillingSection: 'Rechnungsstellung & Abrechnung',
      detailInvoiceable: 'Rechnungsfähig',
      detailCreditRating: 'Kreditbewertung',
      detailActive: 'Status',
      detailBillingCode: 'Abrechnungscode',
      detailInvoiceDue: 'Zahlungsziel',
      detailClassifications: 'Klassifizierungen',
      yes: 'Ja',
      no: 'Nein',
    },
    // Series
    series: {
      countLabel: 'Serien',
      searchPlaceholder: 'Serien suchen...',
      newSeries: 'Neue Serie',
      noSeriesFound: 'Keine Serien gefunden',
      noSeriesYet: 'Noch keine Event-Serien',
      noSeriesDesc: 'Erstellen Sie Serien, um zusammengehörige Events zu gruppieren',
      createFirst: 'Erste Serie erstellen',
      editSeries: 'Serie bearbeiten',
      newSeriesTitle: 'Neue Event-Serie',
      type: 'Typ',
      organizer: 'Organisator',
      department: 'Abteilung',
      startDate: 'Startdatum',
      endDate: 'Enddatum',
      period: 'Zeitraum',
      selectType: 'Typ auswählen...',
      bachelor: 'Bachelor',
      seminar: 'Seminar',
      conference: 'Konferenz',
      workshop: 'Workshop',
      training: 'Training',
      certification: 'Zertifizierung',
      completed: 'Abgeschlossen',
      cancelled: 'Storniert',
      organizerPlaceholder: 'Name des Organisators',
      departmentPlaceholder: 'Abteilung',
      descriptionPlaceholder: 'Beschreibung der Serie...',
      namePlaceholder: 'z.B. Führungsprogramm 2026',
    },
    // Spaces modal
    spaceModal: {
      basicInfo: 'Grunddaten',
      roomDetails: 'Raumdetails',
      roomType: 'Raumtyp',
      seating: 'Bestuhlung',
      roomTypePlaceholder: 'Seminarraum, Veranstaltungsraum, etc.',
      style: 'Stil',
      stylePlaceholder: 'z.B. im Schloss/Barock',
      floorWindows: 'Bodenfenster',
      floorWindowsPlaceholder: 'Ja/Nein/Teilweise/Eine Seite',
      dimensions: 'Abmessungen',
      width: 'Breite (m)',
      length: 'Länge (m)',
      height: 'Höhe (m)',
      areaSqm: 'Fläche (m²)',
      setupCapacities: 'Bestuhlung',
      maxCapacity: 'Max. Kapazität',
      roundTable: 'Rundtisch',
      amenities: 'Ausstattung & Merkmale',
      pricing: 'Preise',
      pricingMiceNote: 'Diese Preise gelten ausschließlich für MICE Events (Meetings, Incentives, Conferences, Exhibitions). Die Abrechnung erfolgt pro Tag.',
      perDay: 'pro Tag',
      priceNet: 'Preis (Netto)',
      priceGross: 'Preis (Brutto)',
      taxPercent: 'MwSt. (%)',
      netPrice: 'Nettopreis',
      grossPrice: 'Bruttopreis',
      taxPercentage: 'Steuersatz',
      additionalInfo: 'Zusätzliche Infos',
      notes: 'Notizen',
      notesPlaceholder: 'Weitere Informationen oder Hinweise',
      statusSection: 'Status',
      combinedSpaces: 'Kombinierte Räume',
      addCombinedSpace: 'Kombinierten Raum hinzufügen',
      searchFeatures: 'Merkmale suchen...',
      coffeePoint: 'Kaffeepause vor dem Raum',
      digitalSignage: 'Raum Beschilderung',
      terraceAccess: 'Terrassenzugang',
      stagePossible: 'Bühne möglich',
      hybridSetup: 'Hybrid-Setup möglich',
      shareable: 'Teilbar',
      autoAssign: 'Auto-Zuweisen',
      noCombinedSpaces: 'Keine kombinierten Räume ausgewählt',
      selectCombinedSpace: 'Wählen Sie einen Raum zum Kombinieren:',
      noSpacesAvailable: 'Keine weiteren aktiven Räume verfügbar',
    },
    // Equipment
    equipmentModal: {
      newEquipment: 'Neues Equipment',
      editEquipment: 'Equipment bearbeiten',
      selectCategory: 'Kategorie wählen',
      stockQuantity: 'Lagermenge',
      addCategory: 'Kategorie hinzufügen',
      categories: 'Equipment Kategorien',
      noCategoriesFound: 'Keine Equipment-Kategorien gefunden',
    },
    // F&B / Menus
    menuModal: {
      newMenuItem: 'Neuer Menüpunkt',
      editMenuItem: 'Menüpunkt bearbeiten',
      selectCategory: 'Kategorie wählen',
      addCategory: 'Kategorie hinzufügen',
      addDietaryRestriction: 'Diäthinweis hinzufügen',
      dietaryCode: 'Code *',
      dietaryCodePlaceholder: 'z.B. VEG, GF, NUT_FREE',
      dietaryDescription: 'Beschreibung *',
      dietaryDescriptionPlaceholder: 'z.B. Vegetarisch, Glutenfrei',
      searchMenuItems: 'Menü-Einträge suchen...',
      categories: 'Menü Kategorien',
      noCategoriesFound: 'Keine Menü-Kategorien gefunden',
      dietaryRestrictions: 'Unverträglichkeiten',
      noDietaryFound: 'Keine Unverträglichkeiten gefunden',
    },
    // Rates
    rateModal: {
      newRate: 'Neue Rate',
      editRate: 'Rate bearbeiten',
      selectCategory: 'Kategorie wählen',
      baseAmount: 'Grundbetrag *',
      unit: 'Einheit',
      perDay: 'Pro Tag',
      perHour: 'Pro Stunde',
      perPerson: 'Pro Person',
      perItem: 'Pro Stück',
      flatRate: 'Pauschal',
      addCategory: 'Kategorie hinzufügen',
      searchRates: 'Raten suchen...',
      categories: 'Raten-Kategorien',
      noCategoriesFound: 'Keine Raten-Kategorien gefunden',
    },
    rateCheck: {
      title: 'MEWS Raten-Check',
      subtitle: 'Verfügbarkeit, Einschränkungen, Preis und Storno für einen konkreten Aufenthalt prüfen',
      live: 'Live aus MEWS',
      guestKind: 'Gasttyp',
      hotel: 'Hotelgast',
      dayguest: 'Tagesgast',
      lecturer: 'Referent',
      arrival: 'Anreise',
      departure: 'Abreise',
      sameDayEnd: 'Ende (gleicher Tag)',
      roomType: 'Zimmerkategorie',
      chooseRoomType: 'Zimmerkategorie wählen',
      noMappedRoomTypes: 'Für diese Property ist keine aktive, mit MEWS verknüpfte Zimmerkategorie vorhanden.',
      stream: 'Stream',
      allStreams: 'Alle Streams',
      check: 'Raten prüfen',
      checking: 'Prüfe…',
      failed: 'Raten-Check fehlgeschlagen',
      propertyRequired: 'Bitte zuerst eine Property auswählen.',
      datesRequired: 'Bitte gültige An- und Abreisedaten wählen.',
      checkoutAfterArrival: 'Die Abreise muss nach der Anreise liegen.',
      roomRequired: 'Für Hotelgäste und Referenten ist eine Zimmerkategorie erforderlich.',
      of: 'von',
      ratesAvailable: 'Raten sind für diese Auswahl buchbar',
      checkedAt: 'Geprüft:',
      cached: 'Kurzzeit-Cache',
      noRates: 'Für diese Property und Auswahl wurden keine lokalen Raten gefunden.',
      stornoUnavailableTitle: 'Storno-Regeln konnten nicht geprüft werden',
      stornoUnavailable: 'MEWS hat den Zugriff auf die Storno-Richtlinien nicht geliefert. Das bedeutet nicht, dass eine kostenfreie Stornierung möglich ist.',
      price: 'Preis',
      totalUnavailable: 'Gesamtpreis nicht verfügbar',
      nightlyPrices: 'Preise pro Nacht',
      pricingUnavailable: 'MEWS-Preis für diese Auswahl nicht verfügbar.',
      restrictions: 'Einschränkungen',
      noRestrictions: 'Keine passenden MEWS-Einschränkungen für diesen Zeitraum.',
      blocks: 'Blockiert',
      exceptionSatisfied: 'Ausnahme erfüllt',
      arrivalRestriction: 'Anreise-Einschränkung',
      departureRestriction: 'Abreise-Einschränkung',
      stayRestriction: 'Aufenthalts-Einschränkung',
      wholePeriod: 'Gilt im geprüften Zeitraum',
      minAdvance: 'Mindestvorlauf',
      maxAdvance: 'Maximaler Vorlauf',
      minStay: 'Mindestaufenthalt',
      maxStay: 'Maximalaufenthalt',
      minPrice: 'Mindestpreis',
      maxPrice: 'Höchstpreis',
      storno: 'Storno',
      notVerified: 'Nicht verifiziert — bitte direkt in MEWS prüfen.',
      noStornoPolicies: 'MEWS hat für diesen Aufenthalt keine wirksame Storno-Richtlinie zurückgegeben.',
      maximum: 'Maximal',
      timeUnits: 'Zeiteinheit(en)',
      fee: 'Gebühr',
      feeAccordingToMews: 'Gebühr gemäß MEWS',
      fromBooking: 'ab Buchung',
      beforeArrival: 'vor Anreise',
      afterArrival: 'nach Anreise',
      atArrival: 'bei Anreise',
      fromArrival: 'ab Anreise',
      from: 'ab',
      day: 'Tag',
      days: 'Tage',
      hour: 'Stunde',
      hours: 'Stunden',
      applicability: {
        available: 'Buchbar',
        unmapped: 'Nicht mit MEWS verknüpft',
        wrongService: 'Falscher MEWS-Service',
        missingInMews: 'In MEWS nicht gefunden',
        inactiveInMews: 'In MEWS inaktiv',
        disabledInMews: 'In MEWS deaktiviert',
        blockOnly: 'Nur für Verfügbarkeitsblöcke',
        restrictedForDates: 'Für diese Daten eingeschränkt',
      },
      weekdays: {
        monday: 'Mo',
        tuesday: 'Di',
        wednesday: 'Mi',
        thursday: 'Do',
        friday: 'Fr',
        saturday: 'Sa',
        sunday: 'So',
      },
    },
    // Taxes
    taxModal: {
      newTaxRate: 'Neuer Steuersatz',
      editTaxRate: 'Steuersatz bearbeiten',
      taxCode: 'Steuercode *',
      percentage: 'Prozentsatz *',
      percentagePlaceholder: 'z.B. 8,5',
      searchTaxRates: 'Steuersätze suchen...',
    },
    // Contacts
    contactModal: {
      newContact: 'Neuer Kontakt',
      editContact: 'Kontakt bearbeiten',
      firstName: 'Vorname *',
      lastName: 'Nachname *',
      jobTitle: 'Position',
      searchContacts: 'Kontakte suchen...',
    },
    // Users
    userModal: {
      newUser: 'Neuer Benutzer',
      editUser: 'Benutzer bearbeiten',
      fullName: 'Vollständiger Name *',
      searchUsers: 'Benutzer suchen...',
    },
    // Packages
    packages: {
      title: 'Pakete',
      searchPackages: 'Pakete suchen...',
      searchPlaceholder: 'Pakete suchen...',
      newPackage: 'Neues Paket',
      noPackagesFound: 'Keine Pakete gefunden',
      noPackagesYet: 'Noch keine Pakete',
      noPackagesDesc: 'Erstellen Sie Pakete aus MEWS-Produkten mit eigenen Preisen',
      createFirst: 'Erstes Paket erstellen',
      editPackage: 'Paket bearbeiten',
      newPackageTitle: 'Neues Paket',
      countLabel: 'Pakete',
      allGroups: 'Alle Gruppen',
      packageName: 'Paketname...',
      optionalDesc: 'Optionale Beschreibung...',
      products: 'Produkte',
      loadingPrices: 'Preise laden...',
      price: 'Preis',
      quantity: 'Menge',
      savePackage: 'Paket speichern',
      saving: 'Speichern...',
      total: 'Gesamt',
      selectProducts: 'Produkte auswählen',
      productsLoading: 'Produkte werden geladen...',
      noProductsLoaded: 'Noch keine Produkte geladen',
      loadProducts: 'Produkte laden',
      searchProducts: 'Produkt suchen...',
      productsSelected: '{count} Produkt(e) ausgewählt',
      addProducts: '{count} Produkt(e) hinzufügen',
      alreadyAdded: 'hinzugefügt',
      noProductsMatch: 'Keine Produkte gefunden',
      noProductsYetDesc: 'Noch keine Produkte — wählen Sie unten MEWS-Produkte aus',
      addProduct: 'Produkt hinzufügen',
      charging: 'Abrechnung',
      service: 'Service',
      nameRequired: 'Bitte Paketname eingeben',
      updateError: 'Paket konnte nicht aktualisiert werden',
      createError: 'Paket konnte nicht erstellt werden',
      itemsSaveError: 'Paket-Produkte konnten nicht gespeichert werden',
      confirmDelete: 'Paket "{name}" löschen? Alle zugehörigen Produkte werden entfernt.',
      deleteError: 'Paket konnte nicht gelöscht werden',
      product: 'Produkt',
      qty: 'Anz.',
      selectPackage: 'Paket auswählen um Produkte zu sehen',
      stream: 'Streams',
      allStreams: 'Alle Streams',
      noStream: 'Kein Stream',
      allStreamsHint: 'Keine Auswahl = alle Streams',
      createdBy: 'Erstellt von',
      updatedBy: 'Geändert von',
      createdAt: 'Erstellt',
      updatedAt: 'Geändert',
      allServices: 'Alle Services',
      allCategories: 'Alle Kategorien',
      allCharging: 'Alle Abrechnungen',
      category: 'Kategorie',
      noCategory: 'Ohne Kategorie',
      selectCategory: 'Kategorie wählen',
    },
    // Common form
    noFeaturesMatch: 'Keine Merkmale entsprechen Ihrer Suche',
    noFeaturesFound: 'Keine Merkmale gefunden',
    confirmDelete: 'Löschen bestätigen',
    confirmDeleteMsg: 'Möchten Sie dieses Element wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    featureModal: {
      newFeature: 'Neues Merkmal',
      editFeature: 'Merkmal bearbeiten',
    },
  },
  administration: {
    title: 'Verwaltung',
    users: 'Benutzer',
    roles: 'Rollen',
    permissions: 'Berechtigungen',
    settings: 'Einstellungen',
    logs: 'Protokolle',
    backup: 'Sicherung',
    restore: 'Wiederherstellen',
    systemHealth: 'Systemzustand',
    newUser: 'Neuer Benutzer',
    editUser: 'Benutzer bearbeiten',
    firstName: 'Vorname',
    lastName: 'Nachname',
    role: 'Rolle',
    lastLogin: 'Letzte Anmeldung',
  },
  equipment: {
    title: 'Ausrüstungsverwaltung',
    equipment: 'Ausrüstung',
    categories: 'Kategorien',
    newEquipment: 'Neue Ausrüstung',
    newCategory: 'Neue Kategorie',
    editEquipment: 'Ausrüstung bearbeiten',
    editCategory: 'Kategorie bearbeiten',
    deleteEquipment: 'Ausrüstung löschen',
    deleteCategory: 'Kategorie löschen',
    allProperties: 'Alle Objekte',
    allCategories: 'Alle Kategorien',
    allStatus: 'Alle Status',
    searchEquipment: 'Ausrüstung suchen...',
    noEquipmentFound: 'Keine Ausrüstung gefunden',
    addEquipment: 'Ausrüstung hinzufügen',
    stockQuantity: 'Lagermenge',
    equipmentCount: 'Ausrüstungsanzahl',
    code: 'Code',
    category: 'Kategorie',
    property: 'Objekt',
    deleteConfirm: 'Möchten Sie wirklich löschen',
    deleteWarning: 'Diese Aktion kann nicht rückgängig gemacht werden.',
    saving: 'Speichern...',
    deleting: 'Löschen...',
  },
  spaceBooking: {
    requested: 'Raum angefragt',
    requestedTooltip: 'Raum angefragt — das Hotel wählt noch einen Raum',
    requestSpace: 'Raum anfragen',
    requestHint: 'Ohne Raum anfragen — das Hotel wählt einen Raum und bestätigt',
    requestCreated: 'Raum angefragt',
    requestFailed: 'Anfrage fehlgeschlagen',
    assignSpace: 'Raum zuweisen',
    assignFailed: 'Raum konnte nicht zugewiesen werden',
    noSpaceYet: 'Kein Raum (angefragt)',
    confirmFailed: 'Buchung konnte nicht bestätigt werden.',
    confirmPartial: 'Nur {done} von {total} Tagen bestätigt — die übrigen bleiben offen.',
    confirmBooking: 'Buchung bestätigen',
    confirmConflict: 'Dieser Raum ist zu dieser Zeit bereits bestätigt gebucht. Eine zweite überschneidende Bestätigung ist nicht möglich – bitte zuerst die andere Buchung stornieren oder verschieben.',
    overbookingTitle: 'Raumkonflikt',
    overbookingMessage: 'Dieser Raum ist bereits im gewählten Zeitraum gebucht:',
    overbookingHint: 'Sie können trotzdem fortfahren, dies erzeugt eine Doppelbuchung.',
    overbookingConfirm: 'Trotzdem buchen',
    unavailableTitle: 'Raum nicht verfügbar',
    unavailableMessage: 'Der ausgewählte Raum kann für den gewünschten Zeitraum nicht gebucht werden. Er ist möglicherweise durch eine andere Veranstaltung belegt oder durch einen kombinierten Raumkonflikt blockiert.',
  },
  themes: {
    title: 'Themes',
    subtitle: 'Alle EventHub-Elemente in verschiedenen Themes ansehen',
  },
  rolesPermissions: {
    selectAll: 'Alle',
    toggleWholeSection: 'Alle Berechtigungen dieses Bereichs setzen oder entfernen',
    specialPermissions: 'Spezialrechte',
    specialPermissionsHint: 'Fähigkeiten und Freigaben, die keine Seiten sind – Event-Streams, Function-Sheet-Workflow, Maya, Rohtabellen und API-Zugriff.',
    toggleWholeColumn: '"{column}" f\u00fcr alle Zeilen dieses Bereichs setzen',
    title: 'Verwaltung',
    subtitle: 'Benutzer, Rollen und Zugriff verwalten',
    adminOnly: 'Zugriff verweigert',
    adminOnlyMsg: 'Diese Seite ist nur für Administratoren zugänglich.',
    noPermission: 'Sie haben keine Berechtigung, Benutzer zu verwalten.',
    noSupertokensSession: 'Keine aktive SuperTokens-Sitzung. Mit E-Mail/Passwort anmelden, um Benutzer zu verwalten.',
    usersTab: 'Benutzer',
    rolesTab: 'Rollen & Rechte',
    usersCount: 'Benutzer',
    addUser: 'Benutzer anlegen',
    loadingUsers: 'Benutzer laden...',
    loadingRoles: 'Rollen und Rechte laden...',
    noUsers: 'Keine Benutzer gefunden.',
    provider: 'Anmeldeart',
    deleteUser: 'Benutzer löschen',
    deleteUserPrompt: 'Sicher?',
    deleteUserConfirm: 'Ja, löschen',
    noAccess: 'Noch kein Zugriff',
    noAccessHint: 'Dieser Benutzer hat noch keine Rolle und kann nicht auf EventHub zugreifen. Klicken Sie auf Bearbeiten, um eine Rolle zuzuweisen.',
    searchUsers: 'Benutzer suchen…',
    clearSearch: 'Suche zurücksetzen',
    noSearchMatches: 'Keine Benutzer entsprechen Ihrer Suche.',
    primaryRoleHint: 'Muss eine von: adg-user, adg-admin, adg-superadmin sein (steuert den Datenbankzugriff).',
    outrankedHint: 'Dieser Benutzer hat eine höhere Rolle als Sie. Nur ein adg-superadmin kann ihn bearbeiten.',
    escalationBlocked: 'Sie können keine Rolle vergeben, die höher als Ihre eigene ist.',
    entraRoleHint: 'Rollen für Entra-ID-Benutzer werden in Azure verwaltet (App-Rollen) und können hier nicht bearbeitet werden.',
    email: 'E-Mail',
    name: 'Name',
    fullName: 'Vollständiger Name',
    fullNamePlaceholder: 'z.B. Max Mustermann',
    rolesLabel: 'Rollen',
    joined: 'Beigetreten',
    password: 'Passwort',
    primaryRole: 'Hauptrolle',
    defaultRole: 'Standard (keine Rolle)',
    roleHint: 'Vordefinierte Rolle für den neuen Benutzer zuweisen',
    changeRole: 'Ändern',
    additionalRoles: 'Weitere Rollen',
    selectAdditionalRole: 'Rolle auswählen...',
    additionalRolesHint: 'Zusätzliche Rollen für den Benutzer (optional)',
    editUserRoles: 'Benutzerrollen bearbeiten',
    saveChanges: 'Änderungen speichern',
    createUser: 'Benutzer erstellen',
    creating: 'Erstellen...',
    addRole: 'Rolle anlegen',
    adding: 'Hinzufügen...',
    roleName: 'Rollenname',
    roleNameHint: 'Muss dem Rollennamen im JWT-Token entsprechen',
    description: 'Beschreibung',
    descriptionPlaceholder: 'Wofür diese Rolle ist...',
    selectRole: 'Rolle wählen',
    selectRoleMsg: 'Wähle oben eine Rolle, um deren Seitenrechte zu konfigurieren',
    noDescription: 'Keine Beschreibung',
    savePermissions: 'Rechte speichern',
    saving: 'Speichern...',
    deleteRole: 'Rolle löschen',
    deleteRoleMsg: 'Soll {name} wirklich gelöscht werden? Alle zugehörigen Rechte werden entfernt.',
    deleting: 'Löschen...',
    delete: 'Löschen',
    cancel: 'Abbrechen',
    grantAll: 'Alle gewähren',
    readOnlyAll: 'Nur Lesen',
    revokeAll: 'Alle entziehen',
    page: 'Seite',
    read: 'Lesen',
    create: 'Erstellen',
    edit: 'Bearbeiten',
  },
  errors: {
    loadFailed: 'Laden fehlgeschlagen. Bitte versuchen Sie es erneut.',
    saveFailed: 'Speichern fehlgeschlagen. Bitte versuchen Sie es erneut.',
    deleteFailed: 'Löschen fehlgeschlagen. Bitte versuchen Sie es erneut.',
    retry: 'Wiederholen',
  },
  apiDocs: {
    subtitle: 'Integrations-Dokumentation',
    gettingStarted: 'Erste Schritte',
    authentication: 'Authentifizierung',
    authDescription: 'Alle API-Anfragen erfordern einen API-Key im x-api-key Header.',
    baseUrl: 'Basis-URL',
    endpoints: 'Endpunkte',
    keyBehavior: 'Verhalten',
    requiredFields: 'Pflichtfelder',
    optionalFields: 'Optionale Felder',
    field: 'Feld',
    type: 'Typ',
    note: 'Hinweis',
    examples: 'Beispiele',
    createMinimal: 'Erstellen (Minimal)',
    createFull: 'Erstellen (Alle Felder)',
    update: 'Aktualisieren',
    response: 'Antwort',
    copy: 'Kopieren',
    bsUpsertDescription: 'BS-Stream Event erstellen oder aktualisieren. Matching über external_id.',
    bsAutoSet: 'wird automatisch auf "bs" gesetzt — nicht mitsenden',
    bsUpsertLogic: 'Upsert: gleiche external_id → bestehendes Event wird aktualisiert',
    bsPmsBlock: 'PMS-Block wird automatisch erstellt wenn overnight_guests > 0',
    bsSpaceBooking: 'Raumbuchung wird automatisch basierend auf max_participants + Datum erstellt',
    bsResponse: 'Antwort: action: "created" (201) oder action: "updated" (200)',
  },
  reports: {
    title: 'Meldungen & Feedback',
    subtitle: 'Verwalte Fehler, Anfragen und Wünsche in einem gemeinsamen Ticketsystem.',
    allTickets: 'Alle Tickets',
    bugsCount: '{n} Fehler',
    myTickets: 'Meine Tickets',
    openTickets: 'Offene Tickets',
    retestTickets: 'Re-Test',
    retestPrompt: 'Wurde dein Ticket gelöst?',
    retestFailed: 'Nicht gelöst',
    retestSolved: 'Gelöst',
    closeTicket: 'Ticket schließen',
    retestReasonLabel: 'Was funktioniert weiterhin nicht?',
    retestReasonPlaceholder: 'z. B. weiterhin fehlerhaft — Schritt 3 wirft beim Speichern einen 500er',
    retestReasonSubmit: 'Ticket wieder öffnen',
    retestQuestion: 'Ist das Problem noch da?',
    retestQuestionYes: 'Ja – Ticket wieder öffnen',
    retestQuestionNo: 'Nein – nur kommentieren',
    commentSendFailed: 'Kommentar konnte nicht gesendet werden. Bitte erneut versuchen.',
    unknownAuthor: 'Unbekannt',
    notesDamage: {
      chip: 'beschädigt',
      title: 'Kommentarverlauf beschädigt',
      kindUnparseable: 'Der gespeicherte Verlauf ist kein gültiges JSON – zum Beispiel zwei aneinandergehängte Listen.',
      kindNotAList: 'Der gespeicherte Verlauf ist keine Liste von Kommentaren.',
      kindWrapped: 'Ein Eintrag enthält einen ganzen gespeicherten Verlauf als Text. Er wird im Verlauf für alle ausgeblendet, weil darin interne Kommentare stehen können.',
      kindDroppedEntries: 'Einige gespeicherte Einträge sind unvollständig und werden im Verlauf nicht angezeigt.',
      appendRefused: 'Neue Kommentare und Verlaufseinträge werden abgelehnt, bis der Verlauf in der Datenbank repariert ist.',
      recovered: 'Wiederhergestellt – nur Ansicht, nichts wird gespeichert ({count})',
      nothingRecovered: 'Es konnte kein Kommentar wiederhergestellt werden.',
      raw: 'Gespeicherter Rohtext',
      hiddenEntry: 'Dieser Eintrag ist beschädigt und wird nicht angezeigt.',
      writeRefused: 'Dieser Kommentarverlauf ist beschädigt und kann gerade nicht ergänzt werden. Bitte wende dich an das EventHub-Team.',
      retestReasonRefused: 'Das Ticket wurde wieder geöffnet, aber die Begründung konnte nicht gespeichert werden: Der Kommentarverlauf ist beschädigt. Bitte wende dich an das EventHub-Team.',
    },
    retestFailedConfirmed: 'Ticket wieder geöffnet — dein Feedback liegt beim Team.',
    closeTicketConfirmed: 'Ticket geschlossen. Danke fürs Testen!',
    retestUpdateFailed: 'Ticket konnte nicht aktualisiert werden. Bitte erneut versuchen.',
    wontFixReasonRequired: 'Bitte vor dem Speichern einen Kommentar mit der Begründung für die Ablehnung hinzufügen.',
    wontFixReasonMustBePublic: 'Die Begründung für die Ablehnung muss für den Melder sichtbar sein. Bitte „Nur Admins“ abwählen.',
    closedTickets: 'Geschlossen',
    resolvedTickets: 'Gelöste Tickets',
    createTicket: 'Ticket erstellen',
    refreshList: 'Liste aktualisieren',
    groupByStatus: 'Nach Status',
    groupByTag: 'Nach Tag',
    tags: 'Tags',
    tagInputPlaceholder: 'Tag eingeben und Enter…',
    allTags: 'Alle Tags',
    untagged: 'Ohne Tag',
    searchPlaceholder: 'Nach Ticket-Nr., Titel, Beschreibung, E-Mail oder Notiz suchen',
    statusGroupDone: 'Gelöst + Geschlossen',
    ageJustNow: 'gerade eben',
    ageMinutes: 'vor {n} Min.',
    ageHours: 'vor {n} Std.',
    ageDays: 'vor {n} T.',
    collapseColumn: 'Spalte einklappen',
    navPrev: 'Vorheriges Ticket',
    navNext: 'Nächstes Ticket',
    navBlocked: 'Ungespeicherte Änderungen — zuerst speichern oder verwerfen.',
    moreFilters: 'Weitere Filter',
    resetFilters: 'Filter zurücksetzen',
    filters: 'Filter',
    reporter: 'Ersteller',
    created: 'Erstellt',
    updated: 'Aktualisiert',
    emptyTitle: 'Keine Tickets passen zu den aktuellen Filtern',
    emptyText: 'Versuche andere Filter oder erstelle ein neues Ticket.',
    detailTitle: 'Ticketdetails',
    detailHint: 'Wähle ein Ticket aus, um die ganze Konversation und Metadaten zu sehen.',
    internalNotes: 'Interne Notizen',
    noInternalNotes: 'Noch keine Notizen',
    addInternalNote: 'Notiz oder Kommentar hinzufügen...',
    adminOnlyNoteToggle: 'Nur Admins',
    adminOnlyNoteBadge: 'Nur Admins',
    adminOnlyNoteHint: 'Diesen Kommentar können nur Reports-Admins lesen. Er wird nicht nach Azure DevOps übertragen.',
    postComment: 'Kommentar posten',
    posting: 'Poste…',
    saveChanges: 'Änderungen speichern',
    createPrompt: 'Beschreibe das Problem, die Anfrage oder Idee so klar wie möglich.',
    createdBy: 'Erstellt von',
    assignStatus: 'Status',
    assignPriority: 'Priorität',
    reportMeta: 'Metadaten',
    ticket: 'Ticket',
    system: 'System',
    allSystems: 'Alle Systeme',
    systemHint: 'Ursprungssystem (Standard: eventhub)',
    systemOther: 'Andere…',
    systemPlaceholder: 'System-Slug',
    assignedTo: 'Zugewiesen an',
    unassigned: 'Nicht zugewiesen',
    assigneeGroupFrequent: 'Häufig verwendet',
    assigneeGroupAll: 'Alle Benutzer',
    onlyMine: 'Nur meine',
    onlyOpen: 'Nur offen',
    total: 'Gesamt',
    unreadUpdates: 'Ungelesene Updates',
    unresolved: 'Ungelöst',
    mine: 'Meine',
    adminTools: 'Verwaltung',
    noSelection: 'Kein Ticket ausgewählt',
    saveSuccess: 'Ticket erfolgreich aktualisiert.',
    listView: 'Listenansicht',
    kanbanView: 'Kanban',
    insights: {
      typeTrendTitle: 'Welche Art von Meldungen',
      typeTrendHint: 'Neu erstellte Meldungen je Woche, aufgeschlüsselt nach Typ. Die Summe einer Säule entspricht der Linie „Erstellt“ darüber.',
      typeTrendEmpty: 'In diesem Zeitraum wurden keine Meldungen erstellt.',
      tab: 'Admin-Insights',
      title: 'Admin-Insights',
      subtitle: 'Arbeitslast, Geschwindigkeit und Tickets mit Handlungsbedarf auf einen Blick.',
      basedOnTickets: 'Basierend auf allen {count} Tickets',
      activeQueue: 'Aktive Tickets',
      open: 'Offen',
      inProgress: 'In Bearbeitung',
      blocked: 'Blockiert',
      done: 'Erledigt',
      declined: 'Abgelehnt',
      active: 'Aktiv',
      unassigned: 'Nicht zugewiesen',
      critical: 'Kritisch',
      stale: 'Inaktiv',
      old: 'Seit 14+ T. offen',
      queueHealthy: 'Keine blockierten, kritischen oder nicht zugewiesenen Tickets',
      averageActiveAge: 'Ø Alter aktiver Tickets',
      averageActiveAgeHint: 'Zeit seit Erstellung für weiterhin aktive Tickets',
      doneLast30: 'Erledigt in 30 Tagen',
      createdLast30: '{count} im selben Zeitraum erstellt',
      averageResolutionTime: 'Ø Zeit bis Erledigung',
      averageResolutionHint: 'Von Erstellung bis Gelöst oder Geschlossen',
      oldestActive: 'Ältestes aktives Ticket',
      noActiveTickets: 'Keine aktiven Tickets',
      needsAttention: 'Handlungsbedarf',
      needsAttentionHint: 'Priorisiert nach Kritikalität, Zuständigkeit, Inaktivität und Alter.',
      attentionSummary: '{count} Tickets benötigen Aufmerksamkeit',
      noAttentionSummary: 'Keine blockierten, kritischen, nicht zugewiesenen, inaktiven oder überalterten Tickets.',
      blockedCount: '{count} blockiert',
      criticalCount: '{count} kritisch',
      unassignedCount: '{count} nicht zugewiesen',
      staleCount: '{count} seit 7+ T. inaktiv',
      oldCount: '{count} seit 14+ T. offen',
      startWith: 'Hier beginnen',
      allSignals: 'Alle',
      noAttention: 'Keine Tickets entsprechen diesem Signal.',
      openFor: 'Seit {duration} offen',
      inactiveFor: 'Seit {duration} ohne Aktivität',
      actionAssign: 'Verantwortung zuweisen',
      actionStartCritical: 'Kritisches Ticket starten',
      actionCheckCritical: 'Fortschritt prüfen',
      actionRequestUpdate: 'Update anfordern',
      actionReviewOld: 'Altes Ticket prüfen',
      actionUnblock: 'Blockierung lösen',
      statusOverview: 'Statusübersicht',
      flowTrendTitle: 'Ticket-Verlauf',
      flowTrendHint: 'Offener Bestand, Neuzugänge und erledigte Tickets pro Woche — exakt aus Erstell- und Erledigungsdatum.',
      flowOpen: 'Offener Bestand',
      flowCreated: 'Neu erstellt',
      flowResolved: 'Erledigt',
      flowRange8: '8 Wo.',
      flowRange12: '12 Wo.',
      flowRange26: '26 Wo.',
      ageProfile: 'Alter aktiver Tickets',
      ageProfileHint: 'Wie lange die aktuelle Arbeit bereits offen ist.',
      ageBuckets: {
        under1: '< 1 T.',
        oneTo3: '1–3 T.',
        fourTo7: '4–7 T.',
        eightTo14: '8–14 T.',
        fifteenTo30: '15–30 T.',
        over30: '30+ T.',
      },
      teamWorkload: 'Leistung & Arbeitslast nach Zuständigkeit',
      teamWorkloadHint: 'Aktuelle Zuständigkeit, jüngste Ergebnisse und Geschwindigkeit auf einen Blick.',
      highestWorkload: 'Höchste Arbeitslast',
      mostDone30: 'Meiste erledigt · 30 Tage',
      fastestCompletion: 'Schnellste Erledigung · 30 Tage',
      needsSupport: 'Zuständige mit Handlungsbedarf',
      activeCount: '{count} aktive Tickets',
      doneCount: '{count} erledigt',
      ofAssignees: 'von {count} zugewiesenen Personen',
      person: 'Person',
      currentWorkload: 'Aktuelle Arbeitslast',
      doneLast30Short: 'Erledigt · 30 T.',
      vsPrevious30: 'vs. vorherige 30 T.',
      averageResolution30: 'Ø Erledigungszeit · 30 T.',
      averageAge: 'Ø aktives Alter',
      averageResolution: 'Ø bis Erledigung',
      oldest: 'Ältestes aktives',
      signals: 'Signale',
      timesAverage: '{value}× Ø',
      signalUnowned: 'Ohne Zuständigkeit',
      signalCritical: 'Kritische Arbeit',
      signalBlocked: 'Blockierte Arbeit',
      signalNeedsSupport: 'Nachfassen',
      signalClear: 'Keine offenen Tickets',
      signalHighLoad: 'Hohe Last',
      signalOnTrack: 'Im Plan',
      sortRisk: 'Höchster Handlungsbedarf',
      sortActive: 'Meiste aktive Tickets',
      sortOldest: 'Ältestes Ticket',
      sortDone: 'Meiste erledigt in 30 Tagen',
      currentAssigneeCaveat: 'Historische Ergebnisse werden der aktuell zugewiesenen Person zugerechnet, da Zuweisungswechsel nicht gespeichert werden.',
      reporterSignals: 'Signale nach Ersteller',
      reporterSignalsHint: 'Wer Meldungen erstellt und wie viel davon noch aktiv ist.',
      submitted: 'Gesendet',
      unknownReporter: 'Unbekannter Ersteller',
      minutesShort: '{count} Min.',
      hoursShort: '{count} Std.',
      daysShort: '{count} T.',
    },
    noTicketsInColumn: 'Keine Tickets in dieser Spalte',
    submitTitle: 'Meldung erstellen',
    reportDetails: 'Meldungsdetails',
    newReport: 'Neue Meldung',
    createFirst: 'Erste Meldung erstellen',
    loadingReports: 'Meldungen werden geladen...',
    noReports: 'Keine Meldungen gefunden',
    type: 'Typ',
    priority: 'Priorität',
    titleField: 'Titel',
    descriptionField: 'Beschreibung',
    attachImage: 'Bild anhängen',
    screenshotOptional: 'Screenshot (optional)',
    attachments: 'Anhaenge',
    attachmentHint: 'Bilder hierher ziehen, klicken zum Auswaehlen oder aus Zwischenablage einfuegen',
    screenshotHint: 'Klicken, ziehen & ablegen oder Strg+V zum Einfügen',
    screenshotMaxSize: 'PNG, JPG bis 5MB',
    screenshotTooLarge: 'Screenshot muss unter 5MB sein',
    submit: 'Meldung senden',
    submitting: 'Wird gesendet...',
    submitSuccess: 'Meldung erfolgreich gesendet! Vielen Dank für Ihr Feedback.',
    submitError: 'Fehler beim Senden der Meldung. Bitte versuchen Sie es erneut.',
    titlePlaceholder: 'Kurze Zusammenfassung des Problems oder Wunsches',
    descriptionPlaceholder: 'Bitte geben Sie detaillierte Informationen an...',
    comments: 'Kommentare',
    noComments: 'Noch keine Kommentare',
    addComment: 'Kommentar hinzufügen...',
    send: 'Senden',
    bug: 'Fehler',
    feature: 'Feature',
    wish: 'Wunsch',
    other: 'Sonstiges',
    bugReport: 'Fehlerbericht',
    featureRequest: 'Feature-Anfrage',
    wishIdea: 'Wunsch / Idee',
    improvement: 'Improvement',
    low: 'Niedrig',
    medium: 'Mittel',
    high: 'Hoch',
    critical: 'Kritisch',
    new: 'Neu',
    backlog: 'Backlog',
    todo: 'To-do',
    inProgress: 'In Bearbeitung',
    blocked: 'Blockiert',
    devTesting: 'Dev-Test',
    retest: 'Zu testen',
    resolved: 'Gelöst',
    closed: 'Geschlossen',
    wontFix: 'Wird nicht behoben',
    editTicket: 'Ticket bearbeiten',
    editTicketHint: 'Titel, Beschreibung, Typ und System korrigieren.',
    cancelEdit: 'Bearbeiten abbrechen',
    editedNoteSuffix: 'bearbeitet',
    editNote: 'Kommentar bearbeiten',
    deleteNote: 'Kommentar löschen',
    deleteNoteConfirm: 'Diesen Kommentar endgültig löschen?',
    deleteTicket: 'Ticket löschen',
    deleteTicketConfirm: 'Ticket {ticket} endgültig löschen? Das kann nicht rückgängig gemacht werden.',
    deleteTicketSuccess: 'Ticket gelöscht.',
    deleteAttachmentConfirm: 'Diesen Anhang endgültig löschen?',
    conflictDetected: 'Das Ticket wurde zwischenzeitlich von jemand anderem geändert. Die Ansicht wurde neu geladen — bitte Änderung erneut eintragen.',
    invalidTransition: 'Ein neues Ticket kann nicht direkt auf „Gelöst“ gesetzt werden. Bitte zuerst annehmen (Backlog / To-do / In Bearbeitung).',
    editHistoryNote: '{fields} geändert.',
    bulkSelected: '{count} ausgewählt',
    bulkClear: 'Auswahl aufheben',
    bulkStatus: 'Status setzen',
    bulkAssign: 'Zuweisen an',
    bulkType: 'Typ setzen',
    bulkPriority: 'Priorität setzen',
    bulkSystem: 'System setzen',
    bulkAddTag: 'Tag hinzufügen…',
    bulkDelete: 'Löschen',
    bulkDeleteConfirm: '{count} Tickets endgültig löschen? Das kann nicht rückgängig gemacht werden.',
    bulkApply: 'Anwenden',
    bulkApplying: 'Wird angewendet…',
    bulkFailed: '{count} von {total} konnten nicht aktualisiert werden.',
    selectAllRows: 'Alle sichtbaren auswählen',
    url: 'URL',
    browser: 'Browser',
    technicalDetails: 'Technische Details',
    showRawBrowserInfo: 'Rohe Browserinformationen anzeigen',
    screenshot: 'Screenshot',
    devops: {
      settings: {
        title: 'Azure DevOps · Verbindung',
        setup: 'DevOps-Verbindung einrichten',
        edit: 'DevOps-Verbindung bearbeiten',
        org: 'Organisation',
        project: 'Projekt',
        pat: 'Personal Access Token',
        patHint: 'Bleibt ausschließlich in deinem Browser-localStorage. Für Ticket-Erstellung „Read & Write" auswählen.',
        identityMap: 'Benutzer-Zuordnung (EventHub → DevOps)',
        identityMapHint: 'Ordnet den EventHub-Zuständigen (Name, ID oder E-Mail) einer Azure-DevOps-Identität zu. Wird beim Verknüpfen automatisch gelernt.',
        identityMapKey: 'Name / ID / E-Mail',
      },
      promote: 'Zu DevOps übertragen',
      link: 'Verknüpfen',
      viewData: 'DevOps-Daten',
      liveAssignee: 'DevOps',
      liveAssigneeHint: 'In Azure DevOps aktuell zugewiesen (wird nicht synchronisiert)',
      linkOnCreate: 'Direkt in Azure DevOps anlegen',
      linkOnCreateHint: 'Nach dem Speichern öffnet sich das DevOps-Fenster zum Verknüpfen/Anlegen.',
      searchPbi: 'PBIs suchen…',
      searchFeatures: 'Features suchen…',
      searchEpics: 'Epics suchen…',
      noPbiMatch: 'Keine passenden PBIs.',
      refresh: 'Aktualisieren',
      openInAzure: 'In Azure DevOps öffnen',
      hierarchy: 'Hierarchie',
      priority: 'Priorität',
      ownership: 'Verantwortung & Verlauf',
      assignedTo: 'Zugewiesen an',
      unassigned: 'Nicht zugewiesen',
      createdBy: 'Erstellt von',
      changedBy: 'Zuletzt geändert von',
      planning: 'Planung',
      area: 'Bereich',
      iteration: 'Iteration',
      tags: 'Tags',
      relatedItems: 'Weitere Elemente in {type} #{id}',
      relatedItemsHint: 'Andere direkte Kinder desselben übergeordneten Elements',
      noRelatedItems: 'Keine weiteren Elemente unter diesem Eltern-Element.',
      children: 'Direkt untergeordnete Elemente',
      showingOf: '{shown} von {total} Elementen werden angezeigt.',
      parent: 'Übergeordnet',
      existingPbi: 'Bestehendes PBI',
      newPbi: 'Neues PBI',
      newPbiTitle: 'PBI-Titel',
      feature: 'Feature',
      existing: 'Bestehend',
      new: 'Neu',
      noFeature: '— Ohne Feature —',
      newFeatureTitle: 'Feature-Titel',
      noEpic: '— Ohne Epic —',
      promoteHint: 'Bericht zuerst annehmen (Status auf Backlog, To-do oder In Bearbeitung setzen).',
      linked: 'verknüpft ✓ Task #{id}',
      title: 'Zu Azure DevOps übertragen',
      parentPbi: 'Übergeordnetes PBI',
      parentPbiPlaceholder: 'Product Backlog Item auswählen…',
      assignee: 'Zugewiesen an',
      searchAssignee: 'Benutzer suchen…',
      noAssigneeMatch: 'Keine Treffer — „Benutzerdefiniert“ für eine E-Mail wählen.',
      customAssignee: 'Benutzerdefiniert (E-Mail)…',
      customAssigneePlaceholder: "name{'@'}example.com",
      loading: 'DevOps-Daten werden geladen…',
      submit: 'Task erstellen',
      promoted: 'Mit DevOps-Task #{id} verknüpft.',
      notConfigured: 'Kein Azure-DevOps-PAT hinterlegt — bitte zuerst im Azure-Board konfigurieren.',
      syncing: 'DevOps-Status wird geprüft…',
      syncedCount: '{count} aus DevOps aktualisiert',
      openBoard: 'Board öffnen',
      import: {
        button: 'Aus DevOps importieren',
        title: 'Aus Azure DevOps importieren',
        subtitle: 'Dir zugewiesene Tasks & PBIs, für die es noch keinen Report gibt.',
        loading: 'Deine DevOps-Arbeitselemente werden geladen…',
        empty: 'Nichts zu importieren — für alle dir zugewiesenen Elemente gibt es bereits einen Report.',
        selectAll: 'Alle auswählen',
        allStates: 'Alle',
        importSelected: 'Auswahl importieren ({count})',
        importing: 'Importiere…',
        done: '{count} importiert',
        assigneeLabel: 'DevOps-Benutzer',
        assigneeMe: 'Ich (Standard)',
        assignToLabel: 'Zuweisen an',
        assignNone: 'nicht zuweisen',
        load: 'Laden',
        withDetails: 'Mit Kommentaren & Anhängen',
        withDetailsHint: 'Kopiert zusätzlich den DevOps-Kommentarverlauf und die Datei-Anhänge in jeden importierten Report.',
        loadingDetail: 'Arbeitselement wird geladen…',
        noParent: 'Kein übergeordnetes Element — oberste Ebene.',
        childItems: 'untergeordnete Elemente',
        noComments: 'Keine Kommentare.',
      },
      pending: {
        title: 'Neu in Azure DevOps:',
        comment: 'Kommentar',
        comments: 'Kommentare',
        attachment: 'Anhang',
        attachments: 'Anhänge',
        fetch: 'Jetzt abrufen',
        fetching: 'Wird abgerufen…',
        fetched: 'Aus Azure DevOps abgerufen.',
      },
      connect: {
        intro: 'Um Tickets zu erstellen und zu verlinken, verbinde einmalig dein Azure DevOps mit einem persönlichen Zugriffstoken (PAT). Der Token bleibt ausschließlich in deinem Browser.',
        step1: 'Token-Seite öffnen und',
        newToken: 'New Token',
        step1b: 'anklicken.',
        step2: 'Bei „Expiration“ Custom defined wählen und ca. 1 Jahr in die Zukunft setzen.',
        step3: 'Bei „Scopes“ mindestens Work Items → Read & write auswählen.',
        step4: 'Token kopieren und hier einfügen.',
        patLabel: 'Personal Access Token',
        patPlaceholder: 'Token mit Work Items: Read & write',
        submit: 'Verbinden',
        connecting: 'Verbinde…',
      },
    },
  },
  mewsFinance: {
    event: 'Event',
    chargeProducts: 'Produkte belasten',
    chargeDescription: 'Belastet wird je Reiter: Dort werden zuerst die Zeilen und Hinweise angezeigt, gebucht wird erst nach der Bestätigung.',
    chargeFnb: 'F&B belasten…',
    chargeEquipment: 'Ausstattung belasten…',
    internalEvent: 'Interne Veranstaltungen werden nicht an MEWS belastet.',
    noProductsRight: 'Keine Berechtigung, Produkte dieser Veranstaltung zu belasten.',
    nothingPending: 'In diesem Reiter gibt es keine offenen Zeilen.',
    skipped: 'Übersprungen',
    chargeErrors: 'Fehler',
  },
  propertyRules: {
    streamFilterHint: 'Nach Stream filtern',
    category: 'Kategorie',
    charging: 'Abrechnung',
    price: 'Preis',
    ruleEditorDiscardBody: 'Nicht gespeicherte Produkt- und Trigger-Änderungen gehen verloren.',
    countLabel: 'Regeln',
    title: 'Produkt Regeln & Preise',
    productsSelected: 'Produkte ausgewählt',
    packageValue: 'Wert',
    packageValueHint: 'Summe der Basispreise aller Produkte dieser Regel',
    noProducts: 'Keine Produkte',
    unpricedHint: 'ohne Preis — Summe unvollständig',
    mixedCurrencyHint: 'Produkte in unterschiedlichen Währungen — nicht summierbar',
    lecturer: 'Dozent',
    lecturerOnly: 'Nur Dozent',
    lecturerNone: 'Kein Dozent',
    triggerMode: 'Auslöser',
    pricingMode: 'Preise',
    howItChargesTitle: 'Wie wird abgerechnet?',
    howItChargesBody: 'Trigger werden nur am Anreise- bzw. Abreisetag berücksichtigt. An allen Tagen dazwischen werden automatisch alle Produkte dieser Regel berechnet.',
    priceList: 'Preisliste',
    newPriceList: 'Neue Liste',
    priceListName: 'Name der Preisliste',
    cloneFrom: 'Preise übernehmen aus',
    startEmpty: 'Leer starten',
    addProduct: 'Produkt hinzufügen',
    ruleEditorDiscard: 'Ungespeicherte Änderungen verwerfen?',
    ruleEditorSaveFailed: 'Speichern fehlgeschlagen',
    product: 'Produkt',
    defaultPrice: 'Standardpreis',
    priceAndOverrides: 'Preis & Overrides',
    timeOverride: 'Aktive Preisliste',
    timeOverrideHint: 'Der angezeigte Preis kommt aktuell aus dieser Preisliste (gültig ab {date}).',
    rateOverrideHint: 'Ratenspezifischer Override aus „{list}“, gültig ab {date}.',
    total: 'Summe',
    emptyTitle: 'Noch keine Produkte',
    emptyDesc: 'Füge Produkte hinzu, um Auslöser und Preisgruppen zu konfigurieren.',
    searchProducts: 'Produkte suchen...',
    noProductsAvailable: 'Keine weiteren Produkte verfügbar',
    mockNotice: 'Hinweis:',
    mockNoticeDesc: 'Daten werden aktuell nur temporär gespeichert (kein Backend).',
    rule: 'Regel',
    newRule: 'Neue Regel',
    renameRule: 'Umbenennen',
    deleteRule: 'Löschen',
    createRule: 'Erstellen',
    ruleName: 'Regelname',
    ruleNamePlaceholder: 'z.B. Standard-Rate, Sommer-Special...',
    noRules: '— Keine Regeln —',
    noRulesTitle: 'Noch keine Regeln',
    noRulesDesc: 'Erstelle eine neue Regel, um loszulegen.',
    noRulesFound: 'Keine passenden Regeln',
    searchRules: 'Regeln suchen...',
    allStreams: 'Alle Streams',
    allStatus: 'Alle Status',
    stream: 'Stream',
    rate: 'Rate',
    allRates: 'Alle Raten',
    products: 'Produkte',
    priceLists: 'Preislisten',
    deleteRuleConfirm: 'Regel „{name}" wirklich löschen? Alle zugehörigen Produkt-Konfigurationen und Preise gehen verloren.',
    monitor: 'Monitor',
    monitorTitle: 'Regel-Monitor',
    monitorSubtitle: 'Eingang vs. Ausgang — was an MEWS gesendet wurde',
    // Charges-log: property-wide list of recent event_products charges
    // created by rule triggers (source='rule'). One row = one charge.
    chargesLog: 'Charges-Log',
    chargesLogTitle: 'Charges-Log',
    chargesLogSubtitle: 'Letzte berechnete Produkte aus Regel-Auslösern (alle Regeln)',
    chargesLogEmpty: 'Noch keine Regel-Berechnungen.',
    chargesLogLimitHint: 'Letzte 500 Einträge',
    chargesLogSearchPlaceholder: 'Event, Produkt oder Regel...',
    chargedAt: 'Zeitpunkt',
    chargeTo: 'Empfänger',
    participantsShort: 'Tn',
    kpiTotal: 'Gesamt',
    kpiCharges: 'Berechnungen',
    kpiRules: 'Regeln',
    kpiEvents: 'Events',
    from: 'Von',
    to: 'Bis',
    exportCsv: 'CSV exportieren',
    input: 'Eingang',
    outputMews: 'Ausgang (an MEWS)',
    productLines: 'Produktzeilen',
    event: 'Event',
    arrival: 'Anreise',
    departure: 'Abreise',
    rateGroup: 'Rate',
    processedAt: 'Verarbeitet',
    totalEntries: 'Einträge gesamt',
    statusPending: 'Ausstehend',
    statusProcessed: 'Verarbeitet',
    statusFailed: 'Fehlgeschlagen',
    filterAll: 'Alle',
    noEntries: 'Keine Einträge vorhanden.',
    errorFromMews: 'MEWS-Fehler',
    awaitingProcessing: 'Wartet auf Verarbeitung...',
    noProductLines: 'Keine Produktzeilen.',
    vormittag: 'Vormittag',
    nachmittag: 'Nachmittag',
    triggeredByPackage: 'Ausgelöst durch Paket',
    standaloneProducts: 'Einzelne Produkte',
    triggers: {
      anreiseVormittag: 'Anreise vormittag',
      anreiseNachmittag: 'Anreise nachmittag',
      abreiseVormittag: 'Abreise vormittag',
      abreiseNachmittag: 'Abreise nachmittag',
      tagesgast: 'Tagesgast',
      uebernachtung: 'Übernachtung',
    },
    groups: {
      mitglied: 'Mitglied',
      nichtMitglied: 'Nicht Mitglied',
      studentBest: 'Student BEST',
      studentVodafoneEdeka: 'Student Vodafone/Edeka',
      tagesgast: 'Tagesgast',
      tagesgastBest: 'Tagesgast BEST',
      tagesgastVodafone: 'Tagesgast Vodafone',
    },
  },
  maya: {
    title: 'Maya',
    subtitle: 'KI-Assistentin',
    greeting: 'Hallo! Ich bin Maya, deine EventHub-Assistentin. Wie kann ich dir heute helfen?',
    placeholder: 'Frag Maya alles über deine Events...',
    send: 'Senden',
    close: 'Schließen',
    clear: 'Chat leeren',
    thinking: 'Maya denkt nach...',
    suggestions: {
      findEvent: 'Event finden',
      upcomingEvents: 'Kommende Events anzeigen',
      eventRequirements: 'Event-Anforderungen prüfen',
      availableSpaces: 'Verfügbare Räume',
    },
    errors: {
      generic: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',
      noResults: 'Keine Ergebnisse für deine Anfrage gefunden.',
    },
  },
  eventHealth: {
    title: 'Systemprüfung',
    menuHint: 'Veranstaltung gegen MEWS & verknüpfte Daten prüfen',
    introTitle: 'Systemprüfung starten?',
    introBody: 'Prüft Zimmerblöcke, Reservierungen und Abrechnung dieser Veranstaltung gegen MEWS. Die Prüfung ist schreibgeschützt und kann einige Sekunden dauern.',
    start: 'Prüfung starten',
    checking: 'Prüfe Blöcke, Reservierungen und Abrechnung…',
    allGood: 'Alles in Ordnung',
    degraded: 'Kleinere Abweichungen',
    unhealthy: 'Es stimmt etwas nicht',
    notFound: 'Veranstaltung nicht gefunden',
    unknown: 'Unbekannt',
    errors: 'Fehler',
    warnings: 'Hinweise',
    nothingFlagged: 'Nichts beanstandet.',
    checkedAt: 'Geprüft',
    checkedItems: 'geprüft',
    findings: 'Befunde',
    recheck: 'Erneut prüfen',
    healing: 'Repariere…',
    healRan: 'Reparatur ausgeführt',
    noMewsSide: 'kein MEWS-Abgleich',
    mewsNotConfirmed: 'MEWS offen',
    amountsChecked: 'Beträge geprüft',
    amountsUnknown: 'ohne Vergleichswert',
    mewsUnreachable: 'Teile der Prüfung konnten MEWS nicht erreichen. Das bedeutet nicht, dass etwas falsch ist — diese Punkte wurden nur nicht geprüft.',
    sectionBlocks: 'Zimmerblöcke',
    sectionReservations: 'Reservierungen',
    sectionSpaces: 'Raumbuchungen',
    sectionCharges: 'Produktabrechnung',
  },
  taskModal: {
    onlyAssigneeCloses: 'Nur die zugewiesene Person kann diese Aufgabe abschließen.',
    title: 'Meine Aufgaben',
    openCount: '{n} offen',
    overdueSuffix: '{n} überfällig',
    newTask: 'Neue Aufgabe',
    viewActive: 'Offen',
    viewClosed: 'Erledigt',
    viewSent: 'Gesendet',
    viewSentOpen: 'Gesendet offen',
    viewHistory: 'Verlauf',
    formTitlePlaceholder: 'Titel der Aufgabe…',
    formDescriptionPlaceholder: 'Beschreibung (optional)…',
    assignedTo: 'Zugewiesen an',
    nobody: '— Niemand —',
    userSearchPlaceholder: 'Name oder E-Mail suchen…',
    event: 'Veranstaltung',
    eventSearchPlaceholder: 'Suchen…',
    eventNone: '— Ohne —',
    noMatches: 'Keine Treffer',
    priority: 'Priorität',
    due: 'Fällig',
    creating: 'Erstelle…',
    createTask: 'Aufgabe erstellen',
    emptyActive: 'Keine offenen Aufgaben.',
    emptySent: 'Keine gesendeten Aufgaben.',
    emptySentOpen: 'Keine offenen gesendeten Aufgaben.',
    emptyClosed: 'Keine erledigten Aufgaben.',
    emptyHistory: 'Kein Verlauf.',
    noDueDate: 'ohne Fälligkeit',
    assignedByShort: 'von',
    createdBy: 'Erstellt von',
    createdBySelf: 'mir',
    sectionSentOpen: 'Offen',
    sectionSentClosed: 'Erledigt',
    overdue: 'überfällig',
    markDone: 'Als erledigt markieren',
    reopen: 'Wieder öffnen',
    fallbackTitle: 'Aufgabe',
    noDescription: 'Keine Beschreibung.',
    hintActive: 'Klick auf eine Aufgabe erledigt sie.',
    hintSent: 'Aufgaben, die du für andere erstellt hast.',
    hintClosed: 'Erledigte Aufgaben — „Wieder öffnen“ holt sie zurück.',
    confirmCompleteTitle: 'Aufgabe als erledigt markieren?',
    confirmCompleteBody: '„{title}“ wird geschlossen und verschwindet aus deinen offenen Aufgaben.',
    confirmCompleteCta: 'Erledigt',
    kpiOpen: 'Offen',
    kpiOverdue: 'Überfällig',
    kpiToday: 'Heute',
    kpiWeek: 'Diese Woche',
    kpiNoDue: 'Ohne Termin',
    prioUrgent: 'Dringend',
    prioHigh: 'Hoch',
    prioMedium: 'Mittel',
    prioLow: 'Niedrig',
    statusOpen: 'Offen',
    statusInProgress: 'In Arbeit',
    statusDone: 'Erledigt',
    statusCancelled: 'Storniert',
  },
  accessDenied: {
    title: 'Keine Berechtigung',
    body: 'Deine Rolle darf hier nicht {action}.',
    bodyWithSubject: '„{subject}“ darf deine Rolle nicht {action}.',
    action: {
      read: 'lesen',
      create: 'anlegen',
      edit: 'bearbeiten',
      delete: 'löschen',
    },
    neededLabel: 'Benötigte Berechtigung',
    askAdmin: 'Ein Administrator kann das unter Administration ▸ Rollen & Rechte freischalten.',
    technicalDetails: 'Technische Details',
  },
  mewsNotes: {
    title: 'Notiz in MEWS',
    hint: 'Zeigt die Notizen, die in MEWS an der Reservierung hängen — das Feld oben ist die interne Notiz von EventHub und wird nicht übertragen.',
    show: 'Anzeigen',
    reload: 'Neu laden',
    resync: 'Nach MEWS senden',
    syncing: 'Sende…',
    inSync: 'aktuell',
    outOfSync: 'abweichend',
    snapshot: 'Würde gesendet',
    inMews: 'In MEWS',
    current: 'aktuell',
    none: 'MEWS hat zu dieser Reservierung keine Notiz.',
    readFailed: 'MEWS konnte nicht gelesen werden:',
    notFound: 'Zu dieser Reservierung liegen keine Notizdaten vor.',
    resyncResult: '{pushed} gesendet · {unchanged} unverändert · {failed} fehlgeschlagen',
  },
}
